/* Little Premiere — tunnel de création. JS sans dépendance, pensé mobile d'abord.
   Données : catalogue et sessions côté Worker ; prix côté Shopify (variantes, par SKU).
   La photo est ré-encodée sur l'appareil (canvas → JPEG, sans EXIF ni GPS) puis envoyée au Worker, jamais à Shopify. */
(function () {
  'use strict';
  var rootEl = document.getElementById('lp-root');
  var app = document.getElementById('lp-app');
  // 30/10 : dans l'éditeur de thème, la section re-rendue peut ramener ce fichier une 2e fois ; une seule app par page.
  if (!rootEl || !app || window.__lpFunnel) return;
  window.__lpFunnel = 1;
  var DESIGN = !!(window.Shopify && window.Shopify.designMode);
  // 02/11 (Paul : « ouvre-moi chaque étape du funnel sur Shopify, où je peux modifier les le saviez-vous… le paywall ») :
  // dans l'éditeur de thème, le tunnel tourne en DÉMO. Aucune session créée, rien d'écrit (journal, Klaviyo, pixels,
  // localStorage, checkout) ; un enfant d'exemple (Leo, 5 ans) et ?lp_step=<écran> ouvrent directement l'écran voulu.
  // Avant : ouvrir l'éditeur créait une vraie session dans le journal du tunnel, et l'aperçu et l'offre restaient
  // inaccessibles sans vraie photo.
  var DEMO = DESIGN;

  var CFG = JSON.parse(document.getElementById('lp-config').textContent || '{}');
  var API = String(CFG.api || '').replace(/\/$/, '');
  var ROOT = CFG.root && CFG.root !== '/' ? String(CFG.root).replace(/\/?$/, '/') : '/';
  var LS_KEY = 'lp_state_v1';
  var RESUME_MS = 7 * 86400000;
  var params = new URLSearchParams(location.search);
  // 24/10 : réglés dans l'éditeur de thème (section « LP — Create funnel ») : l'opération promo et son chrono, le compte
  // Klaviyo, et le dossier des images du thème (cadeaux de l'offre).
  var PROMO = CFG.promo || {};
  var KL = CFG.klaviyo || {};
  var ASSETS = String(CFG.assets || '');

  var CAT = null;          // catalogue public
  var S = null;            // état du parcours (localStorage, jamais la photo)
  var pollTimer = null;
  var progressTimer = null;

  // 23/10 ~10 h (Paul : « une bande en haut, sous le logo, étape 1 sur 6 », « que la personne n'ait pas à scroller, et
  // qu'à chaque fois il y ait le bouton suivant en bas », « des flèches en haut pour revenir en arrière ») : l'en-tête et
  // la barre basse de StarringYou (ses captures 10 et 13). Créés ici, une fois, hors de #lp-app. Chaque écran garde son
  // bouton principal et ses gestionnaires : le bouton est seulement déplacé dans la barre basse, avec l'erreur de l'écran.
  // 23/10 ~14 h (Paul : « ne pas pouvoir revenir en arrière pousse les utilisateurs à aller jusqu'au bout »), précisé à
  // ~14 h 50 (« remet la possibilité de revenir en arrière à part à la fin sur les 2 dernières étapes ») : flèche Back aux
  // étapes 2 à 4, jamais aux étapes 5 et 6 ; à ~16 h 45, sur sa capture de l'aperçu (« l'étape où tu ne peux plus revenir
  // en arrière, ça doit être celle-ci, pas celle d'avant ») : flèche aux étapes 2 à 5, jamais à l'étape 6 (aperçu, offre).
  // Le geste retour du téléphone, lui, marche partout : le bloquer ferait sortir du site au geste suivant. Bandeau du haut = l'offre en cours (« le FOMO
  // doit être présent tout au long, même dans le header, avec Early Black Friday »), rempli au démarrage depuis le catalogue.
  var topEl = document.createElement('header');
  topEl.className = 'lp-top';
  topEl.innerHTML = '<p class="lp-top-fomo" id="lp-fomo" hidden></p>' +
    '<div class="lp-top-in"><button type="button" class="lp-top-back" id="lp-topback" hidden><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>Back</button>' +
    '<span class="lp-top-logo"><span aria-hidden="true">✦</span>Little Premiere</span><span class="lp-top-step" id="lp-topstep"></span></div>' +
    '<div class="lp-top-bar" aria-hidden="true"><i id="lp-topbar"></i></div>';
  rootEl.insertBefore(topEl, rootEl.firstChild);
  app.classList.add('lp-app');
  var dockEl = document.createElement('div');
  dockEl.className = 'lp-dock';
  dockEl.hidden = true;
  rootEl.appendChild(dockEl);
  document.body.classList.add('lp-funnel');

  // 6 étapes affichées, comme le concurrent : l'occasion et le message font l'étape 5 ; l'aperçu et l'offre, l'étape 6
  // (« rien à payer avant la dernière étape » reste vrai). Le journal serveur garde ses numéros (STEP_INDEX).
  var SCREEN_STEP = { pick: 2, hero: 1, adventure: 2, costume: 2, photo: 3, loves: 4, message: 5, details: 5, preview: 6, offer: 6, interstitial: 6 };
  var SCREENS = 6;
  // Où mène la flèche quand l'écran n'a pas son propre retour (#lp-back, caché : la flèche du haut le déclenche).
  var BACKS = { adventure: 'hero', loves: 'photo', message: 'loves', details: 'loves' };
  var LAST_BACK = 5;
  var PRIMARY = ['#lp-next', '#lp-make', '#lp-pick', '#lp-cont'];
  function setTop(stepName) {
    var n = SCREEN_STEP[stepName] || 0;
    document.getElementById('lp-topstep').textContent = n ? fill(tx('head_step', 'Step {n} of {total}'), { n: n, total: SCREENS }) : '';
    // En-tête (bloc « All · Header & bottom bar ») : relu à chaque écran, l'éditeur montre la frappe.
    var tb = document.getElementById('lp-topback'), lg = topEl.querySelector('.lp-top-logo');
    tb.lastChild.nodeValue = tx('head_back', 'Back');
    lg.lastChild.nodeValue = tx('head_logo', 'Little Premiere');
    if (DESIGN) topEl.setAttribute('data-ed', 'z_head');
    // Barre rapide puis lente, déjà entamée : une barre constante ne réduit pas les abandons, une rapide-puis-lente si
    // (Villar, Callegaro & Yang 2013, 32 expériences) ; une carte déjà entamée est plus souvent finie (Nunes & Drèze 2006).
    document.getElementById('lp-topbar').style.width = n ? Math.round(100 * Math.pow((n + 1) / (SCREENS + 1), 0.7)) + '%' : '0%';
    paintFomo();
  }
  // L'offre saison du bras (plusieurs épisodes) : c'est elle que portent la promo, le bandeau et le chrono.
  function fomoOffer() {
    if (!CAT) return null;
    var arm = S ? armDef() : CAT.experiments.offer.arms[0];
    var ids = (arm && arm.offers) || [];
    for (var i = 0; i < ids.length; i++) { var o = CAT.offers[ids[i]]; if (o && o.kind === 'series' && o.films > 1) return o; }
    return null;
  }
  function paintFomo() {
    var el = document.getElementById('lp-fomo');
    var o = fomoOffer();
    var name = promoName();
    el.hidden = !name;
    // 24/10 (Paul, « encore une fois ») : le bandeau garde l'offre, sans chrono. Le chrono vit sur l'offre (étape 6).
    if (name) el.innerHTML = '<span aria-hidden="true">⚡</span><b>' + esc(name) + ':</b> ' + fillE(tx('head_fomo', '{deal}'), { deal: o.headline });
  }
  // 23/10 ~17 h 30 (Paul : « un chrono sur l'offre Black Friday, se termine dans…, tous les jours à minuit ») : compte à
  // rebours jusqu'au minuit du visiteur, pas du serveur (4 fuseaux aux États-Unis : un minuit de New York tomberait à
  // 21 h en Californie). Un seul minuteur pour tous les .lp-cd de la page.
  // 24/10 (Paul : « chrono urgence que je vais régler moi-même pour les différentes opérations promotionnelles ») : nom de
  // l'opération et dernier jour se règlent dans l'éditeur de thème (LP — Create funnel › Promo countdown), sans code.
  // Dernier jour vide : le chrono repart chaque nuit à minuit. Dernier jour passé : le chrono disparaît (jamais un
  // « 00:00:00 » figé). Le prix reste celui de la remise automatique Shopify : l'arrêter se fait dans Shopify.
  function promoName() {
    var o = fomoOffer();
    return PROMO.on === false || !o ? '' : String(PROMO.name || o.badge || '').trim();
  }
  // 24/10 ~12 h 20 (Paul : « un chrono qui repart toutes les 48 h ») : sans dernier jour réglé, la promo dure deux jours :
  // le jour pair du visiteur, elle finit « tomorrow at midnight » ; le jour impair, « tonight at midnight ». Même échéance
  // à chaque visite du même jour (jamais un chrono qui recule quand on recharge).
  function promoEnd() {
    var m = /^\s*(\d{4})-(\d{1,2})-(\d{1,2})\s*$/.exec(PROMO.end || '');
    var d = m ? new Date(+m[1], +m[2] - 1, +m[3]) : new Date();
    if (!m && Math.floor((d.getTime() - d.getTimezoneOffset() * 60000) / 86400000) % 2 === 0) d.setDate(d.getDate() + 1);
    d.setHours(24, 0, 0, 0);
    return d;
  }
  function promoLeft() { return promoName() ? Math.max(0, Math.floor((promoEnd() - new Date()) / 1000)) : 0; }
  function promoWhen() {
    var tonight = new Date();
    tonight.setHours(24, 0, 0, 0);
    var e = promoEnd(), days = Math.round((e - tonight) / 86400000);
    return days <= 0 ? 'tonight at midnight' : days === 1 ? 'tomorrow at midnight'
      : new Date(e - 1).toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' }) + ' at midnight';
  }
  function cdText(s) {
    var p2 = function (x) { return (x < 10 ? '0' : '') + x; };
    var d = Math.floor(s / 86400);
    return (d ? d + 'd ' : '') + p2(Math.floor(s / 3600) % 24) + ':' + p2(Math.floor(s / 60) % 60) + ':' + p2(s % 60);
  }
  var cdTimer = null;
  function tickCountdowns() {
    var s = promoLeft();
    document.querySelectorAll('.lp-cd').forEach(function (el) { el.textContent = cdText(s); });
    document.querySelectorAll('[data-cdbox]').forEach(function (el) { el.hidden = !s; });
  }
  function startCountdowns() {
    tickCountdowns();
    if (!cdTimer) cdTimer = setInterval(tickCountdowns, 1000);
  }
  function syncNav() {
    var resume = !!app.querySelector('.lp-resume');
    var own = app.querySelector('#lp-back');
    var n = S && SCREEN_STEP[S.step];
    document.getElementById('lp-topback').hidden = resume || !n || n > LAST_BACK || !(own || BACKS[S.step]);
    if (resume) setTop('');
    dockEl.innerHTML = '';
    var btn = null;
    for (var i = 0; i < PRIMARY.length && !btn; i++) btn = app.querySelector(PRIMARY[i]);
    if (!btn || (S && (S.step === 'offer' || S.step === 'interstitial') && !resume)) { dockEl.hidden = true; rootEl.classList.remove('has-dock'); return; }
    if (btn.type === 'submit' && btn.form) btn.setAttribute('form', btn.form.id);
    var inner = document.createElement('div');
    inner.className = 'lp-dock-in';
    var err = app.querySelector('#lp-err');
    if (err) inner.appendChild(err);
    var status = btn.id === 'lp-pick' && app.querySelector('#lp-status');
    if (status) inner.appendChild(status);
    inner.appendChild(btn);
    var note = document.createElement('p');
    note.className = 'lp-dock-note';
    note.textContent = fill(S && S.step === 'photo' ? tx('head_note_photo', '🔒 Private: never public, never used to train AI, deleted automatically.') : tx('head_note', '✓ Free preview first · pay only if you love it'));
    if (DESIGN) note.setAttribute('data-ed', 'z_head');
    inner.appendChild(note);
    dockEl.appendChild(inner);
    dockEl.hidden = false;
    rootEl.classList.add('has-dock');
  }
  new MutationObserver(syncNav).observe(app, { childList: true });
  document.getElementById('lp-topback').onclick = function () {
    if (!S || (SCREEN_STEP[S.step] || 0) > LAST_BACK) return;
    var own = document.getElementById('lp-back');
    if (own && app.contains(own)) return own.click();
    if (BACKS[S.step]) go(BACKS[S.step]);
  };
  // Le geste « retour » du téléphone revient à l'écran précédent. Avant le 23/10, il quittait le tunnel pour la page
  // d'avant (aucune entrée d'historique par écran). Un écran = une entrée, à la même adresse.
  var fromHistory = false;
  // Retour arrière depuis le checkout : Safari et Chrome rendent la page gelée (bfcache), bouton « Opening secure
  // checkout… » encore désactivé. On redessine l'écran.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && S && S.sid && (S.step === 'offer' || S.step === 'interstitial')) render();
  });
  window.addEventListener('popstate', function (e) {
    var st = e.state && e.state.lpStep;
    if (!st || !S || !S.sid) return;
    fromHistory = true;
    try { go(st); } finally { fromHistory = false; }
  });

  // ------------------------------------------------------------ outils
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // Garçon / fille demandé à l'étape 1 depuis le 23/10 (Paul : « ressembler vraiment au concurrent ») : les textes passent
  // en « his / her ». Sans réponse (reprise d'un parcours plus ancien), pronoms neutres comme avant.
  var PRONS = { boy: { they: 'he', them: 'him', their: 'his', themself: 'himself' }, girl: { they: 'she', them: 'her', their: 'her', themself: 'herself' } };
  var NEUTRAL = { they: 'they', them: 'them', their: 'their', themself: 'themself' };
  function pron() { return (S && S.hero && PRONS[S.hero.gender]) || NEUTRAL; }
  function cap(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }
  // 24/10 (captures de Paul : « paul and the Baby Dinosaur ») : un prénom tapé tout en minuscules (ou tout en capitales)
  // s'écrit « Paul », « Mary-Jane ». Une casse voulue (« McKenzie », « DeShawn ») est gardée telle quelle.
  function nameCase(n) {
    n = String(n || '');
    if (n !== n.toLowerCase() && n !== n.toUpperCase()) return n;
    return n.toLowerCase().replace(/(^|[\s'’.-])(\S)/g, function (m, a, b) { return a + b.toUpperCase(); });
  }
  function vars(extra) {
    var name = (S && S.hero && S.hero.name && nameCase(S.hero.name)) || 'your child';
    var P = pron();
    var v = {
      name: name, Name: cap(name), age: (S && S.hero && S.hero.age) || '',
      they: P.they, them: P.them, their: P.their, themself: P.themself, They: cap(P.they), Their: cap(P.their), Them: cap(P.them),
      from: (S && S.details && S.details.from) || '',
      delivery_hours: CAT ? CAT.settings.delivery_hours : 24
    };
    for (var k in (extra || {})) v[k] = extra[k];
    return v;
  }
  function fill(t, extra) {
    var v = vars(extra);
    return realText(String(t == null ? '' : t)).replace(/\{(\w+)\}/g, function (m, k) { return v[k] !== undefined && v[k] !== '' ? v[k] : m; });
  }
  function fillE(t, extra) { return esc(fill(t, extra)); }
  // Noël (30/10) : film en prise de vue réelle. Les phrases « 3D » restent pour les films 3D (Dino, Halloween : rien ne
  // change pour eux) ; pour une aventure réelle, la version de T_process_noel/agents/04_page_produit.txt §4f.
  var REAL_FILMS = { christmas: true };
  var REAL_SWAPS = [
    ['turn {name} into a 3D hero.', 'make {name} the hero.'], ['into a 3D ', 'into a '],
    ['{Name}\'s 3D hero is on its way.', '{Name}\'s hero is on its way.'],
    ['{name} as a 3D animated hero', '{name} as the hero of the movie'], ['{Name} as a 3D animated hero', '{Name} as the hero of the movie'],
    ['Sketching {name}\'s face in 3D', 'Matching {name}\'s face, feature by feature'],
    ['{Name}\'s 3D hero is ready!', '{Name}\'s hero is ready!'], ['{Name}\'s 3D hero · 1 to 2 minutes', '{Name}\'s hero · 1 to 2 minutes'],
    ['Shaping {name}\'s face, hair and smile in 3D', 'Shaping {name}\'s face, hair and smile for the movie'],
    ['This photo didn\'t work for our 3D studio.', 'This photo didn\'t work for our studio.'],
    ['That\'s why you saw {their} 3D hero for free', 'That\'s why you saw {their} hero for free'],
    ['{Name}\'s own movie, starring the 3D hero you just met.', '{Name}\'s own movie, starring the hero you just met.'],
    ['The movie is made from the 3D hero you just saw.', 'The movie is made from the {name} you just saw.'],
    ['in every scene, in 3D', 'in every scene, just like in real life'],
    ['Each episode is a 3-minute 3D animated movie where', 'Each episode is a 2-3 minute movie that looks like real life, where'],
    ['More than a cartoon: an adventure where', 'More than a movie: an adventure where'],
    ['own animated adventure,', 'own movie that looks like real life,']
  ];
  function realText(t) {
    if (!(typeof S === 'object' && S && typeof REAL_FILMS === 'object' && REAL_FILMS[S.adventure])) return t;
    for (var i = 0; i < REAL_SWAPS.length; i++) t = t.split(REAL_SWAPS[i][0]).join(REAL_SWAPS[i][1]);
    return t;
  }

  // Ce que le parent regarde pendant que l'aperçu se fabrique, puis sur l'aperçu : une playlist muette (extraits,
  // motion design, réactions mises en scène), une vidéo par ligne, « URL | légende » possible ; « URL | » = sans
  // légende. Jamais une image fixe violette (Paul, 19/10). Chaque écran commence par la vidéo suivante.
  // 23/10 ~14 h : la playlist est le montage muet de réactions d'enfants (Paul) ; plus de bouton son.
  var sceneTurn = 0;
  function waitList() {
    var m = CFG.wait_videos || {};
    var raw = (S && S.adventure && m[S.adventure]) || CFG.wait_video || '';
    return String(raw).split(/\n+/).map(function (line) {
      var i = line.indexOf('|');
      return { u: (i < 0 ? line : line.slice(0, i)).trim(), c: i < 0 ? null : line.slice(i + 1).trim() };
    }).filter(function (x) { return /^https:\/\//.test(x.u); });
  }
  // note : petite ligne sous la vidéo (les réactions sont des scènes faites au studio IA : on le dit, comme sur les pages).
  function sceneHtml(cls, caption, note) {
    var list = waitList();
    if (!list.length) return '';
    var i = sceneTurn++ % list.length;
    var cap = list[i].c !== null ? list[i].c : caption || '';
    return '<figure class="lp-scene ' + (cls || '') + '"><video src="' + esc(list[i].u) + '" muted autoplay playsinline preload="auto" aria-hidden="true"' +
      (list.length > 1 ? ' data-lp-list="' + esc(JSON.stringify(list)) + '" data-i="' + i + '" data-cap="' + esc(caption || '') + '"' : ' loop') + '></video>' +
      '<figcaption' + (cap ? '' : ' hidden') + '>' + esc(cap) + '</figcaption></figure>' + (note ? '<p class="lp-scene-note">' + esc(note) + '</p>' : '');
  }
  function playScene(v) {
    v.muted = true;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  // Une vidéo finie laisse la place à la suivante de sa playlist (« ended » ne remonte pas : écoute en capture).
  document.addEventListener('ended', function (e) {
    var v = e.target;
    if (!v || !v.getAttribute || !v.getAttribute('data-lp-list')) return;
    var list = JSON.parse(v.getAttribute('data-lp-list'));
    var i = (Number(v.getAttribute('data-i')) + 1) % list.length;
    v.setAttribute('data-i', i);
    v.src = list[i].u;
    var fc = v.parentNode && v.parentNode.querySelector('figcaption');
    var cap = list[i].c !== null ? list[i].c : v.getAttribute('data-cap') || '';
    if (fc) { fc.textContent = cap; fc.hidden = !cap; }
    playScene(v);
  }, true);

  // Costume au choix (Halloween : Superhero, Princess, Witch, Ghost, Vampire). Nommé dans les textes seulement s'il a
  // été choisi sur cet appareil : après une reprise par email, l'image de l'aperçu fait foi.
  function costumesOf(a) { return a && a.costumes && a.costumes.length ? a.costumes : null; }
  function costumeOf(a, id) {
    var list = costumesOf(a) || [];
    for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i];
    for (var j = 0; j < list.length; j++) if (list[j].id === a.default_costume) return list[j];
    return list[0] || null;
  }
  function costume() { var a = adventure(); return costumesOf(a) && S.costume ? costumeOf(a, S.costume) : null; }
  function asCostume() { var c = costume(); return c ? ' as a ' + c.label.toLowerCase() : ''; }

  // ------------------------------------------------------------ avis
  // Avis Trustpilot de Little Premiere (Paul, 23/10 : premières familles, questionnaires réels ; texte source :
  // ~/Downloads/personalized_cartoon_review_concepts.docx, numéro d'origine = clé). Recopiés mot pour mot ; le titre en gras
  // est la première phrase de l'avis, jamais un texte ajouté. Ni nom, ni date, ni « achat vérifié », ni nombre d'avis
  // (Paul : « on ne met pas de nombre ») ; le rôle n'est écrit que quand l'avis le dit (« my grandson » → Grandparent).
  // Chaque écran du tunnel montre l'avis qui répond au doute de cet écran ; jamais à côté d'une réaction mise en scène.
  var REVIEWS = {
    r01: ['My son couldn’t believe he was the main character.', 'He watched the whole thing with the biggest smile on his face.', 'Parent'],
    r02: ['We’ve watched it three times already, and my daughter still gets excited every time she sees herself on screen.', '', 'Parent'],
    r03: ['I didn’t tell my grandson what the gift was.', 'Seeing his face when he realized the hero was him made the surprise worth it.', 'Grandparent'],
    r04: ['My daughter was completely absorbed in the story.', 'She kept pointing at the screen whenever she recognized herself.', 'Parent'],
    r07: ['My son loved recognizing his character throughout the adventure.', 'It made the whole experience feel much more personal.', 'Parent'],
    r08: ['This felt so much more thoughtful than buying another toy that might be forgotten in a few days.', '', ''],
    r09: ['My daughter is used to watching cartoons, but seeing herself become part of one made this completely different.', '', 'Parent'],
    r11: ['I wanted to give my grandson something more meaningful than another toy.', 'A story starring him felt like a lovely idea.', 'Grandparent'],
    r12: ['We were looking for a birthday gift that felt different, and a personalized cartoon was a really fun surprise.', '', ''],
    r14: ['The whole family enjoyed watching the adventure together.', 'It made the gift feel like an experience we could share.', ''],
    r16: ['I liked that the story was about being brave and facing challenges, rather than just watching another adventure.', '', ''],
    r17: ['The message about helping others was my favorite part.', 'It gave us something positive to talk about after watching.', ''],
    r19: ['I loved that my child got to be the hero while the story still focused on values we want to teach at home.', '', 'Parent']
  };
  var REVIEW_WALL = ['r01', 'r03', 'r04', 'r02', 'r11', 'r09', 'r17', 'r14', 'r08', 'r12', 'r19'];
  var TP_STARS = '<span class="lp-tp-stars" aria-label="5 out of 5 stars">' + new Array(6).join('<i><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 3.2 2.6 5.6 6 .7-4.5 4.1 1.2 6L12 16.6l-5.3 3 1.2-6-4.5-4.1 6-.7Z"/></svg></i>') + '</span>';
  var TP_LOGO = '<span class="lp-tp-logo"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 2.5 2.9 6.6 7.1.6-5.4 4.7 1.6 7L12 17.7l-6.2 3.7 1.6-7L2 9.7l7.1-.6Z"/></svg>Trustpilot</span>';
  // 02/11 (Paul : « laisse-moi la possibilité de modifier tout ce qui concerne la confiance, je vais le faire moi-même ») :
  // avis (blocs « Review » de la section), note, plateforme, badges et garantie se règlent dans l'éditeur de thème.
  // Réglage vide = le texte d'avant ; aucun bloc « Review » = le mur d'avant (REVIEWS / REVIEW_WALL).
  var TRUST = CFG.trust || {};
  // 03/11 : les réglages de confiance vivent dans le bloc « 6 · Offer — trust » ; champ vidé = rien, comme les autres blocs.
  function trustT(k, d) { var T = CFG.trust || TRUST; if (T[k] === undefined) return d.replace(/\{hours\}/g, CAT && CAT.settings ? CAT.settings.delivery_hours : '24'); var v = String(T[k] == null ? '' : T[k]).trim(); if (v === '-') return ''; return v.replace(/\{hours\}/g, CAT && CAT.settings ? CAT.settings.delivery_hours : '24'); }
  function tpName() { return trustT('platform', 'Trustpilot'); }
  // 02/11 (Paul : « quand on clique sur la note, ça redirige vers les avis Trustpilot ») : réglage « Rating link ».
  function tpLink(html) {
    // 03/11 ~16 h (Paul : « quand on clique sur le lien Trustpilot, il faut que ça redirige directement vers les avis ») :
    // champ « Rating link » vide = la page Trustpilot du domaine.
    var u = String((CFG.trust || TRUST).link || '').trim() || 'https://www.trustpilot.com/review/littlepremiere.com';
    return u ? '<a class="lp-tp-link" href="' + esc(u) + '" target="_blank" rel="noopener">' + html + '</a>' : html;
  }
  function guarantee() { return trustT('guarantee', 'Love it, or we remake it free'); }
  function starsHtml(n) {
    n = Math.max(1, Math.min(5, Math.round(Number(n) || 5)));
    if (n === 5) return TP_STARS;
    var i = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 3.2 2.6 5.6 6 .7-4.5 4.1 1.2 6L12 16.6l-5.3 3 1.2-6-4.5-4.1 6-.7Z"/></svg>';
    return '<span class="lp-tp-stars" aria-label="' + n + ' out of 5 stars">' + new Array(n + 1).join('<i>' + i + '</i>') + new Array(6 - n).join('<i style="background:#dcdce6">' + i + '</i>') + '</span>';
  }
  function reviewList() {
    var own = (CFG.reviews || []).filter(function (r) { return r && r.on !== false && String(r.title || '').trim(); });
    if (own.length) return own.map(function (r) { return [String(r.title).trim(), String(r.text || '').trim(), String(r.name || '').trim(), r.stars, r.id]; });
    return REVIEW_WALL.map(function (id) { return REVIEWS[id]; });
  }
  function reviewCard(r, cls) {
    if (typeof r === 'string') r = REVIEWS[r];
    if (!r) return '';
    return '<figure class="' + (cls || 'lp-rv') + '"' + (r[4] ? ed('b:' + r[4]) : '') + '>' + starsHtml(r[3]) + '<blockquote><b>' + esc(r[0]) + '</b>' + (r[1] ? ' ' + esc(r[1]) : '') + '</blockquote>' +
      '<figcaption>' + (r[2] ? esc(r[2]) + ' · ' : '') + esc(trustT('review_line', 'Review on ' + tpName())) + '</figcaption></figure>';
  }
  // 23/10 ~14 h (Paul, captures 26-37 : « pas de Trustpilot » sur chaque étape) : les avis ne restent qu'à l'offre.
  // Le bloc de l'offre, calqué sur celui de StarringYou (capture de Paul du 23/10) : livraison, 3 garanties, « Excellent ·
  // Trustpilot » sans nombre, puis les avis qui défilent seuls (le parent peut aussi les faire glisser).
  function trustWallHtml() {
    return '<section class="lp-tpwall" aria-label="' + esc('Reviews on ' + tpName()) + '"' + ed('z_off_trust') + '>' +
      // 03/11 ~16 h (Paul, capture 22 : « enlève l'élément ») : plus de ligne « Delivered by email within … hours » ici.
      '<ul class="lp-tp-badges">' +
        '<li><svg viewBox="0 0 24 24" class="is-green" aria-hidden="true"><rect x="5" y="10.5" width="14" height="10" rx="2"/><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5"/></svg>' + esc(trustT('badge_pay', 'Secure payment')) + '</li>' +
        '<li><svg viewBox="0 0 24 24" class="is-blue" aria-hidden="true"><path d="M12 3 4.5 6v5.5c0 4.6 3.2 8.2 7.5 9.5 4.3-1.3 7.5-4.9 7.5-9.5V6Z"/><path d="m8.8 12 2.2 2.2 4.2-4.4"/></svg>' + esc(guarantee()) + '</li>' +
        '<li><svg viewBox="0 0 24 24" class="is-orange" aria-hidden="true"><path d="M13 2.5 5 13.5h6l-1 8 8-11h-6Z"/></svg>' + esc(trustT('badge_fast', 'Delivered in {hours}h')) + '</li>' +
      '</ul>' +
      '<p class="lp-tp-head">' + tpLink(TP_STARS + '<b>' + esc(trustT('rating', 'Excellent')) + '</b> ' + esc(tx('off_rate_on', 'on')) + ' ' + TP_LOGO.replace('Trustpilot</span>', esc(tpName()) + '</span>')) + '</p>' +
      '<div class="lp-tp-track" data-lp-autoscroll tabindex="0">' + reviewList().map(function (r) { return reviewCard(r, 'lp-rv lp-rv-card'); }).join('') + '</div>' +
      '</section>';
  }
  // Défilement seul, une carte toutes les 4 s ; s'arrête 8 s quand le parent touche ou survole, et jamais si l'appareil
  // demande moins d'animations.
  function startAutoscroll(root) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    (root || document).querySelectorAll('[data-lp-autoscroll]').forEach(function (t) {
      if (t.getAttribute('data-lp-on')) return;
      t.setAttribute('data-lp-on', '1');
      var hold = 0;
      ['pointerdown', 'touchstart', 'wheel', 'mouseenter', 'focus'].forEach(function (ev) { t.addEventListener(ev, function () { hold = Date.now() + 8000; }, { passive: true }); });
      var timer = setInterval(function () {
        if (!document.body.contains(t)) return clearInterval(timer);
        if (Date.now() < hold || document.hidden) return;
        var card = t.querySelector('.lp-rv-card');
        var step = card ? card.getBoundingClientRect().width + 12 : 280;
        if (t.scrollLeft + t.clientWidth >= t.scrollWidth - 4) t.scrollTo({ left: 0, behavior: 'smooth' });
        else t.scrollBy({ left: step, behavior: 'smooth' });
      }, 4000);
    });
  }

  function money(cents) {
    var fmt = CFG.money_format || '${{amount}}';
    var n = Number(cents) / 100;
    function withSep(x, dec, thou, decSep) {
      var parts = x.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(decSep);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return withSep(n, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return withSep(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return withSep(n, 0, '.', ',');
      var s = withSep(n, 2, ',', '.');
      return s.replace(/\.00$/, '');
    });
  }

  function load() {
    if (DEMO) return null;
    try { return JSON.parse(localStorage.getItem(LS_KEY) || 'null'); } catch (e) { return null; }
  }
  function save() {
    if (DEMO) return; // la démo de l'éditeur ne doit jamais devenir le parcours repris sur le vrai site
    try { localStorage.setItem(LS_KEY, JSON.stringify(S)); } catch (e) { /* navigation privée */ }
  }
  function clearSaved() { if (DEMO) return; try { localStorage.removeItem(LS_KEY); } catch (e) { /* rien */ } }

  function api(path, opts) {
    opts = opts || {};
    // Démo : un envoi « réussit » sans rien écrire (le bouton Next mène à l'écran suivant) ; une lecture de session échoue.
    if (DEMO) return (opts.method || 'GET') === 'GET' ? Promise.reject(new Error('demo')) : Promise.resolve({});
    var headers = opts.headers || {};
    if (S && S.sid && S.secret) headers['x-lp-session'] = S.sid + '.' + S.secret;
    if (opts.json !== undefined) { headers['content-type'] = 'application/json'; opts.body = JSON.stringify(opts.json); }
    return fetch(API + path, { method: opts.method || 'GET', headers: headers, body: opts.body, keepalive: !!opts.keepalive })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (data) {
          if (!r.ok) { var err = new Error(data.error || ('http_' + r.status)); err.status = r.status; err.code = data.error; throw err; }
          return data;
        });
      });
  }

  function publish(name, data) {
    if (DEMO) return;
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('lp:' + name, data || {}); } catch (e) { /* pixel absent */ }
  }
  // Pixel Meta (chargé sur la page par WeTracked, Paul 20/10) : une étape = un événement (Paul, 23/10 ~17 h : « il faut que
  // chaque étape soit traquée »), pour voir l'entonnoir dans le Gestionnaire d'événements et en faire des conversions
  // personnalisées. Lead (e-mail donné) et ViewContent (héros 3D vu) sont des événements standard ; le checkout et l'achat
  // restent à WeTracked (pas de doublon). Aucune donnée personnelle.
  // WeTracked charge le pixel après la page : vu en ligne le 23/10, le Lead et les étapes 2 à 6 d'un parcours rapide partaient
  // avant lui et se perdaient. File d'attente, vidée dès que fbq existe (60 s au plus). Pas de faux fbq : le code de base de
  // Meta ne charge pas fbevents.js si fbq existe déjà.
  var META_STEPS = { adventure: 'LP_Step2_Adventure', photo: 'LP_Step3_Photo', loves: 'LP_Step4_Loves', message: 'LP_Step5_Message', preview: 'LP_Step6_Preview', offer: 'LP_Step7_Offer' };
  var metaQ = [], metaTimer = null;
  function metaFlush() {
    if (typeof window.fbq !== 'function') return false;
    while (metaQ.length) { try { window.fbq.apply(window, metaQ.shift()); } catch (e) { /* pixel absent */ } }
    return true;
  }
  function meta(name, data) {
    var p = { content_name: (S && S.adventure) || '' };
    if (name === 'step_view' && data && META_STEPS[data.name]) metaQ.push(['trackCustom', META_STEPS[data.name], p]);
    else if (name === 'preview_shown') metaQ.push(['track', 'ViewContent', p]);
    else if (name === 'checkout_click') metaQ.push(['trackCustom', 'LP_CheckoutClick', { content_name: p.content_name, value: data.value, currency: data.currency }]);
    else if (name === 'lead') metaQ.push(['track', 'Lead', p]);
    else return;
    if (metaFlush() || metaTimer) return;
    var n = 0;
    metaTimer = setInterval(function () { if (metaFlush() || ++n >= 120) { clearInterval(metaTimer); metaTimer = null; } }, 500);
  }
  // Journal serveur (source de vérité) + miroir Shopify pour les pixels, sans donnée personnelle.
  function track(name, data, step) {
    if (DEMO) return; // ni journal, ni pixel Meta, ni événement Shopify depuis l'éditeur
    var base = { adventure: S && S.adventure, angle: (S && S.angle) || null, arm: S && S.arm };
    var payload = {};
    for (var k in base) payload[k] = base[k];
    for (var j in (data || {})) payload[j] = data[j];
    publish(name, payload);
    meta(name, data);
    if (!S || !S.sid) return;
    api('/api/event', { method: 'POST', json: { name: name, step: step || null, data: data || null }, keepalive: true }).catch(function () {});
  }

  function adventure(id) {
    var list = (CAT && CAT.adventures) || [];
    for (var i = 0; i < list.length; i++) if (list[i].id === (id || S.adventure)) return list[i];
    return null;
  }
  function variantBySku(sku) {
    var list = CFG.variants || [];
    for (var i = 0; i < list.length; i++) if (list[i].sku === sku) return list[i];
    return null;
  }
  function skuFor(offerId) {
    var a = adventure();
    return (a && a.sku_overrides && a.sku_overrides[offerId]) || (CAT.offers[offerId] && CAT.offers[offerId].sku);
  }
  function armDef() {
    var arms = CAT.experiments.offer.arms;
    for (var i = 0; i < arms.length; i++) if (arms[i].id === S.arm) return arms[i];
    return arms[0];
  }
  function guessAccent() {
    var tz = '';
    try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) { /* rien */ }
    var lang = (navigator.language || '').toLowerCase();
    if (tz.indexOf('Australia/') === 0 || lang === 'en-au') return 'au';
    if (tz === 'Europe/London' || lang === 'en-gb') return 'uk';
    return 'us';
  }
  function focusTitle() {
    var h = app.querySelector('h2');
    if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
    // 03/11 (Paul : « Make Paul's movie » amenait directement sur la FAQ de l'offre) : Safari et le navigateur d'Instagram
    // (moteur WebKit, iPhone) ignoraient le défilement « smooth » lancé au changement d'écran — vérifié : 1 915 px, sur les
    // avis. On saute en haut sans animation, et on revérifie à l'image suivante (la page vient d'être posée).
    function top() { return Math.max(0, rootEl.getBoundingClientRect().top + window.pageYOffset - 12); }
    window.scrollTo(0, top());
    requestAnimationFrame(function () { if (window.pageYOffset > top() + 4) window.scrollTo(0, top()); });
  }

  // 30/10 (Paul : « une petite section le saviez-vous sur chaque étape… que je puisse écrire moi-même ») : les blocs « Did you
  // know » de la section lp-create (éditeur de thème Shopify) arrivent dans CFG.facts. Un encart par écran au plus ; s'il y en
  // a plusieurs pour le même écran, chaque visiteur en tire un, toujours le même (S.dyk), et il part dans le step_view
  // (data.dyk = fin de l'id du bloc + empreinte du texte : un texte réécrit compte à part). Un texte qui garde un [X] à
  // remplir ne s'affiche pas : les chiffres de Paul (clients, %) n'existent pas encore.
  // Dans l'éditeur (Paul, 30/10 ~10 h : « je ne vois aucune section le saviez-vous ») : tous les messages de l'écran, [X]
  // compris, avec la mention qu'ils restent cachés sur le site tant qu'un [ ] reste à remplir. « Show on the site » décoché
  // (les faits d'études pré-remplis, ~10 h 40) : visible ici seulement, en attendant que Paul les valide.
  function hole(f) { return /\[[^\]]*\]/.test(f.text + (f.source || '')); }
  function readFacts() { return (CFG.facts || []).filter(function (f) { return f && f.id && f.step && f.text && (DESIGN || (f.on !== false && !hole(f))); }); }
  var FACTS = readFacts();
  var dykShown = '';
  // 03/11 ~10 h (Paul : « il faut que tout soit modifiable, tout facilement… dès que j'appuie sur l'inspecteur, je veux pouvoir
  // aller exactement où je veux et modifier le texte ») : chaque zone d'écran a son bloc dans l'éditeur de thème (« 2 ·
  // Adventure — top », « Movie card »…). Ses champs arrivent dans CFG.tx (clé = id du réglage), pré-remplis avec le texte
  // affiché avant : tx(clé, texte d'avant) rend le champ tel quel, vide = rien ; bloc absent (supprimé) = le texte d'avant.
  // Dans l'éditeur, chaque zone porte l'attribut Shopify de son bloc (edLink) : un clic de l'inspecteur sur la zone ouvre
  // ce bloc, et seulement ses champs.
  function tx(k, d) { var T = CFG.tx || {}; if (!(k in T)) return d; var v = T[k] == null ? '' : String(T[k]).trim(); return v === '-' ? '' : v; }
  // 03/11 ~12 h : data-ed aussi sur le site, car c'est l'ancre des blocs posés « là où je le glisse » (injectLiq).
  function ed(key) { return ' data-ed="' + esc(key) + '"'; }
  function edLink() {
    if (!DESIGN) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-lp-ed][data-shopify-editor-block]'), function (h) {
      var key = h.getAttribute('data-lp-ed'), at = h.getAttribute('data-shopify-editor-block');
      Array.prototype.forEach.call(rootEl.querySelectorAll('[data-ed="' + key + '"]'), function (el) {
        if (el.getAttribute('data-shopify-editor-block') !== at) el.setAttribute('data-shopify-editor-block', at);
      });
    });
  }
  var ZONE_SCREEN = {'z_hero': 'hero', 'z_hero_form': 'hero', 'z_hero_mail': 'hero', 'z_cos': 'costume', 'z_cos_pick': 'costume', 'z_cos_btn': 'costume', 'z_adv': 'adventure', 'z_adv_ben': 'adventure', 'z_study': 'adventure', 'z_photo': 'photo', 'z_photo_safe': 'photo', 'z_photo_more': 'photo', 'z_loves': 'loves', 'z_loves_from': 'loves', 'z_msg': 'message', 'z_sugg': 'message', 'z_wait': 'waiting', 'z_prev': 'preview', 'z_sheet_dino': 'preview', 'z_sheet_halloween': 'preview', 'z_sheet_christmas': 'preview', 'z_off_top': 'offer', 'z_off_ben': 'offer', 'z_off_cards': 'offer', 'z_off_buy': 'offer', 'z_off_trust': 'offer', 'z_off_faq': 'offer', 'movie': 'adventure'};
  // Bloc choisi dans la liste de l'éditeur → sa zone. Lu sur data-lp-bid (= block.id, ce que Shopify envoie dans
  // shopify:block:select) : l'id rangé dans data-shopify-editor-block n'est pas le même (vérifié dans l'éditeur le 03/11).
  function edKey(id) {
    var k = '';
    Array.prototype.forEach.call(document.querySelectorAll('[data-lp-ed][data-lp-bid]'), function (h) {
      if (h.getAttribute('data-lp-bid') === id) k = h.getAttribute('data-lp-ed');
    });
    return k;
  }
  // Cartes de l'étape 2 (bloc « Movie card », un par film) : l'ordre des blocs = l'ordre des affiches ; champ vide = rien ;
  // film sans bloc = ses textes d'avant (catalogue, MOVIE_POSTERS).
  function movieEd(id) { return (CFG.movies || []).filter(function (m) { return m && m.adv === id; })[0] || null; }
  function movieRank(id) { var L = CFG.movies || []; for (var i = 0; i < L.length; i++) if (L[i] && L[i].adv === id) return i; return 1e3; }
  function movieTxt(m, k, d) { if (!m) return d; var v = m[k] == null ? '' : String(m[k]).trim(); return v === '-' ? '' : v; }

  // A/B tests du 02/11/2026 (Paul : « que des vrais A/B tests » ; le témoin A = la page telle qu'elle est, B réglable dans
  // l'éditeur de thème, section « A/B tests »). Un bras par visiteur, tiré à la 1re vue de l'écran testé et gardé (S.ab) ;
  // ?<clé>=a|b le force, même test éteint (<clé>f = 1 : nos vérifications, écartées de la lecture). Les bras partent dans
  // chaque step_view, offer_view et checkout_click. Lecture : onglet A/B tests de genstack (lib/abtests.js, mêmes clés).
  //   abe : l'email à l'étape 1 (A) ou sur l'écran de l'aperçu, juste avant l'offre (B)
  //   abv : étape 2, Noël juste après le Dino, avec un badge (B)        abk : encarts « Did you know » / confiance (B)
  //   abt : bande-annonce du Dino, l'enfant vu de dos seulement (B)     abl : atterrissage (A) ou tunnel direct (B)
  //   abn : bande-annonce de Noël, un enfant d'exemple visible (B) ; A = l'actuelle, aucun enfant à l'écran
  var AB = CFG.ab || {};
  // abh2 (Paul, 03/11 14 h : « garder la headline d'hier, celle qui a tourné… dans le title B, écrire ce que j'ai envie ») :
  // titre de l'étape 1, 2 bras. A = champ « Title » (le titre en place depuis le 30/10), B = le titre que Paul écrit dans le champ
  // « title B » du bloc « 1 · Title ». B vide = pas de test : tout le monde voit A, aucun bras tiré ni compté. Remplace abh
  // (3 bras, 11 h 35 → 14 h 20 : B « brave / believe » et C « kind / friends » jugés mauvais, arrêté sans verdict).
  // Ces deux textes-là, encore dans le gabarit, valent vide : le test ne part qu'avec le texte de Paul.
  var ABH_OLD = ['Help {name} be brave and believe in {themself}.', 'Help them be brave and believe in themselves.'];
  function heroB(k) { var v = tx(k, ''); return ABH_OLD.indexOf(v) >= 0 ? '' : v; }
  if (!AB.abh2) AB.abh2 = { on: true };
  // Comme abArm, mais N bras (arms = 'abc') ; dans l'éditeur de thème, A sauf forcé (le titre ne change pas pendant que Paul écrit).
  function abArmN(k, arms) {
    S.ab = S.ab || {};
    var f = new RegExp('^[' + arms + ']$').exec(params.get(k) || '');
    if (f && !(S.ab[k] && S.ab[k].f && S.ab[k].c === f[0])) { S.ab[k] = { c: f[0], f: 1 }; save(); }
    if (S.ab[k] && S.ab[k].f) return S.ab[k].c;
    if (DESIGN || !(AB[k] && AB[k].on)) return 'a';
    if (!S.ab[k]) { S.ab[k] = { c: arms.charAt(Math.floor(Math.random() * arms.length)) }; save(); }
    return S.ab[k].c;
  }
  function abArm(k) {
    S.ab = S.ab || {};
    var f = /^(a|b)$/.exec(params.get(k) || '');
    if (f && !(S.ab[k] && S.ab[k].f && S.ab[k].c === f[0])) { S.ab[k] = { c: f[0], f: 1 }; save(); }
    if (S.ab[k] && S.ab[k].f) return S.ab[k].c;
    // 03/11 15 h (Paul : « pourquoi il est revenu sur New ?… ça commence à me rendre dingue ») : dans l'éditeur de thème,
    // chaque rechargement de l'aperçu retirait A ou B au hasard (abe, abv, abk, abt, abn) ; ce que Paul tapait pouvait ne pas
    // s'afficher. L'éditeur montre toujours A (sauf bras forcé dans l'adresse) ; les visiteurs ne changent pas.
    if (DESIGN || !(AB[k] && AB[k].on)) return 'a';
    if (!S.ab[k]) { S.ab[k] = { c: Math.random() < 0.5 ? 'a' : 'b' }; save(); }
    return S.ab[k].c;
  }
  function abData(d) {
    var ab = (S && S.ab) || {};
    for (var k in ab) { d[k] = ab[k].c; if (ab[k].f) d[k + 'f'] = 1; }
    return d;
  }
  // Bras tirés AVANT le tunnel (localStorage, valables 30 jours depuis le 02/11, Paul : « 30 jours et pas 7 »), recopiés sur chaque step_view par abData :
  // abl = page Dino ou tunnel direct (02/11, tiré dans sections/lpl-adventure.liquid) ;
  // abr = landing A « 7 raisons », B « aventures » ou C tunnel direct (tiré dans snippets/lpl-router.liquid, U_landings_0211).
  var AB_LANDING = [['abl', 'lp_abl', /^(a|b)$/], ['abr', 'lp_abr', /^(a|b|c)$/]];
  function abLanding() {
    AB_LANDING.forEach(function (x) {
      try {
        var l = JSON.parse(localStorage.getItem(x[1]) || 'null');
        if (l && x[2].test(l.c) && Date.now() - l.t < 30 * 864e5) { S.ab = S.ab || {}; S.ab[x[0]] = l.f ? { c: l.c, f: 1 } : { c: l.c }; }
      } catch (e) { /* rien */ }
    });
  }
  // abe, bras B : l'email n'a pas été demandé à l'étape 1 ; il l'est sur l'écran de l'aperçu, avant l'offre.
  function needMail() { return !S.email && !!(S.ab && S.ab.abe && S.ab.abe.c === 'b'); }
  function trustStat() { return abArm('abk') === 'b' && CFG.trust_stat_b ? CFG.trust_stat_b : CFG.trust_stat; }
  var MAIL_RE = /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/;
  function textMark(s) { for (var h = 5381, i = 0; i < s.length; i++) h = (h * 33 + s.charCodeAt(i)) % 1679616; return h.toString(36); }
  function dykCard(f) {
    return '<aside class="lp-study lp-dyk-card" data-fid="' + esc(f.id) + '"' + ed('b:' + f.id) + '><p class="lp-study-k">' + (f.icon == null || f.icon ? '<span aria-hidden="true">' + esc(f.icon == null ? '💡' : f.icon) + ' </span>' : '') + esc(f.title == null ? 'Did you know?' : f.title) + '</p><p>' + fillE(f.text) + '</p>' +
      (f.source ? '<span class="lp-dyk-src">' + esc(f.source) + '</span>' : '') +
      (DESIGN && f.on === false ? '<span class="lp-dyk-ed">Editor only: not on the site until « Show on the site » is ticked.</span>'
        : DESIGN && hole(f) ? '<span class="lp-dyk-ed">Editor only: hidden on the site until every [ ] is filled in.</span>' : '') +
      (DESIGN && (f.arm === 'a' || f.arm === 'b') ? '<span class="lp-dyk-ed">Editor only: shown to the ' + f.arm.toUpperCase() + ' half of the A/B test « Did you know / trust » only.</span>' : '') + '</aside>';
  }
  function dyk(screen) {
    var k = abArm('abk'); // abk : un bloc « Test A only » / « Test B only » ne sort que dans son bras (test éteint : A)
    var list = FACTS.filter(function (f) { return f.step === screen && (DESIGN || !f.arm || f.arm === 'all' || f.arm === k); });
    if (!list.length) return '';
    if (DESIGN) return list.map(dykCard).join('');
    S.dyk = S.dyk || {};
    var f = list.filter(function (x) { return x.id === S.dyk[screen]; })[0];
    if (!f) { f = list[Math.floor(Math.random() * list.length)]; S.dyk[screen] = f.id; save(); }
    if (!dykShown) dykShown = String(f.id).slice(-6) + '.' + textMark(f.text);
    return dykCard(f);
  }
  // Bloc cliqué dans l'éditeur : son encart s'il est sur l'écran affiché, sinon un aperçu flottant qui dit sur quel écran il
  // sortira (les écrans 6 et l'offre demandent une vraie photo pour s'afficher dans l'aperçu).
  var DYK_SCREENS = { hero: 'Step 1 — Email & child\'s name', adventure: 'Step 2 — Adventure', costume: 'Step 2 — Costume (Halloween)', photo: 'Step 3 — Photo', loves: 'Step 4 — Occasion',
    message: 'Step 5 — Message', waiting: 'Step 6 — While the 3D hero is made', preview: 'Step 6 — Preview (poster)', offer: 'Offer page' };
  // L'écran affiché, au sens des réglages « Screen » (l'aperçu en cours de fabrication = « waiting »).
  function curScreen() {
    if (!S || !S.step) return '';
    if (S.step === 'preview') return app.querySelector('[data-lp-wait]') || !(S.preview && S.preview.state === 'done') ? 'waiting' : 'preview';
    return S.step === 'details' ? 'message' : S.step;
  }
  var edFact = '';
  function edShow(id) {
    edFact = id || '';
    var old = document.getElementById('lp-dyk-ed');
    if (old) old.remove();
    // Zone d'écran (« 2 · Adventure — top », « Movie card »…) : son écran, puis la zone au milieu de l'aperçu.
    var zk = edFact && edKey(edFact), zs = zk && ZONE_SCREEN[zk.split(':')[0]];
    if (zs) {
      var sa = /^z_sheet_(.+)$/.exec(zk); // fiche saison d'un film : l'aperçu passe sur CE film
      if (DEMO && S && (zs !== curScreen() || (sa && S.adventure !== sa[1]))) demoGo(zs, sa ? sa[1] : null);
      var zel = rootEl.querySelector('[data-ed="' + zk + '"]');
      if (zel) zel.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    }
    var f = FACTS.filter(function (x) { return x.id === edFact; })[0];
    // Démo : le bloc cliqué (encart ou code Liquid) ouvre son écran.
    var liq = !f && edFact && document.querySelector('template.lp-liq[data-bid="' + edFact + '"]');
    var bx = !f && !liq && edFact && (CFG.boxes || []).filter(function (b) { return b && b.id === edFact; })[0];
    var target = f ? (f.step === 'auto' ? autoScreen(f.after) : f.step) : liq ? (liq.getAttribute('data-step') === 'auto' ? autoScreen(liq.getAttribute('data-after')) : liq.getAttribute('data-step'))
      : bx ? (bx.step === 'auto' ? autoScreen(bx.after) : bx.step) : '';
    if (DEMO && S && target && target !== 'all' && target !== curScreen()) demoGo(target);
    if (liq || bx) { var lo = app.querySelector(liq ? '[data-liqid="' + edFact + '"]' : '[data-boxid="' + edFact + '"]'); if (lo) lo.scrollIntoView({ block: 'center', behavior: 'smooth' }); return; }
    if (!f) return;
    // Bloc « Where I drag it » : posé par injectLiq juste après ce rendu (observateur) → on le montre ensuite, sans flottant.
    if (f.step === 'auto') { var fid = edFact; setTimeout(function () { var h2 = app.querySelector('[data-fid="' + fid + '"]'); if (h2) h2.scrollIntoView({ block: 'center', behavior: 'smooth' }); }, 60); return; }
    var here = app.querySelector('[data-fid="' + edFact + '"]');
    if (here) return here.scrollIntoView({ block: 'center', behavior: 'smooth' });
    var box = document.createElement('div');
    box.id = 'lp-dyk-ed';
    box.className = 'lp-dyk-float';
    box.innerHTML = '<p class="lp-dyk-where">Editor preview — shown on: ' + esc(DYK_SCREENS[f.step] || f.step) + '</p>' + dykCard(f);
    rootEl.appendChild(box);
  }

  // Numéros d'étape du journal serveur : stables d'une aventure à l'autre (le costume compte avec l'étape 1).
  // 23/10 (session 23) : l'aventure (étape 2) et « ce qu'il adore » (après la photo) s'ajoutent ; le costume compte avec
  // l'aventure, l'occasion / message, la première et « ce qui se passe » forment une seule étape à l'écran.
  var STEP_INDEX = { hero: 1, adventure: 1, costume: 1, photo: 2, loves: 3, message: 3, endmsg: 3, premiere: 3, next: 3, preview: 4, offer: 5 };
  // L'étape s'affiche dans l'en-tête (setTop) ; l'appel reste dans chaque écran, il ne rend plus rien dans la carte.
  function progress(stepName) {
    setTop(stepName);
    return '';
  }

  // extra : ce qui vient d'être choisi à l'écran précédent (garçon / fille, passions, couleur, occasion…). Le Worker n'a pas
  // encore de colonnes pour ces choix ; ils voyagent dans le journal step_view (données ≤ 1 000 caractères, sans nom tapé).
  function go(stepName, extra) {
    S.step = stepName;
    save();
    if (!fromHistory) {
      try {
        var hs = history.state && history.state.lpStep;
        history[hs && hs !== stepName ? 'pushState' : 'replaceState']({ lpStep: stepName }, '');
      } catch (e) { /* rien */ }
    }
    dykShown = '';
    render();
    var data = { name: stepName };
    if (S.abq && S.abq.id === ABQ) { data.abw = S.abq.c; if (S.abq.forced) data.abwf = 1; }
    abData(data);
    if (dykShown) data.dyk = dykShown;
    clarityTag(data);
    for (var k in (extra || {})) data[k] = extra[k];
    track('step_view', data, STEP_INDEX[stepName] || 0);
    focusTitle();
  }

  function showError(msg, retry) {
    stopTrailer();
    track('error_shown', { msg: String(msg).slice(0, 80) });
    app.innerHTML = '<div class="lp-card lp-center"><h2 class="lp-h2">Something went wrong</h2><p class="lp-muted">' + esc(msg) + '</p>' +
      '<button type="button" class="lp-btn" id="lp-retry">Try again</button></div>';
    document.getElementById('lp-retry').onclick = retry || function () { location.reload(); };
  }

  function friendly(err) {
    if (!err) return 'Please try again.';
    if (err.status === 429) return 'Too many tries for now. Please try again in a little while.';
    if (err.code === 'adventure_closed') return 'This adventure is closed for new orders. Please pick another one.';
    if (err.message === 'Failed to fetch' || err.name === 'TypeError') return 'We could not reach our studio. Please check your connection.';
    return 'Please try again.';
  }

  // ------------------------------------------------------------ rendu
  function render() {
    stopProgress();
    stopTrailer();
    rootEl.classList.remove('has-sticky');
    // 23/10 ~14 h : le message, la date de première et « What happens next » ont rejoint l'écran de l'occasion (Paul :
    // « supprimer »). Un parcours repris sur l'un de ces anciens écrans y revient.
    if (S.step === 'endmsg' || S.step === 'premiere' || S.step === 'next') S.step = 'message';
    var step = S.step;
    if (step === 'pick') return renderPick();
    if (step === 'hero') return renderHero();
    if (step === 'adventure') return renderAdventure();
    if (step === 'costume') return renderCostume();
    if (step === 'photo') return renderPhoto();
    if (step === 'loves') return renderLoves();
    if (step === 'details' || step === 'message') return renderMessage(); // 'details' : ancien nom, reprises
    if (step === 'preview') return renderPreview();
    if (step === 'offer') return renderOffer();
    if (step === 'interstitial') return renderInterstitial();
    return renderHero();
  }

  function posterHtml(a, cls) {
    if (a.poster) return '<img class="' + cls + '" src="' + esc(a.poster) + '" alt="" loading="lazy">';
    return '<div class="' + cls + ' lp-poster-fallback" aria-hidden="true"><span>' + esc(a.emoji || '🎬') + '</span></div>';
  }

  function renderPick(message) {
    var list = CAT.adventures;
    var html = '<div class="lp-card"><h2 class="lp-h2">Pick an adventure</h2>' +
      (message ? '<p class="lp-note">' + esc(message) + '</p>' : '<p class="lp-muted">Your child becomes the hero of a 3D animated movie.</p>') +
      '<div class="lp-grid">';
    for (var i = 0; i < list.length; i++) {
      var a = list[i];
      html += '<button type="button" class="lp-adv' + (a.id === S.adventure ? ' is-on' : '') + '" data-adv="' + esc(a.id) + '">' +
        posterHtml(a, 'lp-adv-poster') + '<span class="lp-adv-title">' + esc(fill(a.title, { name: 'Your child' })) + '</span>' +
        '<span class="lp-adv-tag">' + esc(a.tagline || '') + '</span>' +
        (a.orders_until ? '<span class="lp-adv-until">Order by ' + esc(new Date(a.orders_until).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })) + '</span>' : '') +
        '</button>';
    }
    html += '</div></div>';
    app.innerHTML = html;
    app.querySelectorAll('[data-adv]').forEach(function (b) {
      b.onclick = function () {
        var prev = S.adventure;
        S.adventure = b.getAttribute('data-adv');
        if (prev !== S.adventure) track('adventure_changed', { from: prev, to: S.adventure }, 0);
        go('hero');
      };
    });
  }

  // Étape 1, refaite le 23/10 vers 9 h 30 par la session 23 (Paul : « créer quelque chose qui ressemble vraiment à notre
  // concurrent ») : calque de l'étape 1 de StarringYou (research/funnel_2310/starringyou_eu/10_etape1.png) — prénom,
  // garçon / fille, âge au curseur avec 4 stades, e-mail. Rien d'autre avant l'e-mail : « Who's the movie from? » passe à
  // l'écran de l'occasion, là où se signe le message. Stades sur 2-8 ans (Paul) : 2 / 3-4 / 5-6 / 7-8. Chaque phrase dit ce
  // que l'histoire montre à cet âge, jamais un effet sur l'enfant ; le seul effet réel de l'âge est vrai et affiché : le
  // héros 3D est dessiné à cet âge (Worker, prompts.js, en ligne depuis le 23/10 à 8 h 07).
  var ICONS = {
    wonder: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M8.5 14.5c1.9 2 5.1 2 7 0M9 9.6h.01M15 9.6h.01"/></svg>',
    imagination: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 20 15 9M15 3.5v3M19.6 5.4l-2.1 2.1M20.5 10h-3M12.5 5.4l1.2 1.2"/></svg>',
    exploration: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M13 16.5 7.5 11C9.5 6 13.5 3.5 20.5 3.5 20.5 10.5 18 14.5 13 16.5Z"/><path d="M7.5 11H4l2.5-3.5h4.5M13 16.5V20l3.5-2.5V13M7 17c-1.2 1.2-2 3.5-2 3.5s2.3-.8 3.5-2"/></svg>',
    adventure: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 3 2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1-4.4-4.3 6.1-.9Z"/></svg>'
  };
  // Noms à nous, pas la traduction des stades du concurrent (Éveil / Imaginaire / Exploration / Aventure ; Paul, 23/10 :
  // « ne pas être trop proche de lui »). 23/10 ~14 h (Paul : « en petit », non cliquables) : une ligne sous les âges, le
  // stade de l'âge choisi s'allume. Plus de phrase par stade : l'histoire ne change pas avec l'âge, seul le héros 3D.
  var STAGES = [
    { id: 'wonder', min: 2, max: 2, name: 'Little one' },
    { id: 'imagination', min: 3, max: 4, name: 'Dreamer' },
    { id: 'exploration', min: 5, max: 6, name: 'Explorer' },
    { id: 'adventure', min: 7, max: 8, name: 'Adventurer' }
  ];
  function stageOf(age) {
    for (var i = 0; i < STAGES.length; i++) if (age >= STAGES[i].min && age <= STAGES[i].max) return STAGES[i];
    return null;
  }
  var SENDERS = [['Mom', 'parent'], ['Dad', 'parent'], ['Mom & Dad', 'parent'], ['Grandma', 'grandparent'], ['Grandpa', 'grandparent'], ['Grandma & Grandpa', 'grandparent']];
  var NAME_OK = /^[A-Za-zÀ-ÖØ-öø-ÿĀ-ɏ][A-Za-zÀ-ÖØ-öø-ÿĀ-ɏ '’.-]{0,23}$/;

  // Le prospect au Worker. Appelé à l'étape 1 (l'e-mail d'abord), puis de nouveau seulement si l'aventure ou « de la part
  // de qui » change : le Worker n'a pas d'autre route pour les mettre à jour, et l'entonnoir compte les sid, pas les appels.
  // Tant que l'expéditeur n'est pas choisi, la relation part en « family » (valeur neutre acceptée par le Worker).
  function sendLead() {
    var h = S.hero || {};
    // abe, bras B : le lead part sans email (email_later, Worker a17955f2) ; le pixel « lead » et Klaviyo attendent l'email.
    var first = !S.leadSent || (S.leadSent.noEmail && !!S.email);
    return api('/api/lead', { method: 'POST', json: { name: h.name, age: h.age, gender: h.gender || null, relationship: S.relationship || 'family', email: S.email || '', email_later: S.email ? undefined : true, adventure: S.adventure } })
      .then(function (r) {
        S.adventure = r.adventure || S.adventure; S.leadSent = { adventure: S.adventure, relationship: S.relationship || 'family', noEmail: S.email ? undefined : true }; save();
        // B6 (30/10) : aventure changée après la photo → le Worker refait la fiche et l'affiche ; la page attend la nouvelle.
        if (r.preview_restarted) { S.preview = { state: 'queued', startedAt: Date.now() }; shownPreview = shownPoster = false; save(); startPolling(); }
        if (first && S.email) { meta('lead'); klSubscribe(); klEvent('LP Lead'); }
        return r;
      });
  }

  // 24/10 (Paul : « faut vraiment capturer les mails ici ») : l'e-mail de l'étape 1 part aussi dans Klaviyo, par son API
  // publique (clé « Site ID » et liste réglées dans l'éditeur de thème ; sans clé, rien ne part). Les événements disent
  // jusqu'où le parent est allé : un flux relance « LP Lead » sans « LP Offer Viewed », « LP Offer Viewed » sans commande.
  // Le prénom et l'aventure vont sur le profil : l'objet du mail peut dire « Mason's movie is waiting ».
  function klPost(path, data) {
    if (DEMO || !KL.key || !S || !S.email) return;
    try {
      fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(KL.key), {
        method: 'POST', keepalive: true,
        headers: { 'content-type': 'application/vnd.api+json', revision: '2024-10-15' },
        body: JSON.stringify({ data: data })
      }).catch(function () {});
    } catch (e) { /* jamais bloquant */ }
  }
  function klProfile() {
    var h = S.hero || {}, a = adventure();
    return { type: 'profile', attributes: { email: S.email, properties: {
      lp_child_name: h.name || null, lp_child_age: h.age || null, lp_child_gender: h.gender || null,
      lp_adventure: a ? fill(a.title) : S.adventure || null, lp_relationship: S.relationship || null, lp_link: location.origin + ROOT + 'pages/create' } } };
  }
  // L'abonnement à la liste ne porte que l'e-mail ; le prénom et l'aventure arrivent par l'événement qui suit.
  function klSubscribe() {
    if (!KL.list) return;
    klPost('subscriptions', { type: 'subscription', attributes: { custom_source: 'Little Premiere funnel, step 1',
      profile: { data: { type: 'profile', attributes: { email: S.email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
      relationships: { list: { data: { type: 'list', id: KL.list } } } });
  }
  function klEvent(name, props) {
    klPost('events', { type: 'event', attributes: { properties: props || {}, metric: { data: { type: 'metric', attributes: { name: name } } },
      profile: { data: klProfile() } } });
  }

  function renderHero() {
    var h = S.hero || {};
    var ageVal = Number(h.age) >= 2 && Number(h.age) <= 8 ? Number(h.age) : 0;
    var gender = h.gender || '';
    var abh = heroB('hero_title_b') ? abArmN('abh2', 'ab') : 'a'; // tiré ici : il part dans le step_view de l'étape 1
    var mailLater = abArm('abe') === 'b' && !S.email; // abe, bras B : pas d'email ici, il est demandé avant l'offre
    // 23/10 ~14 h (Paul, captures 26-27 : « le plus simple possible », « âge à choisir de 2 à 8 ans », le curseur montrait
    // 5 avant tout choix) : 7 pastilles, aucune allumée d'office ; dessous, les 4 stades en petit, chacun sous ses âges.
    var ages = '';
    for (var m = 2; m <= 8; m++) ages += '<button type="button" class="lp-agebtn' + (m === ageVal ? ' is-on' : '') + '" data-age="' + m + '" role="radio" aria-checked="' + (m === ageVal) + '" aria-label="' + m + ' years old">' + m + '</button>';
    var nameLbl = tx('hero_name_label', 'Their first name'), genLbl = tx('hero_gender_label', 'The hero is…'), ageLbl = tx('hero_age_label', 'Age');
    // Prénoms d'exemple américains, pas ceux du concurrent (Paul, 23/10 : « Léo et Emma, comme lui » ; marché 100 % US).
    app.innerHTML =
      '<div class="lp-card lp-hero1">' + progress('hero') +
      // 30/10 (Paul : « starring in the movie » = pas le meilleur bénéfice ; « 3-minute 3D movie » faux, c'est une saison de
      // 6 épisodes que le parent ne connaît pas encore) : le titre porte l'angle confiance, le sous-titre dit ce qu'on achète
      // sans durée ni format. Remplis par refresh(), au prénom et au genre.
      '<h2 class="lp-h2 lp-center-text" id="lp-title"' + ed('z_hero') + '></h2>' +
        (DESIGN ? '<p class="lp-dyk-ed lp-center-text" id="lp-title-b"' + ed('z_hero') + '></p>' : '') +
      '<p class="lp-muted lp-center-text" id="lp-sub"' + ed('z_hero') + '></p>' +
      '<form id="lp-form" novalidate>' +
        // Zone « 1 · Name, gender & age » (z_hero_form) : libellé vide = libellé et icône retirés.
        (nameLbl ? '<label class="lp-label lp-ico-label" for="lp-name"' + ed('z_hero_form') + '>' + ICONS.wonder + fillE(nameLbl) + '</label>' : '') +
        '<input class="lp-input" id="lp-name" name="name" maxlength="24" autocomplete="off" autocapitalize="words" placeholder="' + fillE(tx('hero_name_ph', 'e.g. Mason, Harper…')) + '" value="' + esc(h.name || '') + '"' + ed('z_hero_form') + '>' +
        (genLbl ? '<p class="lp-label lp-ico-label" id="lp-genlbl"' + ed('z_hero_form') + '>' + ICONS.adventure + fillE(genLbl) + '</p>' : '') +
        '<div class="lp-gender" role="radiogroup" aria-labelledby="lp-genlbl"' + ed('z_hero_form') + '>' +
          [['boy', '👦', tx('hero_boy', 'A boy')], ['girl', '👧', tx('hero_girl', 'A girl')]].map(function (g) {
            var on = gender === g[0];
            return '<button type="button" class="lp-gtile' + (on ? ' is-on' : '') + '" data-gender="' + g[0] + '" role="radio" aria-checked="' + on + '"><span aria-hidden="true">' + g[1] + '</span>' + fillE(g[2]) + '</button>';
          }).join('') +
        '</div>' +
        (ageLbl ? '<p class="lp-label lp-ico-label" id="lp-agelbl"' + ed('z_hero_form') + '><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 11h16v9H4zM3 7h18v4H3zM12 7v13M12 7c-1.5-3-5.5-3-5 0M12 7c1.5-3 5.5-3 5 0"/></svg>' + fillE(ageLbl) + '</p>' : '') +
        '<div class="lp-ages" role="radiogroup" aria-labelledby="lp-agelbl">' + ages + '</div>' +
        // 28/10 (Paul : « pourquoi je devrais mettre mon email ? Il faut lui faire comprendre pourquoi ») : 258 vues de l'étape 1
        // pour 103 e-mails (24-28/10). La raison est dans le libellé, lu avant de taper ; tout ce qui est dit est vrai (mail 1
        // à +30 min avec le héros et le lien de reprise, film livré par e-mail, désinscription Klaviyo).
        (mailLater ? '' : '<label class="lp-label lp-ico-label" for="lp-email"' + ed('z_hero_mail') + '><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h18v12H3z"/><path d="m3 7 9 6 9-6"/></svg><span id="lp-emaillbl">' + fillE(tx('hero_email0', 'Where should we send the free preview?')) + '</span></label>' +
        '<input class="lp-input lp-input-lg" id="lp-email" type="email" inputmode="email" autocomplete="email" placeholder="' + fillE(tx('hero_email_ph', 'you@example.com')) + '" value="' + esc(S.email || '') + '"' + ed('z_hero_mail') + '>') +
        '<p class="lp-error" id="lp-err" role="alert"></p>' +
        '<button type="submit" class="lp-btn lp-btn-full" id="lp-next"' + ed('z_hero_mail') + '>' + fillE(tx('hero_button0', 'Next →')) + '</button>' +
        dyk('hero') +
      '</form></div>';

    var nameInput = document.getElementById('lp-name');
    var touched = !!ageVal;
    function typedName() { return nameCase(nameInput.value.trim().replace(/\s+/g, ' ')); }
    // Tout ce qui dit le prénom se met à jour pendant la frappe : « C'est pour Tom… que pour Tom » (Paul, 23/10).
    function refresh() {
      var n = typedName();
      var who = n || 'your child';
      var P = PRONS[gender] || { they: 'they', them: 'them', their: 'their', themself: 'themselves' };
      // Zones « 1 · Title » et « 1 · Email & button » : {name}, {they}… = le prénom en cours de frappe et le genre cliqué.
      var V = { name: who, Name: cap(who), they: P.they, them: P.them, their: P.their, themself: P.themself, They: cap(P.they), Them: cap(P.them), Their: cap(P.their) };
      app.querySelectorAll('[data-age]').forEach(function (b) { var on = touched && Number(b.getAttribute('data-age')) === ageVal; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', String(on)); });
      // 30/10 ~11 h (Paul : pas que la bravoure, un mot qui rassemble, où chaque parent met ce qu'il veut) : « hero » est le
      // mot-parapluie (brave pour l'un, gentil avec maman pour l'autre) ET le produit ; la liste reprend l'étape 2.
      // abh2 : B = champ « title B » (avec prénom) ; avant le prénom, « title B — before the name » s'il est rempli, sinon le même
      // titre B avec « your child ». Dans l'éditeur, l'aperçu montre A et, dessous en rouge, le titre B tel qu'il sortira.
      var hb = n ? heroB('hero_title_b') : (heroB('hero_title_b0') || heroB('hero_title_b'));
      var ht = abh === 'b' && hb ? hb : tx('hero_title', 'Show {name} the hero {they} can be.');
      document.getElementById('lp-title').textContent = fill(ht, V);
      var tb = document.getElementById('lp-title-b');
      if (tb) tb.textContent = hb ? 'Editor only — A/B test, title B: « ' + fill(hb, V) + ' »' : 'Editor only — A/B test off: write a title B below to start it (half the visitors will see it).';
      document.getElementById('lp-sub').textContent = fill(tx('hero_sub', '{Name} stars in {their} own animated adventure, being brave, kind and helping others. Kids grow into the hero they see.'), V);
      document.getElementById('lp-next').textContent = n ? fill(tx('hero_button', 'Make {name} the star ✦'), V) : fill(tx('hero_button0', 'Next →'), V);
      if (!mailLater) document.getElementById('lp-emaillbl').textContent = n ? fill(tx('hero_email', 'Where should we send {name}\'s free preview?'), V) : fill(tx('hero_email0', 'Where should we send the free preview?'), V);
    }
    function unmiss() { app.querySelectorAll('.lp-miss').forEach(function (x) { x.classList.remove('lp-miss'); }); }
    function pop(btn) {
      unmiss();
      document.getElementById('lp-err').textContent = '';
      btn.classList.add('lp-pop');
      btn.addEventListener('animationend', function () { btn.classList.remove('lp-pop'); }, { once: true });
    }
    app.querySelectorAll('[data-age]').forEach(function (b) {
      b.onclick = function () {
        touched = true;
        ageVal = Number(b.getAttribute('data-age'));
        pop(b);
        refresh();
      };
    });
    var gBtns = [].slice.call(app.querySelectorAll('.lp-gtile'));
    gBtns.forEach(function (b) {
      b.onclick = function () {
        gender = b.getAttribute('data-gender');
        gBtns.forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-checked', String(x === b)); });
        pop(b);
        refresh();
      };
    });
    nameInput.oninput = function () { unmiss(); refresh(); };
    if (!mailLater) document.getElementById('lp-email').oninput = function () { unmiss(); document.getElementById('lp-err').textContent = ''; };
    refresh();

    document.getElementById('lp-form').onsubmit = function (ev) {
      ev.preventDefault();
      var err = document.getElementById('lp-err');
      var name = typedName();
      var email = mailLater ? '' : document.getElementById('lp-email').value.trim();
      var problem = '', miss = null;
      if (!NAME_OK.test(name)) { problem = 'Please enter the hero\'s first name.'; miss = nameInput; }
      else if (!gender) { problem = 'Is ' + name + ' a boy or a girl?'; miss = app.querySelector('.lp-gender'); }
      else if (!touched) { problem = 'Please choose ' + name + '\'s age.'; miss = app.querySelector('.lp-ages'); }
      else if (!mailLater && !MAIL_RE.test(email)) { problem = 'Please enter a valid email to get ' + name + '\'s free preview.'; miss = document.getElementById('lp-email'); }
      if (problem) {
        err.textContent = problem; unmiss(); miss.classList.add('lp-miss');
        miss.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (miss.tagName === 'INPUT') miss.focus({ preventScroll: true });
        return;
      }
      err.textContent = '';
      var btn = document.getElementById('lp-next');
      btn.disabled = true;
      btn.textContent = 'Saving…';
      S.hero = { name: name, age: ageVal, gender: gender };
      if (!mailLater) S.email = email;
      save();
      sendLead()
        .then(function () {
          S.leadDone = true;
          if (S.email) publish('lead', { adventure: S.adventure, angle: S.angle || null, arm: S.arm });
          go('adventure', { gender: gender, stage: (stageOf(ageVal) || {}).id || null });
        })
        .catch(function (e) {
          btn.disabled = false;
          refresh();
          if (e.code === 'adventure_closed') { S.adventure = null; S.leadDone = false; return renderPick('This adventure just closed for new orders. Please pick another one.'); }
          err.textContent = e.code === 'bad_name' ? 'Please use letters only for the first name.' : friendly(e);
        });
    };
  }

  // Étape 2 : l'aventure. 23/10 ~11 h 40, refaite sur la remarque de Paul (captures 19-20 : « options trop nombreuses et
  // trop grandes », « faire comme le concurrent mais améliorer », « une section générale en bas sur tous les épisodes […]
  // pensées par rapport à une étude », « des bénéfices très clairs qu'un enfant de 8 ans pourrait comprendre », pas « le
  // cadeau qui lui fera plaisir »). Donc : cartes compactes de StarringYou (20_etape2.png : affiche, titre, une ligne), puis
  // en bas ce que le héros fait dans TOUS les films et l'étude, telle que Paul l'a validée pour les pages (10 h 37 ; forme
  // imposée par ETUDES_4_BENEFICES : « That story was about sharing », aucun effet prêté à nos films). Les cartes viennent
  // du catalogue : une aventure que la production ne sait pas livrer n'apparaît jamais.
  // 23/10 ~14 h (Paul, capture 28 : « mettre en avant In every movie… plus visible, en haut ») : la bande des trois
  // bénéfices passe au-dessus des cartes ; l'étude reste dessous.
  function kidBenefitsHtml() {
    var ben = [['🦁', 'Is brave', 'even when it\'s a little scary'], ['💛', 'Is kind', 'to someone shy or lost'], ['🤝', 'Helps others', 'and saves the day']];
    var li = ben.map(function (x, i) {
      var ic = tx('adv_b' + (i + 1) + '_icon', x[0]), b = tx('adv_b' + (i + 1) + '_title', x[1]), sm = tx('adv_b' + (i + 1) + '_text', x[2]);
      return ic || b || sm ? '<li>' + (ic ? '<span aria-hidden="true">' + esc(ic) + '</span>' : '') + (b ? '<b>' + fillE(b) + '</b>' : '') + (sm ? '<small>' + fillE(sm) + '</small>' : '') + '</li>' : '';
    }).join('');
    var k = tx('adv_kicker', 'In every movie, {name}…');
    return '<section class="lp-allmovies lp-allmovies-top" aria-label="In every movie"' + ed('z_adv_ben') + '>' +
      (k ? '<p class="lp-allmovies-k">' + fillE(k) + '</p>' : '') +
      (li ? '<ul class="lp-kidben">' + li + '</ul>' : '') + '</section>';
  }
  function studyHtml() {
    var t = tx('study_title', '★ Why we write every story this way'),
      x = tx('study_text', 'Kids copy their heroes, and even more when the hero is them. In a 2025 study of 315 kids aged 5 to 6, those read a story about a hero who shares gave more of their favorite stickers to a child they\'d never met. When the hero had their own photo and name, they gave even more. That story was about sharing.'),
      u = tx('study_us', 'In every Little Premiere movie, {name} is the hero who helps.'),
      src = tx('study_src', 'Kotaman & Balcı (2025), Early Childhood Education Journal');
    if (!t && !x && !u && !src) return DESIGN ? '<section class="lp-study lp-study-sep"' + ed('z_study') + '><span class="lp-dyk-ed">Editor only: « Why we write… » is empty, so it is hidden on the site.</span></section>' : '';
    return '<section class="lp-study lp-study-sep" aria-label="' + esc(String(t || 'Why we write every story this way').replace(/^[^A-Za-z0-9]+/, '')) + '"' + ed('z_study') + '>' + (t ? '<p class="lp-study-k">' + fillE(t) + '</p>' : '') +
        (x ? '<p>' + fillE(x) + '</p>' : '') +
        (u ? '<p class="lp-study-us">' + fillE(u) + '</p>' : '') +
        (src ? '<span class="lp-dyk-src">' + fillE(src) + '</span>' : '') + '</section>';
  }
  // 24/10 ~11 h 30 (Paul, captures 45 et 47 : « on garde les 2 aventures… mettre [l'accent] sur Halloween, exclusivité
  // 2026 » ; « style affiche de film et on voit un vrai enfant… ça fait plus pro et donne envie ») : chaque carte est
  // l'affiche du film au prénom tapé à l'étape 1, comme la couverture d'un livre personnalisé. Un vrai enfant en costume,
  // en pied, devant le halo de l'aventure : Leo (R37) ; pour une fille, à Halloween, la petite sorcière (R45) ; photos de
  // refs_avatar, droits achetés ; détourées par Vision (macOS), composées par work_offre_2410/compose.py (0 $).
  // Aventure sans affiche composée : l'image du catalogue, comme avant.
  // 28/10 (Paul : « sur chaque affiche, un garçon et une fille… toutes les images équilibrées entre garçons et filles ») :
  // une seule affiche par film, pour tous, le garçon des affiches (R37) et la fille AVATAR n° 30 ensemble (gpt-image-2).
  // Badge du Dino = best-seller : 7 des 9 commandes payées (#1006-#1014, 24-28/10, lues dans Shopify). « 2026 exclusive »
  // retiré. Le Rudolph de l'affiche de Noël a perdu son nez rouge (personnage sous marque).
  var MOVIE_POSTERS = {
    halloween: { pic: 'lp-adv-halloween-duo.jpg' },
    dino: { pic: 'lp-adv-dino-duo.jpg', badge: '★ Best-seller', proof: 'Parents\' #1 choice' },
    christmas: { pic: 'lp-adv-christmas-reel-duo.jpg', badge: 'Coming soon' },
    fairy: { pic: 'lp-adv-fairy-duo.jpg', badge: 'Coming soon' }
  };
  // Films pas encore prêts : montrés, ni cliquables ni commandables (le catalogue du Worker n'en sait rien ; Noël y reste
  // « upcoming », masqué). Un film qui ouvre dans le catalogue sort d'ici tout seul.
  var COMING_SOON = [
    { id: 'christmas', title: '{name} and the Christmas Star', short_title: 'The Christmas Star', tagline: 'The Christmas Star went out. Santa needs a hero.' },
    { id: 'fairy', title: '{name} and the Fairy Queen', short_title: 'The Fairy Queen', tagline: 'The Fairy Queen lost her magic crown. The kingdom needs a hero.' }
  ];
  // A/B de l'étape 2 (28/10 → 30/10 ~17 h) : les films ouverts seuls, ou plus les deux coming soon. Les coming soon ont
  // gagné (9 ventes / 39 visiteurs contre 4 / 58) : GO de Paul, ils sont affichés à tout le monde (genstack, onglet A/B tests).
  function moviePosterHtml(a, badgeB) {
    var m = MOVIE_POSTERS[a.id];
    if (!m || !ASSETS) return '';
    var badge = badgeB || movieTxt(movieEd(a.id), 'badge', m.badge || '');
    var h = S.hero || {}, name = h.name ? vars().name : '';
    return '<span class="lp-mposter" style="background-image:url(' + esc(ASSETS + m.pic) + ')">' +
      (badge && !(badge === 'Coming soon' && adventure(a.id)) ? '<span class="lp-mposter-badge">' + esc(badge) + '</span>' : '') + mposterTitle(a, name) + '</span>';
  }
  // ss = la saison (SEASON_SHEETS) : l'affiche de l'étape 6 annonce la série, pas l'épisode 1 (Paul, 30/10). Pas de badge
  // « Episodes 1–6 » (Paul, 30/10 ~11 h 10 : le bas de l'affiche dit déjà « 6 episodes »).
  function mposterTitle(a, name, ss) {
    var full = fill(a.title), sub = ss ? ss.poster : name && full.indexOf(name) === 0 ? full.slice(name.length).trim() : (a.short_title || full);
    return '<span class="lp-mposter-t"><b style="font-size:' + Math.min(19, 92 / (0.6 * Math.max(name.length, 1))).toFixed(2) + 'cqw">' + esc(name || 'Your child') + '</b>' +
      '<i' + (ss ? ed('z_sheet_' + a.id) : '') + '>' + esc(sub) + '</i><small' + (ss ? ed('z_sheet_' + a.id) : '') + '>' +
      (ss ? esc(ss.series == null ? 'A Little Premiere series · 6 episodes' : ss.series) : 'A Little Premiere film') + '</small></span>';
  }
  // 28/10 (Paul : « une véritable tête d'affiche… le titre avec son prénom ») : l'affiche de l'étape 2, avec l'enfant dedans.
  // L'image vient du Worker (sans texte) ; le prénom et le titre sont posés ici, comme sur la carte cliquée à l'étape 2.
  // 30/10 (Paul, capture 1 : cadre noir ; « parfois l'ancienne image et pas toujours la nouvelle ») : deux calques dans le
  // même cadre, titre posé dès le départ. Dessous la fiche 3D (même image que « The cast », déjà chargée), dessus l'affiche,
  // en fondu dès qu'elle est chargée. La fiche ne se montre que si l'affiche manque : pas encore faite (4 visiteurs sur 44
  // les 28-29/10), lente (> 1,5 s) ou en échec. Plus de cadre vide, plus d'image remplacée d'un coup par une autre mise en page.
  function heroPosterHtml(a, url, base, ss) {
    return '<span class="lp-mposter" role="img" aria-label="Movie poster">' +
      (base ? '<img class="lp-mp-base" src="' + esc(base) + '" alt="">' : '') +
      (url ? '<img class="lp-mp-art" src="' + esc(url) + '" alt="">' : '') +
      mposterTitle(a, vars().name, ss) + '</span>';
  }
  function armPoster() {
    var mp = document.querySelector('#lp-heromedia .lp-mposter');
    if (!mp) return;
    var base = mp.querySelector('.lp-mp-base'), art = mp.querySelector('.lp-mp-art');
    var showBase = function () { if (base) base.classList.add('is-on'); };
    if (!art) return showBase();
    var slow = setTimeout(showBase, 1500);
    var ok = function () {
      clearTimeout(slow);
      art.classList.add('is-on');
      if (!shownPoster) { shownPoster = true; track('poster_shown', {}, 4); }
    };
    art.onerror = function () { clearTimeout(slow); if (art.parentNode) art.parentNode.removeChild(art); showBase(); };
    if (art.complete && art.naturalWidth) ok(); else art.onload = ok;
  }
  function swapPoster() {
    var mp = document.querySelector('#lp-heromedia .lp-mposter');
    if (!mp || !S.preview || !S.preview.poster || mp.querySelector('.lp-mp-art')) return;
    var base = mp.querySelector('.lp-mp-base'), art = '<img class="lp-mp-art" src="' + esc(S.preview.poster) + '" alt="">';
    if (base) base.insertAdjacentHTML('afterend', art); else mp.insertAdjacentHTML('afterbegin', art);
    armPoster();
  }
  // 28/10 ~18 h : un vrai visiteur quitte l'étape 6 en 10 s (médiane, 80 sessions du 24-28/10) et l'affiche arrive ~20 s
  // après la fiche ; il reste 69 s sur l'offre. L'affiche y remplace donc la fiche dès qu'elle est prête : la vignette
  // « Starring » et l'image de fin de la bande-annonce (le médaillon pendant le film reste le portrait).
  function swapOfferPoster() {
    var url = S.preview && S.preview.poster;
    if (!url) return;
    var pre = new Image();
    pre.onload = function () {
      if (S.step !== 'offer') return;
      var card = document.querySelector('.lp-pw-card');
      if (card && !card.classList.contains('has-poster')) {
        var cim = card.querySelector('img');
        if (!cim) { cim = document.createElement('img'); card.insertBefore(cim, card.firstChild); }
        cim.src = url;
        cim.alt = fill('{Name}\'s movie poster');
        card.classList.add('has-poster');
      }
      var end = document.getElementById('lp-endimg');
      if (end) { end.src = url; end.hidden = false; end.classList.add('is-poster'); }
      if (!shownPoster) { shownPoster = true; track('poster_shown', { where: 'offer' }, 5); }
    };
    pre.src = url;
  }
  // 02/11 ~22 h 40 (Paul, capture de l'étape 2 : « format téléphone on voit pas les 4, et on voit pas tout le texte… un max
  // d'infos les plus utiles visibles ») : sur téléphone, l'étape 2 passe en liste, une ligne par film : la petite affiche au
  // prénom, le titre, l'accroche entière, le badge et la ligne du bas. Le titre et le badge en texte ne servent qu'à cette
  // liste (cachés sur ordinateur, où l'affiche les porte déjà). Mesuré à 390 × 720 (iPhone, navigateur d'Instagram) : avant
  // 2 affiches sur 4 et leur texte sous le bouton ; après, les 4 lignes entières au-dessus du bouton.
  // 03/11 ~9 h 30 (Paul, capture StarringYou « Pick Emma's adventure » : « comme le concurrent… on voit bien l'image et c'est
  // hyper simple à cliquer, juste potentiellement un peu plus petit ») : la liste devient une grille 2 × 2 d'affiches, le
  // prénom, le titre et l'accroche posés en bas de l'image ; les 4 entières au-dessus du bouton à 390 × 720.
  function movieCard(a) {
    var me = movieEd(a.id), c = {};
    for (var k in a) c[k] = a[k];
    if (COMING_SOON.some(function (x) { return x === a; })) c.soon = true;
    // Titre réécrit : il remplace aussi « {name} and the … » de l'affiche (ordinateur) ; inchangé, l'affiche reste la même.
    if (me) { var t = movieTxt(me, 'title', ''); if (t !== a.short_title) c.title = t; c.short_title = t; c.tagline = movieTxt(me, 'tagline', ''); }
    return c;
  }
  function advName(a) {
    var nm = S.hero && S.hero.name ? vars().name : '';
    return '<b class="lp-advcard2-name">' + (nm ? '<span>' + esc(nm) + '</span>' : '') + esc(a.short_title || fill(a.title)) + '</b>';
  }
  // Badge de Noël dans le bras B du test abv : champ « Badge in A/B test B » de la carte Noël ; vide = le badge normal.
  function abvBadge() { var me = movieEd('christmas'); return (me ? movieTxt(me, 'badge_b', '') : (AB.abv || {}).badge) || null; }
  function advBadge(a, badgeB) {
    var m = MOVIE_POSTERS[a.id] || {}, badge = badgeB || movieTxt(movieEd(a.id), 'badge', m.badge || '');
    return badge && !(badge === 'Coming soon' && adventure(a.id)) ? '<span class="lp-advcard2-badge">' + esc(badge) + '</span>' : '';
  }
  function renderAdventure() {
    // 28/10 : le best-seller en premier et choisi par défaut. Le Worker donne d'office settings.default_adventure
    // (Halloween, lu le 28/10) à toute session sans ?adv= : à la 1re vue de l'étape 2, on coche donc le best-seller,
    // sauf film demandé par l'URL (pub, page d'une aventure). Ensuite, le choix du parent reste.
    // Ordre : celui des blocs « Movie card » de l'éditeur (films ouverts et coming soon mêlés) ; un film sans bloc garde sa
    // place d'avant (le Dino d'abord, les coming soon à la fin).
    var open = CAT.adventures.slice().sort(function (a, b) { return (b.id === 'dino') - (a.id === 'dino'); });
    if (!open.length) return renderPick();
    var soonRaw = COMING_SOON.filter(function (x) { return !adventure(x.id); });
    var allCards = open.concat(soonRaw).map(function (a, i) { return [a, i]; })
      .sort(function (x, y) { return movieRank(x[0].id) - movieRank(y[0].id) || x[1] - y[1]; }).map(function (x) { return movieCard(x[0]); });
    // A/B abv (Paul, 02/11) : B = Noël juste après le Dino, avec le badge écrit dans l'éditeur (appliqué sur l'ordre réglé).
    // Éditeur : bras A (l'ordre affiché = l'ordre des blocs « Movie card ») sauf ?abv=b dans l'adresse de l'aperçu.
    var abvB = !!adventure('christmas') && (DESIGN && !params.get('abv') ? false : abArm('abv') === 'b');
    if (abvB) {
      var ci = allCards.map(function (a) { return a.id; }).indexOf('christmas'), xmas = allCards.splice(ci, 1)[0];
      allCards.splice(allCards.map(function (a) { return a.id; }).indexOf('dino') + 1, 0, xmas);
    }
    var list = allCards.filter(function (a) { return !a.soon; }), soon = allCards.filter(function (a) { return a.soon; });
    if (!adventure() || (!S.advSeen && !params.get('adv'))) S.adventure = list[0].id;
    S.advSeen = true; save();
    var cardHtml = function (a) { return a.soon ? soonCard(a) : openCard(a); };
    app.innerHTML =
      '<div class="lp-card lp-adv-screen">' + progress('adventure') +
      '<h2 class="lp-h2 lp-center-text"' + ed('z_adv') + '>' + fillE(tx('adv_title', 'Choose {name}\'s adventure')) + '</h2>' +
      kidBenefitsHtml() +
      '<div class="lp-advgrid' + (list.length + soon.length === 1 ? ' is-one' : '') + '" role="radiogroup" aria-label="Movies">' + allCards.map(cardHtml).join('') + '</div>' +
      '<p class="lp-error" id="lp-err" role="alert"></p>' +
      '<button type="button" class="lp-btn lp-btn-full" id="lp-next"' + ed('z_adv') + '></button>' +
      studyHtml() + dyk('adventure') +
      '</div>';
    function openCard(a) {
        var mp = moviePosterHtml(a, abvB && a.id === 'christmas' ? abvBadge() : null), me = movieEd(a.id);
        var proof = movieTxt(me, 'line', (MOVIE_POSTERS[a.id] || {}).proof ? '♥ ' + MOVIE_POSTERS[a.id].proof : '');
        var by = a.orders_until ? movieTxt(me, 'until', 'Order by {date}').replace(/\{date\}/g, new Date(a.orders_until).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })) : '';
        var until = by ? '<em>' + fillE(by) + '</em>' : '';
        return '<button type="button" class="lp-advcard2" data-adv="' + esc(a.id) + '" role="radio" aria-checked="false"' + ed('movie:' + a.id) + '>' +
          '<span class="lp-advcard2-pic' + (mp ? ' is-movie' : '') + '">' + (mp || posterHtml(a, 'lp-advcard-img') + '<span class="lp-advcard-txt"><b>' + esc(a.short_title || fill(a.title)) + '</b>' +
          (a.tagline ? '<small>' + fillE(a.tagline) + '</small>' : '') + until + '</span>') +
          '<span class="lp-advcard-check" aria-hidden="true">✓</span></span>' +
          (mp ? '<span class="lp-advcard2-cap">' + advName(a) + (a.tagline ? '<small>' + fillE(a.tagline) + '</small>' : '') +
            '<span class="lp-advcard2-meta">' + advBadge(a, abvB && a.id === 'christmas' ? abvBadge() : null) +
            (proof ? '<em class="lp-adv-proof">' + fillE(proof) + '</em>' : '') + until + '</span></span>' : '') +
          '</button>';
    }
    function soonCard(a) {
      var line = movieTxt(movieEd(a.id), 'line', '🎬 In the making');
      return '<div class="lp-advcard2 is-soon" aria-disabled="true" aria-label="' + esc(a.short_title) + ', coming soon"' + ed('movie:' + a.id) + '>' +
          '<span class="lp-advcard2-pic is-movie">' + moviePosterHtml(a) + '</span>' +
          '<span class="lp-advcard2-cap">' + advName(a) + (a.tagline ? '<small>' + fillE(a.tagline) + '</small>' : '') + '<span class="lp-advcard2-meta">' + advBadge(a) +
          (line ? '<em>' + fillE(line) + '</em>' : '') + '</span></span></div>';
    }
    var cards = [].slice.call(app.querySelectorAll('.lp-advcard2'));
    function paint() {
      var a = adventure();
      cards.forEach(function (c) { var on = c.getAttribute('data-adv') === a.id; c.classList.toggle('is-on', on); c.setAttribute('aria-checked', String(on)); });
      document.getElementById('lp-next').textContent = fill(tx('adv_button', 'Continue with {movie} →'), { movie: movieCard(a).short_title || fill(a.title) });
    }
    cards.forEach(function (c) {
      c.onclick = function () {
        var prev = S.adventure;
        S.adventure = c.getAttribute('data-adv');
        if (prev !== S.adventure) { S.costume = null; track('adventure_changed', { from: prev, to: S.adventure }, 1); }
        save();
        c.classList.add('lp-pop');
        c.addEventListener('animationend', function () { c.classList.remove('lp-pop'); }, { once: true });
        paint();
      };
    });
    paint();
    document.getElementById('lp-next').onclick = function () {
      var btn = this;
      var next = function () { go(costumesOf(adventure()) ? 'costume' : 'photo', { adventure_picked: S.adventure }); };
      if (S.leadSent && S.leadSent.adventure === S.adventure) return next();
      btn.disabled = true;
      sendLead().then(next).catch(function (e) {
        btn.disabled = false;
        if (e.code === 'adventure_closed') { S.adventure = null; return renderAdventure(); }
        document.getElementById('lp-err').textContent = friendly(e);
      });
    };
  }

  // Étape 4 : l'occasion et de la part de qui. 24/10 ~12 h 20 (Paul, captures 53-57 : « {Name} is… » et « When the movie
  // starts, {name} will say… » « pas folle du tout… ça met pas le pied dans la porte, c'est juste étrange ») : l'étape 4
  // reprend les deux questions de l'étape 5 qu'il avait validées le 23/10 (captures 30-33). Deux réponses que tout parent
  // a sans réfléchir, et toutes deux réelles : l'occasion ouvre le message lu à la fin du film, l'expéditeur le signe.
  // L'écran garde son nom interne « loves » (journal, événements Meta et reprises inchangés).
  function renderLoves() {
    var a = adventure();
    var d = S.details || {};
    var occasion = d.occasion !== undefined && d.occasion !== '' ? d.occasion : (OCCASIONS[a.id] ? a.id : 'none');
    var sender = d.sender || '';
    var known = SENDERS.some(function (x) { return x[0] === sender; });
    var isOther = !!sender && !known;
    var rel = sender ? (S.relationship || 'family') : '';
    // Zones « 4 · Occasion » (z_loves) et « 4 · From & button » (z_loves_from) : seuls les mots affichés changent, jamais
    // data-occ / data-from (la signature lue dans le film reste « Grandma » même si le bouton dit autre chose).
    var sub = tx('loves_sub', 'We\'ll add a little extra for {name}\'s big day.'), other = tx('loves_from_other', 'Someone else');
    app.innerHTML =
      '<div class="lp-card">' + progress('loves') + liveTop() +
      '<h2 class="lp-h2 lp-center-text"' + ed('z_loves') + '>' + fillE(tx('loves_title', 'What are we celebrating?')) + '</h2>' +
      (sub ? '<p class="lp-muted lp-center-text"' + ed('z_loves') + '>' + fillE(sub) + '</p>' : '') +
      '<div class="lp-occgrid" role="radiogroup" aria-label="Occasion"' + ed('z_loves') + '>' + OCC_ORDER.map(function (o) {
        var on = o === occasion, ic = tx('loves_occ_' + o + '_icon', OCCASIONS[o][0]), lb = tx('loves_occ_' + o, OCCASIONS[o][1]);
        return ic || lb ? '<button type="button" class="lp-occtile' + (on ? ' is-on' : '') + (o === 'none' ? ' is-wide' : '') + '" data-occ="' + o + '" role="radio" aria-checked="' + on + '">' + (ic ? '<span aria-hidden="true">' + esc(ic) + '</span>' : '') + fillE(lb) + '</button>' : '';
      }).join('') + '</div>' +
      '<p class="lp-label" id="lp-fromlbl"' + ed('z_loves_from') + '>' + fillE(tx('loves_from_title', 'Who\'s the movie from?')) + '</p>' +
      '<div class="lp-senders" role="radiogroup" aria-labelledby="lp-fromlbl"' + ed('z_loves_from') + '>' +
        SENDERS.map(function (x) {
          var on = sender === x[0], lb = tx('loves_from_' + x[0].toLowerCase().replace(/[^a-z]+/g, '_'), x[0]);
          return lb ? '<button type="button" class="lp-chip lp-sender' + (on ? ' is-on' : '') + '" data-from="' + esc(x[0]) + '" data-rel="' + x[1] + '" role="radio" aria-checked="' + on + '">' + fillE(lb) + '</button>' : '';
        }).join('') +
        (other ? '<button type="button" class="lp-chip lp-sender lp-sender-other' + (isOther ? ' is-on' : '') + '" data-from="" data-rel="family" role="radio" aria-checked="' + isOther + '">' + fillE(other) + '</button>' : '') +
      '</div>' +
      '<input class="lp-input lp-fromother" id="lp-fromother" maxlength="40" aria-label="Your name, as your hero says it" placeholder="' + fillE(tx('loves_from_other_ph', 'Your name, as they say it (e.g. Aunt Sarah)')) + '" value="' + esc(isOther ? d.from || '' : '') + '"' + (isOther ? '' : ' hidden') + ed('z_loves_from') + '>' +
      '<p class="lp-error" id="lp-err" role="alert"></p>' +
      '<button type="button" class="lp-btn lp-btn-full" id="lp-next"' + ed('z_loves_from') + '>' + fillE(tx('loves_next', 'Next →')) + '</button>' + dyk('loves') + '</div>';
    startLive();
    var otherInput = document.getElementById('lp-fromother');
    if (isOther) sender = 'other';
    function fromNow() { return sender === 'other' ? otherInput.value.trim().replace(/\s+/g, ' ') : sender; }
    function radio(list, btn) { list.forEach(function (x) { x.classList.toggle('is-on', x === btn); x.setAttribute('aria-checked', String(x === btn)); }); }
    var occBtns = [].slice.call(app.querySelectorAll('[data-occ]'));
    occBtns.forEach(function (b) {
      b.onclick = function () {
        occasion = b.getAttribute('data-occ');
        radio(occBtns, b);
        b.classList.add('lp-pop');
        b.addEventListener('animationend', function () { b.classList.remove('lp-pop'); }, { once: true });
      };
    });
    var senderBtns = [].slice.call(app.querySelectorAll('.lp-sender'));
    senderBtns.forEach(function (b) {
      b.onclick = function () {
        radio(senderBtns, b);
        document.getElementById('lp-err').textContent = '';
        rel = b.getAttribute('data-rel');
        sender = b.getAttribute('data-from') || 'other';
        otherInput.hidden = sender !== 'other';
        if (sender === 'other') otherInput.focus();
      };
    });
    document.getElementById('lp-next').onclick = function () {
      var err = document.getElementById('lp-err');
      var from = fromNow();
      if (!rel) { err.textContent = fill('Please tell us who the movie is from.'); return; }
      if (!from) { err.textContent = fill('Please write your name, as {name} says it.'); otherInput.focus(); return; }
      err.textContent = '';
      S.details = S.details || {};
      // Un autre expéditeur ou une autre occasion : le message proposé repart de la suggestion (sauf texte tapé à la main).
      if (S.details.occasion !== occasion || S.details.from !== from) S.details.msgPick = 0;
      S.details.from = from;
      S.details.sender = sender;
      S.details.occasion = occasion;
      S.relationship = rel;
      save();
      // La relation part au Worker (présélection de l'offre par relation) ; une panne ne bloque pas le parcours.
      if (!S.leadSent || S.leadSent.relationship !== rel) sendLead().catch(function () {});
      go('message', { occasion: occasion, sender: sender });
    };
  }

  // Étape 1 bis : le costume, AVANT la photo. Comme « Pick Noah's adventure » chez StarringYou (rapport A, étape 2) :
  // un choix d'une touche, amusant, avant l'étape qui coûte (la photo d'un enfant) ; la photo gagne une raison
  // (« pour le voir en super-héros ») ; l'aperçu reste UNE génération, lancée à l'envoi de la photo comme avant ; et
  // le choix est journalisé pour tous ceux qui passent l'étape 1, pas seulement ceux qui envoient une photo.
  function renderCostume() {
    var a = adventure();
    var list = costumesOf(a);
    if (!list) return go('photo');
    var cur = costumeOf(a, S.costume);
    var withImages = list.every(function (c) { return !!c.image; });
    var st = a.costume_step || {};
    var retry = !!S.costumeRetry;
    // Zone « 2 · Costume — top » : un champ par film (cos_<film>_…) ; un film sans champ garde le texte du catalogue.
    var title = tx('cos_' + a.id + '_title', st.title || 'Pick {name}\'s costume'), sub = tx('cos_' + a.id + '_sub', st.sub || '');
    var help = retry ? tx('cos_help_retry', 'We\'ll make a new preview of {name} in this costume. It takes 1 to 2 minutes.')
      : tx('cos_help', 'You\'ll see {name} in it for free, before you pay anything.');
    app.innerHTML =
      '<div class="lp-card">' + progress('costume') +
      '<h2 class="lp-h2"' + ed('z_cos') + '>' + fillE(title) + '</h2>' +
      (sub ? '<p class="lp-muted"' + ed('z_cos') + '>' + fillE(pron() === NEUTRAL ? sub : sub.replace(/\{They\} wear\b/g, '{They} wears')) + '</p>' : '') +
      '<div class="lp-costumes' + (withImages ? ' has-img' : '') + '" role="radiogroup" aria-label="Costume"' + ed('z_cos_pick') + '>' +
      list.map(function (c) {
        var on = c.id === cur.id, line = tx('cos_' + c.id + '_line', c.line || ''); // zone « 2 · Costume choices »
        return '<button type="button" class="lp-costume' + (on ? ' is-on' : '') + '" data-costume="' + esc(c.id) + '" role="radio" aria-checked="' + on + '">' +
          (withImages ? '<img src="' + esc(c.image) + '" alt="" loading="lazy">' : '<span class="lp-costume-emoji" aria-hidden="true">' + esc(c.emoji || '✦') + '</span>') +
          '<span class="lp-costume-label">' + esc(tx('cos_' + c.id + '_name', c.label)) + '</span>' +
          (line ? '<span class="lp-costume-line">' + fillE(line) + '</span>' : '') + '</button>';
      }).join('') + '</div>' +
      '<button type="button" class="lp-btn lp-btn-full" id="lp-next"' + ed('z_cos_btn') + '></button>' +
      (help ? '<p class="lp-help lp-center-text"' + ed('z_cos_btn') + '>' + fillE(help) + '</p>' : '') +
      '<button type="button" class="lp-link" id="lp-back"' + ed('z_cos_btn') + '>' + fillE(tx('cos_back', 'Back')) + '</button>' + dyk('costume') + '</div>';
    var next = document.getElementById('lp-next');
    var busy = false;
    function label() { next.textContent = fill(tx('cos_button', 'Continue as a {costume} →'), { costume: cur.label.toLowerCase() }); }
    function choose(c) {
      if (busy) return;
      busy = true;
      cur = c;
      S.costume = c.id;
      save();
      app.querySelectorAll('.lp-costume').forEach(function (b) {
        var on = b.getAttribute('data-costume') === c.id;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', String(on));
      });
      label();
      next.disabled = true;
      publish('costume_pick', { adventure: S.adventure, costume: c.id, preselected: c.id === a.default_costume });
      // Le choix est enregistré avant la photo (c'est lui qui part dans le prompt) ; un Worker qui ne le connaît pas
      // encore ne bloque pas le parcours : l'aperçu prend alors le costume par défaut.
      var saved = api('/api/costume', { method: 'POST', json: { costume: c.id } }).catch(function () {});
      var timeout = new Promise(function (r) { setTimeout(r, 2500); });
      Promise.race([saved, timeout]).then(function () {
        if (S.costumeRetry) { S.costumeRetry = false; S.step = 'preview'; save(); return regen(); }
        go('photo');
      });
    }
    label();
    app.querySelectorAll('.lp-costume').forEach(function (b) {
      b.onclick = function () { choose(costumeOf(a, b.getAttribute('data-costume'))); };
    });
    next.onclick = function () { choose(cur); };
    document.getElementById('lp-back').onclick = function () {
      if (S.costumeRetry) { S.costumeRetry = false; save(); return go('preview'); }
      go('adventure');
    };
  }

  var REASONS = {
    too_small: 'This photo is too small. Please choose a larger one.',
    no_face: 'We couldn\'t find {name}\'s face in this photo. A photo where {their} face is clearly visible works best.',
    several_faces: 'We see more than one face. Please choose a photo with only {name}.',
    blurry: 'This photo is a bit blurry. A sharper one will give a better hero.',
    not_frontal: 'Please choose a photo where {name} looks toward the camera.',
    obstructed: 'Something covers part of {name}\'s face (sunglasses, hat, hand…). Please choose another photo.',
    face_too_small: '{Name}\'s face is too small in this photo. Try a closer one.',
    unsafe: 'This photo can\'t be used. Please choose another one.'
  };

  // Les délais viennent du Worker (/api/catalog → retention) : le texte dit ce que le cron fait vraiment.
  // 03/11 : règle de Paul du 01/11 (« je le répète ») : aucun délai de conservation dans un texte client ; les délais exacts
  // vivent dans la politique de confidentialité. Avant : « we delete it within 24 hours… we keep it for 30 days… ».
  function photoRule() {
    return 'Stored securely, kept for your movie, then permanently deleted.';
  }

  // Contrôle permissif (20/10) : le Worker ne bloque plus que « trop petite » et « aucun visage » ; le reste revient en
  // avertissements. « several_faces » n'est pas affiché : le contrôleur le dit à tort sur des photos d'un seul enfant.
  var SOFT = ['blurry', 'not_frontal', 'obstructed', 'face_too_small', 'no_face_forced'];
  function photoTip() {
    var w = S.photoWarnings || [];
    return SOFT.some(function (k) { return w.indexOf(k) >= 0; }) ? 'Tip: a sharper, front-facing photo gives the best likeness.' : '';
  }

  // Étape 3, refaite le 23/10 ~11 h 40 sur l'étape 3 de StarringYou (Paul, captures 21-22 : « ajoute une photo, laisse
  // l'option de changer la photo, sans trop de détails […] rassure sur le fait que la photo peut être supprimée, mais pas
  // de paragraphes »). Avant : 4 consignes, une case à cocher qui bloquait le bouton, un paragraphe de 60 mots. Maintenant :
  // une zone qui ouvre la photothèque, puis la vignette « Perfect, got it! » avec « Change photo » ; l'accord tient en une
  // phrase (le Worker l'horodate à l'envoi, consent_at). photoThumb : la vignette de cette visite, jamais enregistrée
  // (le localStorage ne garde jamais la photo).
  var photoThumb = null;
  var ICON_CAM = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 8h3l2-2.5h6L17 8h3v11H4z"/><circle cx="12" cy="13" r="3.6"/></svg>';
  function renderPhoto() {
    var ok = !!S.photoOk;
    var mail = CAT.settings.support_email;
    // Zones « 3 · Photo — top » (z_photo), « 3 · Photo — privacy » (z_photo_safe), « 3 · Details & consent » (z_photo_more).
    // {costume} est posé avant fill : realText (Noël) doit voir « turn {name} into a 3D hero. » comme avant.
    var sub = tx('photo_sub', 'One clear photo is all it takes to turn {name} into a 3D {costume}.').replace(/\{costume\}/g, costume() ? costume().label.toLowerCase() : 'hero');
    var doneT = tx('photo_done_title', '✓ Perfect, got it!'), doneS = photoTip() ? tx('photo_done_tip', photoTip()) : tx('photo_done_line', '{Name}\'s 3D hero is on its way.');
    var boxT = tx('photo_box_title', 'Add a photo'), boxS = tx('photo_box_hint', 'Facing the camera, in good light, just {name}'), boxB = tx('photo_box_button', 'Choose a photo');
    var safe = [['🔒', 'Only used to make {name}\'s movie. Never public, never shared, never used to train AI.'], ['🗑️', 'Stored securely, kept for your movie, then permanently deleted.'],
      ['📍', 'Location and hidden data are removed on your phone, before upload.']].map(function (x, i) {
      var ic = tx('photo_safe' + (i + 1) + '_icon', x[0]), t = tx('photo_safe' + (i + 1), x[1]);
      return ic || t ? '<li>' + (ic ? '<i aria-hidden="true">' + esc(ic) + '</i>' : '') + fillE(t, { hours: CAT.retention.photo_no_order_hours }) + '</li>' : '';
    }).join('');
    var safeL = tx('photo_safe_link', 'How we protect your photos →'), lookL = tx('photo_look_label', 'Other details'), lookO = tx('photo_look_opt', '(optional)');
    var cons = tx('photo_consent', 'By adding a photo, you confirm you\'re family or have the parents\' OK. Want it deleted now?'), consL = tx('photo_consent_link', 'Just ask us');
    app.innerHTML =
      '<div class="lp-card">' + progress('photo') +
      '<h2 class="lp-h2 lp-center-text"' + ed('z_photo') + '>' + fillE(tx('photo_title', 'Add a photo of {name}')) + '</h2>' +
      (sub ? '<p class="lp-muted lp-center-text"' + ed('z_photo') + '>' + fillE(sub) + '</p>' : '') +
      (ok
        // Photo déjà envoyée (retour arrière, geste retour du téléphone) : on continue sans la renvoyer ; en changer reste possible.
        ? '<div class="lp-photook"' + ed('z_photo') + '><div class="lp-photook-img" id="lp-thumb">' + (photoThumb ? '<img src="' + photoThumb + '" alt="">' : '<span aria-hidden="true">✓</span>') + '</div>' +
            '<div class="lp-photook-txt">' + (doneT ? '<p class="lp-photook-t">' + fillE(doneT) + '</p>' : '') + (doneS ? '<p class="lp-photook-s">' + fillE(doneS) + '</p>' : '') +
            '<label class="lp-photook-change" for="lp-file">' + fillE(tx('photo_change', 'Change photo')) + '</label></div></div>' +
          '<button type="button" class="lp-btn lp-btn-full" id="lp-next"' + ed('z_photo') + '>' + fillE(tx('photo_next', 'Next →')) + '</button>'
        : '<label class="lp-drop2" for="lp-file" id="lp-drop"' + ed('z_photo') + '><span class="lp-drop2-thumb" id="lp-thumb" hidden></span>' +
            '<span class="lp-drop2-ico">' + ICON_CAM + '</span>' + (boxT ? '<b>' + fillE(boxT) + '</b>' : '') +
            (boxS ? '<small>' + fillE(boxS) + '</small>' : '') +
            (boxB ? '<span class="lp-drop2-btn">' + fillE(boxB) + '</span>' : '') + '</label>' +
          '<label class="lp-btn lp-btn-full" for="lp-file" id="lp-pick"' + ed('z_photo') + '>' + fillE(tx('photo_button', 'Choose a photo')) + '</label>') +
      '<input type="file" id="lp-file" accept="image/*" class="lp-visually-hidden">' +
      '<p class="lp-status" id="lp-status" role="status"></p>' +
      // 28/10 (Paul : « rassurer sur la photo de l'enfant… même une grand-mère de 80 ans ») : 93 vues de l'étape photo pour 77
      // photos (24-28/10). Trois lignes, pas de paragraphe (Paul 23/10) ; chaque phrase est déjà promise sur la page en ligne.
      (safe ? '<ul class="lp-photosafe"' + ed('z_photo_safe') + '>' + safe + '</ul>' : '') +
      (safeL ? '<a class="lp-photosafe-link" href="' + esc(ROOT) + 'pages/how-we-protect-your-photos" target="_blank" rel="noopener"' + ed('z_photo_safe') + '>' + fillE(safeL) + '</a>' : '') +
      (DESIGN && !safe && !safeL ? '<p' + ed('z_photo_safe') + '><span class="lp-dyk-ed">Editor only: « 3 · Photo — privacy » is empty, so it is hidden on the site.</span></p>' : '') +
      // « Autres détails » de StarringYou (30_etape3_photo.png) : lunettes, taches de rousseur… sont ce que le modèle perd le
      // plus souvent ; le texte part au Worker avec les autres choix (/api/details), pour la fiche du héros.
      (lookL || lookO ? '<label class="lp-label" for="lp-look"' + ed('z_photo_more') + '>' + fillE(lookL) + (lookL && lookO ? ' ' : '') + (lookO ? '<span class="lp-opt">' + fillE(lookO) + '</span>' : '') + '</label>' : '') +
      '<textarea class="lp-input" id="lp-look" maxlength="120" rows="2" placeholder="' + fillE(tx('photo_look_ph', 'e.g. freckles, glasses, curly hair…')) + '"' + ed('z_photo_more') + '>' + esc((S.details && S.details.look) || '') + '</textarea>' +
      (cons || consL ? '<p class="lp-privacy"' + ed('z_photo_more') + '>' + (cons ? fillE(cons) + (consL ? ' ' : '') : '') +
        (consL ? (mail ? '<a href="mailto:' + esc(mail) + '?subject=' + encodeURIComponent('Please delete my photo') + '">' + fillE(consL) + '</a>' : fillE(consL)) + '.' : '') + '</p>' : '') +
      dyk('photo') +
      '<button type="button" class="lp-link" id="lp-back"' + ed('z_photo_more') + '>' + fillE(tx('photo_back', 'Back')) + '</button>' +
      '</div>';
    document.getElementById('lp-back').onclick = function () { go(costumesOf(adventure()) ? 'costume' : 'adventure'); };
    var keep = document.getElementById('lp-next');
    if (keep) keep.onclick = function () { go('loves'); };
    var look = document.getElementById('lp-look');
    look.oninput = function () { S.details = S.details || {}; S.details.look = look.value.trim().replace(/\s+/g, ' '); save(); };
    var file = document.getElementById('lp-file');
    file.onchange = function () { if (file.files && file.files[0]) handleFile(file.files[0]); file.value = ''; };
  }

  function setStatus(text, kind) {
    var el = document.getElementById('lp-status');
    if (!el) return;
    el.className = 'lp-status' + (kind ? ' is-' + kind : '');
    el.innerHTML = text;
  }

  // Ré-encodage sur l'appareil : 1 600 px max, JPEG. Le canvas ne recopie aucune métadonnée (EXIF, GPS).
  function prepareImage(fileObj) {
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(fileObj);
      var img = new Image();
      img.onload = function () {
        var w = img.naturalWidth;
        var h = img.naturalHeight;
        var scale = Math.min(1, 1600 / Math.max(w, h));
        var cw = Math.round(w * scale);
        var ch = Math.round(h * scale);
        var canvas = document.createElement('canvas');
        canvas.width = cw;
        canvas.height = ch;
        canvas.getContext('2d').drawImage(img, 0, 0, cw, ch);
        URL.revokeObjectURL(url);
        canvas.toBlob(function (blob) {
          if (!blob) return reject(new Error('encode'));
          resolve({ blob: blob, width: cw, height: ch, preview: canvas.toDataURL('image/jpeg', 0.6) });
        }, 'image/jpeg', 0.9);
      };
      img.onerror = function () { URL.revokeObjectURL(url); reject(new Error('decode')); };
      img.src = url;
    });
  }

  // HEIC choisi sur ordinateur (Chrome, Firefox, Edge ne le décodent pas) : décodeur chargé seulement dans ce cas.
  // Sur iPhone, accept="image/*" fait déjà convertir la photo en JPEG par iOS.
  var HEIC2ANY = 'https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js';
  function isHeic(f) { return /hei[cf]/i.test(f.type || '') || /\.hei[cf]$/i.test(f.name || ''); }
  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var el = document.createElement('script');
      el.src = src; el.async = true; el.onload = resolve; el.onerror = reject;
      document.head.appendChild(el);
    });
  }
  function decodePhoto(fileObj) {
    return prepareImage(fileObj).catch(function (e) {
      if (e.message !== 'decode' || !isHeic(fileObj)) throw e;
      setStatus('Converting the photo…');
      return (window.heic2any ? Promise.resolve() : loadScript(HEIC2ANY))
        .then(function () { return window.heic2any({ blob: fileObj, toType: 'image/jpeg', quality: 0.9 }); })
        .then(function (out) { return prepareImage(Array.isArray(out) ? out[0] : out); })
        .catch(function () { throw new Error('decode'); });
    });
  }

  function upload(blob, onProgress, force) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', API + '/api/photo');
      xhr.setRequestHeader('content-type', 'image/jpeg');
      xhr.setRequestHeader('x-lp-session', S.sid + '.' + S.secret);
      xhr.setRequestHeader('x-lp-consent', '1');
      if (force) xhr.setRequestHeader('x-lp-force', '1'); // « Use this photo anyway » : seul « aucun visage » se force
      xhr.upload.onprogress = function (e) { if (e.lengthComputable) onProgress(e.loaded / e.total); };
      xhr.onload = function () {
        var data = {};
        try { data = JSON.parse(xhr.responseText || '{}'); } catch (e) { /* vide */ }
        if (xhr.status >= 200 && xhr.status < 300) resolve(data);
        else { var err = new Error(data.error || 'http_' + xhr.status); err.status = xhr.status; err.code = data.error; reject(err); }
      };
      xhr.onerror = function () { var err = new TypeError('Failed to fetch'); reject(err); };
      xhr.send(blob);
    });
  }

  // 24/10 ~11 h 30 (Paul, capture 48 : « quand on upload, même si le chargement est court, fais en sorte que ça fasse
  // vraiment un truc de chargement qu'on voit ») : la photo choisie est « scannée » à l'écran (une ligne qui balaie, le
  // cadre du visage, 3 étapes qui se cochent), au moins 0,9 s par étape même quand l'envoi va plus vite. Les étapes disent
  // ce que fait vraiment le Worker à l'envoi (visage, flou, taille : REASONS) ; l'aperçu, lui, part dès la réponse.
  // 01/11 (Paul : « on a l'impression qu'on scanne le ciel ») : plus de cadre du visage. Il était fixe (haut-centre) et
  // assombrissait le reste, donc il tombait sur le ciel dès que l'enfant n'était pas en haut au centre. Reste la ligne qui balaie.
  var SCAN_STEPS = ['Uploading {name}\'s photo', 'Finding {name}\'s face', 'Checking light and sharpness'];
  var SCAN_MIN = 900;
  function scanner(thumb) {
    var t0 = Date.now(), k = 0, pct = 0;
    var steps = SCAN_STEPS.map(function (x, i) { return tx('photo_scan' + (i + 1), x); }); // zone « 3 · Photo — top »
    var big = !!(thumb && thumb.closest && thumb.closest('.lp-drop2'));
    if (thumb) {
      thumb.insertAdjacentHTML('beforeend', '<span class="lp-scan" aria-hidden="true"><i></i></span>' + (big ? '<span class="lp-scanbox" id="lp-scanbox"></span>' : ''));
      if (big) thumb.closest('.lp-drop2').classList.add('is-scanning');
    }
    function paint() {
      var box = document.getElementById('lp-scanbox');
      if (box) {
        box.innerHTML = '<ol class="lp-scanlist">' + steps.map(function (s, i) {
          return '<li class="' + (i < k ? 'is-done' : i === k ? 'is-on' : '') + '">' + fillE(s) + (i === 0 && k === 0 && pct > 0 ? ' · ' + pct + '%' : '') + '</li>';
        }).join('') + '</ol>';
        setStatus('');
      } else setStatus(k < steps.length ? fillE(steps[k]) + '…' + (k === 0 && pct > 0 ? ' ' + pct + '%' : '') : fillE(tx('photo_done_title', '✓ Perfect, got it!')), k < steps.length ? '' : 'ok');
    }
    paint();
    return {
      progress: function (p) { pct = Math.round(p * 100); if (k === 0) paint(); },
      // ok : les étapes 2 et 3 se cochent, puis tout est vert ; sinon on s'arrête sur l'étape 2 (le contrôle a dit non).
      finish: function (ok) {
        var seq = ok ? [1, 2, 3] : [1];
        return new Promise(function (resolve) {
          (function next(wait) {
            setTimeout(function () {
              k = seq.shift();
              paint();
              if (seq.length) next(SCAN_MIN); else setTimeout(resolve, ok ? 450 : SCAN_MIN);
            }, wait);
          })(Math.max(0, SCAN_MIN - (Date.now() - t0)));
        });
      },
      stop: function () {
        [].forEach.call(document.querySelectorAll('.lp-scan, .lp-scanbox'), function (el) { el.remove(); });
        var d = document.querySelector('.lp-drop2.is-scanning');
        if (d) d.classList.remove('is-scanning');
      }
    };
  }
  function handleFile(fileObj) {
    // Le bouton « Choose a photo » n'existe qu'avant le premier envoi ; ensuite on change de photo depuis la vignette.
    var pick = document.getElementById('lp-pick') || document.createElement('label');
    var sc = null;
    pick.classList.add('is-busy');
    setStatus('Preparing the photo…');
    decodePhoto(fileObj).then(function (img) {
      var thumb = document.getElementById('lp-thumb');
      thumb.hidden = false;
      thumb.innerHTML = '<img src="' + img.preview + '" alt="">';
      if (Math.min(img.width, img.height) < 300) { // même seuil que le Worker (MIN_SIDE)
        pick.classList.remove('is-busy');
        pick.textContent = 'Choose another photo';
        return setStatus(fillE(REASONS.too_small), 'err');
      }
      return send(img, false);
    }).catch(fail);
    function send(img, force) {
      pick.classList.add('is-busy');
      if (sc) sc.stop();
      sc = scanner(document.getElementById('lp-thumb'));
      return upload(img.blob, function (p) { sc.progress(p); }, force)
        .then(function (res) {
          if (res.ok) {
            S.preview = { state: 'queued', startedAt: Date.now() };
            S.photoOk = true;
            S.photoWarnings = res.warnings || [];
            save();
            publish('photo_ok', { adventure: S.adventure, arm: S.arm, forced: !!force });
            startPolling();
            photoThumb = img.preview;
          }
          return sc.finish(res.ok).then(function () { return res; });
        })
        .then(function (res) {
          pick.classList.remove('is-busy');
          if (!res.ok) {
            sc.stop();
            pick.textContent = 'Choose another photo';
            var reasons = res.reasons || [];
            var msgs = reasons.map(function (r) { return fillE(REASONS[r] || 'Please choose another photo.'); });
            var forceable = reasons.length > 0 && reasons.every(function (r) { return r === 'no_face'; });
            setStatus(msgs.slice(0, 2).join('<br>') + (forceable ? '<button type="button" class="lp-link lp-force" id="lp-force">Use this photo anyway</button>' : ''), 'err');
            var fb = document.getElementById('lp-force');
            if (fb) fb.onclick = function () { send(img, true).catch(fail); };
            return;
          }
          // Comme StarringYou (31_etape3_photo_ajoutee.png) : la vignette « Perfect, got it! » reste à l'écran, avec
          // « Change photo » ; le parent avance quand il veut (avant : passage seul à l'écran suivant au bout de 0,7 s).
          if (S.step === 'photo') renderPhoto();
        });
    }
    function fail(e) {
      if (sc) sc.stop();
      pick.classList.remove('is-busy');
      pick.textContent = 'Choose another photo';
      if (e.message === 'decode' || e.message === 'encode' || e.code === 'jpeg_only' || e.code === 'corrupt_image') return setStatus('We couldn\'t read this photo. Please try another one.', 'err');
      setStatus(esc(friendly(e)), 'err');
    }
  }

  // ------------------------------------------------------------ aperçu : sondage de l'état réel
  function startPolling() {
    if (DEMO) return;
    stopPolling();
    pollTimer = setInterval(pollOnce, 2500);
    pollOnce();
  }
  function stopPolling() { if (pollTimer) { clearInterval(pollTimer); pollTimer = null; } }
  // 30/10 (Paul, capture 1) : les liens d'images du Worker expirent au bout de 6 h (MEDIA_URL_TTL_SECONDS, puis 410). Un
  // onglet resté ouvert les gardait : affiche noire, vignette « The cast » cassée. Avant l'aperçu et l'offre, des liens neufs
  // s'ils expirent dans moins de 10 min ; une demande par minute au plus (sans réseau, l'écran s'affiche avec ce qu'on a).
  var linksAskedAt = 0;
  function linkExp(u) { var m = /[?&]e=(\d+)/.exec(u || ''); return m ? Number(m[1]) * 1000 : Infinity; }
  function freshLinks(then) {
    var p = S.preview || {};
    if (p.state !== 'done' || Math.min(linkExp(p.url), linkExp(p.poster), linkExp(p.anim)) > Date.now() + 600000 || Date.now() - linksAskedAt < 60000) return false;
    linksAskedAt = Date.now();
    app.innerHTML = '<div class="lp-card lp-center"><div class="lp-spinner" aria-hidden="true"></div></div>';
    api('/api/preview').then(function (q) {
      S.preview = {
        state: q.state, url: q.image_url || null, anim: q.anim_url || null, anim_state: q.anim_state,
        poster: q.poster_url || null, poster_state: q.poster_state,
        regen_left: q.regen_left, can_regen: q.can_regen, error: q.error, startedAt: p.startedAt || Date.now()
      };
      save();
    }).catch(function () { /* l'écran s'affiche avec les liens qu'on a */ }).then(then);
    return true;
  }
  function pollOnce() {
    api('/api/preview').then(function (p) {
      var prev = S.preview || {};
      S.preview = {
        state: p.state, url: p.image_url || null, anim: p.anim_url || null, anim_state: p.anim_state,
        poster: p.poster_url || null, poster_state: p.poster_state,
        regen_left: p.regen_left, can_regen: p.can_regen, error: p.error, startedAt: prev.startedAt || Date.now()
      };
      save();
      var animPending = p.anim_state === 'queued' || p.anim_state === 'running' || p.poster_state === 'queued' || p.poster_state === 'running';
      if ((p.state === 'done' && !animPending) || p.state === 'failed' || p.state === 'none') stopPolling();
      if (S.step === 'loves' || S.step === 'message') updateLiveStatus();
      if (S.step === 'offer' && S.preview.poster && !prev.poster) swapOfferPoster();
      if (S.step === 'preview') {
        if (prev.state === 'done' && p.state === 'done' && !app.querySelector('[data-lp-wait]')) { swapPoster(); swapAnim(); }
        else renderPreview();
      }
    }).catch(function () { /* on réessaie au prochain tour */ });
  }

  // L'image 3D s'affiche d'abord ; la version animée (5 s) la remplace dès qu'elle est prête, sans bloquer l'écran.
  function swapAnim() {
    var box = document.getElementById('lp-heromedia');
    if (!box || !S.preview || !S.preview.anim || box.getAttribute('data-anim') || box.getAttribute('data-poster')) return; // l'affiche reste
    box.setAttribute('data-anim', 'pending'); // un seul chargement, même si le sondage repasse entre-temps
    var v = document.createElement('video');
    v.src = S.preview.anim;
    // Pas de poster ni de prénom : Clarity les copie tels quels (02/11) ; la vidéo ne remplace l'image qu'une fois prête.
    v.muted = true;
    v.loop = true;
    v.autoplay = true;
    v.setAttribute('playsinline', '');
    v.setAttribute('aria-label', '3D animated hero');
    v.oncanplay = function () {
      v.oncanplay = null; // « canplay » repart à chaque boucle de la vidéo
      box.innerHTML = '';
      box.appendChild(v);
      box.setAttribute('data-anim', '1');
      v.play().catch(function () {});
      track('anim_shown', {}, 4);
    };
    v.load();
  }

  // Attente : 7 étapes nommées qui se cochent sur l'horloge de la barre (grammaire StarringYou « Sketching Paulo's face… 2/7 »,
  // Paul 21/10). Chaque étape décrit ce que l'aperçu fait vraiment : photo → visage 3D → costume → scène → mouvement → voix au prénom.
  function liveSteps() {
    var c = costume();
    return [tx('wait_step1', 'Studying {name}\'s photo'), tx('wait_step2', 'Sketching {name}\'s face in 3D'),
      c ? tx('wait_step3_costume', 'Fitting {name}\'s {costume} costume').split('{costume}').join(c.label.toLowerCase()) : tx('wait_step3', 'Choosing {name}\'s hero outfit'),
      tx('wait_step4', 'Lighting {name}\'s first scene'), tx('wait_step5', 'Bringing {name} to life'), tx('wait_step6', 'Teaching the narrator to say {Name}'), tx('wait_step7', 'Final touches')];
  }
  function liveStepAt(pct) { return Math.min(6, Math.floor(pct / 92 * 7)); }
  function liveStepsHtml() {
    return '<ol class="lp-livesteps" id="lp-livesteps"' + ed('z_wait') + '>' + liveSteps().map(function (s) { return '<li>' + fillE(s) + '</li>'; }).join('') + '</ol>';
  }
  function liveStatusHtml() {
    var p = S.preview || {}, z = curScreen() === 'message' ? ed('z_msg') : '';
    if (p.state === 'done') return '<div class="lp-live is-done"' + z + '>' + fillE(tx('msg_live_done', '✓ {Name}\'s 3D hero is ready!')) + '</div>';
    if (p.state === 'failed') return '<div class="lp-live is-err"' + z + '>' + fillE(tx('msg_live_failed', 'We hit a snag creating {name}\'s hero. You can try again on the next screen.')) + '</div>';
    var eta = tx('msg_live_eta', '{Name}\'s 3D hero · 1 to 2 minutes');
    return '<div class="lp-live"' + z + '><span class="lp-dot"></span><span id="lp-livestep">' + fillE(liveSteps()[0]) + '… 1/7</span><b class="lp-live-pct" id="lp-livepct">0%</b>' +
      '<div class="lp-live-bar"><div id="lp-livebar"></div></div>' + (eta ? '<span class="lp-live-eta">' + fillE(eta) + '</span>' : '') + '</div>';
  }
  function updateLiveStatus() {
    var el = document.getElementById('lp-livewrap');
    if (el) el.innerHTML = liveStatusHtml();
    tickProgress();
  }
  function tickProgress() {
    stopProgress();
    var bar = document.getElementById('lp-livebar');
    if (!bar) return;
    var start = (S.preview && S.preview.startedAt) || Date.now();
    var step = function () {
      var b = document.getElementById('lp-livebar');
      if (!b) return stopProgress();
      // 23/10 ~14 h (Paul : « que le chargement avance plus vite ») : rapide d'abord (30 % à 10 s, 58 % à 25 s, 80 % à 50 s),
      // puis lent ; plafond 92 % : jamais 100 % avant la fin réelle (chaîne E : 13-34 s + 36-43 s au banc).
      var pct = 92 * (1 - Math.exp(-(Date.now() - start) / 25000));
      b.style.width = pct.toFixed(0) + '%';
      var pe = document.getElementById('lp-livepct');
      if (pe) pe.textContent = pct.toFixed(0) + '%';
      var k = liveStepAt(pct), steps = liveSteps();
      var cur = document.getElementById('lp-livestep');
      if (cur) cur.textContent = fill(steps[k]) + '… ' + (k + 1) + '/' + steps.length;
      var ol = document.getElementById('lp-livesteps');
      if (ol) Array.prototype.forEach.call(ol.children, function (li, n) { li.className = n < k ? 'is-done' : n === k ? 'is-on' : ''; });
    };
    step();
    progressTimer = setInterval(step, 1000);
  }
  function stopProgress() { if (progressTimer) { clearInterval(progressTimer); progressTimer = null; } }

  // ------------------------------------------------------------ pendant la génération
  // GPT Image 2 met 57 à 101 s au banc : les écrans « ce qu'il adore » et l'occasion couvrent l'attente.
  // 23/10 ~14 h (Paul : « chargement plus visible », « toutes les vidéos d'attente = des réactions d'enfants ») : la vidéo
  // en 9:16 à gauche, l'état et le pourcentage à droite. Sans badge costume : la vidéo montre un autre enfant que le héros.
  function liveTop() { return '<div class="lp-livebox">' + sceneHtml('lp-scene-sm', '') + '<div id="lp-livewrap">' + liveStatusHtml() + '</div></div>'; }
  function startLive() {
    tickProgress();
    if (S.preview && (S.preview.state === 'queued' || S.preview.state === 'running') && !pollTimer) startPolling();
  }

  // Le message de fin. Effet réel : le narrateur le lit à voix haute à la fin du film (J_prod/tools/fabriquer_commande.py →
  // ligne_message) puis il s'affiche sur la carte « A message for {NAME} ». Jamais « Love, Mom » dans le texte : la signature
  // est dite et affichée à part. ≤ 120 caractères (le Worker coupe à 140), deux phrases au moins : le film coupe le message à
  // la phrase la plus proche du milieu. 23/10 ~14 h : plus d'écran « What should {name} always remember? » (Paul) ; le texte
  // proposé d'office est celui du courage (l'amour pour Noël), modifiable dans le champ.
  // Les messages : research/funnel_2310/PATTERNS_tunnels_concurrents_2310.txt §5, repris en deux phrases et sans
  // « superpower » (cadrage super-héros, ETUDES_4_BENEFICES). Ils changent selon qui offre (aucun des 23 messages par défaut
  // relevés chez les concurrents ne le fait) et relient le film à la vraie vie. t = [voix « I », voix « we »] ; for = ceux
  // qui le voient en premier ; only = réservé à ces expéditeurs ; role = dit « your mom / your grandparents… ».
  var ROLES = { 'Mom': 'mom', 'Dad': 'dad', 'Grandma': 'grandma', 'Grandpa': 'grandpa', 'Mom & Dad': 'parents', 'Grandma & Grandpa': 'grandparents' };
  var MESSAGES = {
    brave: [
      { t: ['You were so brave in your movie, {Name}. I see that same brave heart every single day.', 'You were so brave in your movie, {Name}. We see that same brave heart every single day.'], for: ['Mom', 'Grandma'] },
      { t: ['Hey {Name}, heroes get scared too. They just go anyway. So proud of you, kiddo.'], for: ['Dad'] },
      { t: ['{Name}, you were the bravest hero in your movie. I couldn\'t be any prouder of you!', '{Name}, you were the bravest hero in your movie. We couldn\'t be any prouder of you!'], for: ['Mom & Dad'] },
      { t: ['{Name}, I\'ve met a lot of heroes in my life. You\'re my favorite one.', '{Name}, we\'ve met a lot of heroes in our lives. You\'re our favorite one.'], for: ['Grandpa', 'Grandma & Grandpa'] }
    ],
    kind: [
      { t: ['{Name}, your kind heart makes me so proud. I\'m so lucky to be your {role}.', '{Name}, your kind heart makes us so proud. We\'re so lucky to be your {role}.'], for: ['Mom', 'Dad'], role: true },
      { t: ['{Name}, your kindness makes my heart smile. Never lose that sweet heart of yours.', '{Name}, your kindness makes our hearts smile. Never lose that sweet heart of yours.'], for: ['Grandma', 'Grandpa'] },
      { t: ['{Name}, being kind is the bravest thing of all. I see it in you every day.', '{Name}, being kind is the bravest thing of all. We see it in you every day.'], for: ['Mom & Dad'] },
      { t: ['{Name}, the world is a better place with your kind heart in it. Never change!'], for: ['Grandma & Grandpa'] }
    ],
    helping: [
      { t: ['{Name}, the best heroes help their friends. You do that every day. So proud of you.'], for: ['Dad'] },
      { t: ['You saved the day in your movie, {Name}. And every day, you make our home brighter.'], for: ['Mom', 'Mom & Dad'], only: ['Mom', 'Dad', 'Mom & Dad'] },
      { t: ['{Name}, a true hero lends a hand to others. You make me so proud.', '{Name}, a true hero lends a hand to others. You make us so proud.'], for: ['Grandpa'] },
      { t: ['{Name}, you have the biggest heart. Thank you for being such a great helper.'], for: ['Grandma', 'Grandma & Grandpa'] }
    ],
    believe: [
      { t: ['{Name}, you can do hard things. Try, try again. I\'ll be cheering for you every time.', '{Name}, you can do hard things. Try, try again. We\'ll be cheering for you every time.'], for: ['Mom', 'Mom & Dad'] },
      { t: ['{Name}, when things get tricky, remember this movie. You\'ve got what it takes.'], for: ['Dad'] },
      { t: ['{Name}, I\'ve believed in you since the day you were born. Now it\'s your turn!', '{Name}, we\'ve believed in you since the day you were born. Now it\'s your turn!'], for: ['Grandma', 'Grandpa'] },
      { t: ['Dream big, {Name}! I\'ll be cheering for you every step of the way.', 'Dream big, {Name}! We\'ll be cheering for you every step of the way.'], for: ['Grandma & Grandpa'] }
    ],
    loved: [
      { t: ['{Name}, no matter how big you grow, you\'ll always fit right here in my arms. I love you!', '{Name}, no matter how big you grow, you\'ll always fit right here in our arms. We love you!'], for: ['Mom', 'Dad'] },
      { t: ['{Name}, my favorite story will always be the one you\'re in. I love you so much!', '{Name}, our favorite story will always be the one you\'re in. We love you so much!'], for: ['Grandma', 'Grandma & Grandpa'] },
      { t: ['{Name}, wherever you go, you\'ll always be my little star. I love you to pieces!', '{Name}, wherever you go, you\'ll always be our little star. We love you to pieces!'], for: ['Grandpa'] },
      { t: ['{Name}, you\'re the star of my story too. I love you more than all the stars.', '{Name}, you\'re the star of our story too. We love you more than all the stars.'], for: ['Mom & Dad'] }
    ]
  };
  // 24/10 (Paul : « ajoute des messages préfaits… pour aider les parents, 2 ou 3 mais vraiment deep ») : trois vérités qu'un
  // parent pense sans les écrire — aimé sans condition, le temps qui passe, le jour où il est arrivé (« arrived » et non
  // « born » : vrai aussi pour un enfant adopté). Pour tous les expéditeurs ; t = [voix « I », voix « we »].
  // 30/10 : la 1re carte dit son âge (« Only 4 »), donnée qu'on a et que personne d'autre n'écrirait ; elle absorbe « too big
  // for my lap ».
  MESSAGES.deep = [
    { k: 'sugg_deep1', t: ['Only {age}, and already my hero. One day you\'ll be too big for my lap, never for my heart.', 'Only {age}, and already our hero. One day you\'ll be too big for our laps, never for our hearts.'], for: [] },
    { k: 'sugg_deep2', t: ['{Name}, you don\'t have to be brave or perfect for me to love you. I love you just because you\'re you.', '{Name}, you don\'t have to be brave or perfect for us to love you. We love you just because you\'re you.'], for: [] },
    { k: 'sugg_deep3', t: ['{Name}, the day you arrived, my whole world changed. You are the best thing that ever happened to me.', '{Name}, the day you arrived, our whole world changed. You are the best thing that ever happened to us.'], for: [] }
  ];
  // Occasions (Paul, 23/10 ; calque de StarringYou étape 5). Effet réel : la formule ouvre le message lu à la fin du film.
  var OCCASIONS = {
    birthday: ['🎂', 'Birthday', 'Happy birthday, {Name}!'],
    christmas: ['🎄', 'Christmas', 'Merry Christmas, {Name}!'],
    halloween: ['🎃', 'Halloween', 'Happy Halloween, {Name}!'],
    school: ['🎒', 'Back to school', 'Have the best school year, {Name}!'],
    baby: ['👶', 'New baby', 'Hooray for the new big {sibling}, {Name}!'],
    proud: ['🏆', 'Proud moment', 'Way to go, {Name}!'],
    none: ['💛', 'Just because', '']
  };
  var OCC_ORDER = ['birthday', 'christmas', 'halloween', 'school', 'baby', 'proud', 'none'];
  function occLine(o) { var x = OCCASIONS[o]; return x && x[2] ? tx('sugg_open_' + o, x[2]) : ''; }
  function manySenders(from) { return /&|\band\b|family|parents|grandparents/i.test(from || ''); }
  // sender = le choix de l'étape 1 (il décide quels messages passent en premier) ; from = la signature, peut-être retouchée
  // (« Nana ») : elle ne décide que de la voix, I ou we. Taper « Nana » ne fait donc pas sauter le message ; seul « your mom »
  // disparaît, puisqu'il ne collerait plus à la signature.
  function messagesFor(valueId, sender, from) {
    var voice = manySenders(from) ? 1 : 0;
    var list = (MESSAGES[valueId] || MESSAGES.brave).filter(function (m) { return (!m.only || m.only.indexOf(sender) >= 0) && (!m.role || (ROLES[sender] && from === sender)); });
    list.sort(function (a, b) { return (b.for.indexOf(sender) >= 0) - (a.for.indexOf(sender) >= 0); });
    return list.map(function (m) { var t = m.k ? [tx(m.k, m.t[0]), tx(m.k + '_we', m.t[1])] : m.t; return (t[voice] || t[0]).replace('{role}', ROLES[sender] || ''); });
  }
  // Avec une occasion, le prénom est déjà dans « Happy birthday, Tom! » : on l'enlève du message pour ne pas le dire deux fois.
  function dropName(t) { return /^(Hey )?\{Name\}, /.test(t) ? cap(t.replace(/^(Hey )?\{Name\}, /, '')) : t.replace(/, \{Name\}/, ''); }
  // La première passion touchée à l'écran « What makes {name} smile? » s'accole au prénom (« Mason, my little dinosaur
  // fan, … ») : c'est ce qui rend vraie la phrase de cet écran. Abandonnée si le message dépasserait 120 caractères.
  var LOVE_TAGS = { soccer: 'soccer star', drawing: 'artist', singing: 'singer', dancing: 'dancer', dinosaurs: 'dinosaur fan',
    unicorns: 'unicorn lover', cars: 'race-car driver', space: 'astronaut', mermaids: 'mermaid lover', superheroes: 'superhero',
    animals: 'animal lover', building: 'master builder' };
  // Deux longueurs : « my little dinosaur fan », puis « my dinosaur fan » (le message par défaut, courage + anniversaire,
  // fait 124 caractères avec la forme longue).
  function loveTags(from) {
    var first = S.loves && S.loves.list && S.loves.list[0];
    if (!LOVE_TAGS[first]) return [];
    var my = manySenders(from) ? 'our' : 'my';
    return [', ' + my + ' little ' + LOVE_TAGS[first], ', ' + my + ' ' + LOVE_TAGS[first]];
  }
  // 24/10 ~11 h 30 (Paul, capture 50 : « le message doit avoir un sens avec l'occasion style Christmas… fais que le mec se
  // dise : ok, il est parfait, le message ») : le message proposé d'office est écrit pour l'occasion choisie à l'étape 4 :
  // sa formule, puis une phrase qui lui est propre. Exemple : « Merry Christmas, Mason! You're the best gift I ever got. »
  // t = [« I », « we »]. ≤ 120 caractères ; sans occasion (« Just because ») : les mots « deep ». Le trait de caractère
  // (« {Name} is… ») est parti avec l'ancienne étape 4 (Paul, 24/10 ~12 h 20).
  var MSG_OCC = {
    birthday: ['Every year with you is a gift.'],
    christmas: ['You\'re the best gift I ever got.', 'You\'re the best gift we ever got.'],
    halloween: ['No costume could hide how special you are.'],
    school: ['I\'ll be cheering for you every single day.', 'We\'ll be cheering for you every single day.'],
    baby: ['The new baby is so lucky to have you.'],
    proud: ['I\'m proud of you today and always.', 'We\'re proud of you today and always.']
  };
  // 30/10 (Paul : « le message est complètement naze… pas assez personnalisé ») : la carte « Written for » relie le héros du
  // film à l'enfant réel, dans la voix de l'expéditeur. Lu à la fin, juste après l'aventure : le parent dit « ce héros,
  // c'est toi », le ressort même du produit (« Kids grow into the hero they see »). Ce que l'enfant fait dans la saison,
  // tiré des scripts (F_film/FILM_*_v1.txt). t = [voix « I », voix « we »].
  var MSG_BRIDGE = {
    dino: ['So brave and so kind with your dino friends. That\'s the {Name} I see every day.',
      'So brave and so kind with your dino friends. That\'s the {Name} we see every day.'],
    halloween: ['So brave in the dark, so kind to every friend on Hollow Hill. That\'s the {Name} I see every day.',
      'So brave in the dark, so kind to every friend on Hollow Hill. That\'s the {Name} we see every day.']
  };
  // 03/11 : bloc « 5 · Suggested messages » : formule de l'occasion (sugg_open_*), 1re carte (sugg_<film>, sinon sugg_occ_*),
  // cartes 2 à 4 (sugg_deep*, clé k) ; _we = voix « we » (vide = la voix « I ») ; une carte vidée est cachée.
  function personalMessage(occasion, from) {
    var br = MSG_BRIDGE[S.adventure], many = manySenders(from), open = occLine(occasion);
    if (br) {
      var k = 'sugg_' + S.adventure, line = (many && tx(k + '_we', br[1])) || tx(k, br[0]);
      if (!line) return null;
      if (!open) return fill(line);
      var pre0 = open.replace('{sibling}', { boy: 'brother', girl: 'sister' }[(S.hero || {}).gender] || 'sibling');
      var out = [pre0, pre0.replace(', {Name}', ''), ''].map(function (x) { return fill((x ? x + ' ' : '') + line); }).filter(function (x) { return x.length <= 120; })[0];
      return out || fill(line);
    }
    var mo = MSG_OCC[occasion];
    if (!mo) return null;
    var ko = 'sugg_occ_' + occasion, close = (many && mo[1] && tx(ko + '_we', mo[1])) || tx(ko, mo[0]);
    if (!close) return null;
    var pre = open.replace('{sibling}', { boy: 'brother', girl: 'sister' }[(S.hero || {}).gender] || 'sibling');
    var full = fill((pre ? pre + ' ' : '') + close);
    return full.length <= 120 ? full : fill(pre.replace(', {Name}', '') + ' ' + close);
  }
  // Les cartes de l'étape 5 : 0 = le message écrit pour l'enfant, 1 à 3 = les mots « deep », précédés de l'occasion.
  function cardMessage(n, occasion, from, sender) {
    var mine = n === 0 && personalMessage(occasion, from);
    return mine || composeMessage('deep', occasion, from, Math.max(0, n - 1), sender);
  }
  function composeMessage(valueId, occasion, from, n, sender) {
    var list = messagesFor(valueId, sender === undefined ? from : sender, from);
    var t = list[(n || 0) % list.length];
    if (!t) return '';
    var tags = []; // 24/10 (Paul) : les passions n'entrent plus dans le message (loveTags n'est plus appelé).
    var open = occLine(occasion);
    var i, loved;
    if (!open) {
      for (i = 0; i < tags.length; i++) { loved = fill(t.replace('{Name}', '{Name}' + tags[i])); if (loved.length <= 120) return loved; }
      return fill(t);
    }
    var pre = open.replace('{sibling}', { boy: 'brother', girl: 'sister' }[(S.hero || {}).gender] || 'sibling');
    for (i = 0; i < tags.length; i++) { loved = fill(pre.replace('{Name}', '{Name}' + tags[i]) + ' ' + dropName(t)); if (loved.length <= 120) return loved; }
    var out = fill(pre + ' ' + dropName(t));
    if (out.length > 120) out = fill(pre.replace(', {Name}', '') + ' ' + dropName(t)); // prénom très long
    return out.length > 120 ? fill(t) : out;
  }

  // Étape 5 : le message, calqué sur l'étape 5 de StarringYou (50_etape5_occasion.png). 23/10 ~14 h (Paul : « le parent
  // tape plutôt son message dans un champ simple ») : un champ rempli d'office, et la première part au plus tôt (mode
  // « asap », livraison sous 24 h). 24/10 ~12 h 20 : l'occasion et l'expéditeur sont passés à l'étape 4 ; le message
  // proposé en découle (« Merry Christmas, Mason! … », signé de la voix « I » ou « we »).
  function renderMessage() {
    var d = S.details || {};
    if (!d.from) return go('loves'); // reprise d'un parcours d'avant le 24/10 arrêté avant l'expéditeur
    var occasion = d.occasion || 'none';
    var sender = d.sender || d.from;
    var from = d.from;
    var edited = !!(d.msgEdited && d.message);
    var pick = d.msgV === 2 ? Number(d.msgPick) || 0 : 0;
    // 03/11 : bloc « 5 · Message » : titre, phrase, « Your words », bouton et encart du héros (relié ici seulement, pas à l'étape 4).
    var lead = tx('msg_lead', 'At the end of the movie, the narrator reads it to {name}, from {from}.'), help = tx('sugg_label', 'Need the right words? Tap one:');
    app.innerHTML =
      '<div class="lp-card">' + progress('message') + liveTop() +
      '<h2 class="lp-h2 lp-center-text"' + ed('z_msg') + '>' + fillE(tx('msg_title', 'Your message for {name}')) + '</h2>' +
      (lead ? '<p class="lp-muted lp-center-text"' + ed('z_msg') + '>' + fillE(lead, { from: from }) + '</p>' : '') +
      '<div class="lp-msghead"' + ed('z_msg') + '><label class="lp-label" for="lp-msg">' + fillE(tx('msg_label', 'Your words')) + '</label><span class="lp-opt" id="lp-count"></span></div>' +
      '<textarea class="lp-input lp-msgbox" id="lp-msg" maxlength="120" rows="3"></textarea>' +
      (help ? '<p class="lp-label"' + ed('z_sugg') + '>' + fillE(help) + '</p>' : '') +
      '<div class="lp-deeps"' + ed('z_sugg') + '>' + [0].concat(MESSAGES.deep.map(function (m, i) { return i + 1; })).map(function (i) { return '<button type="button" class="lp-deep' + (i ? '' : ' is-mine') + '" data-deep="' + i + '"></button>'; }).join('') + '</div>' +
      '<p class="lp-error" id="lp-err" role="alert"></p>' +
      '<button type="button" class="lp-btn lp-btn-full" id="lp-next"' + ed('z_msg') + '>' + fillE(tx('msg_button', 'See {name}\'s preview →')) + '</button>' +
      dyk('message') +
      '</div>';
    startLive();
    var msgEl = document.getElementById('lp-msg');
    function count() { document.getElementById('lp-count').textContent = msgEl.value.length + '/120'; }
    // Les cartes montrent les messages dans la voix de l'expéditeur ; la carte gardée est celle du champ. La carte 0
    // (écrite pour l'occasion) disparaît sans occasion : elle répéterait la carte 1.
    var deepBtns = [].slice.call(app.querySelectorAll('.lp-deep'));
    var mine = personalMessage(occasion, from), tag = tx('sugg_tag', '✨ Written for {name}');
    function shown(i) { return !(i === 0 && !mine) && !!cardMessage(i, occasion, from, sender); }
    function eff() {
      var p = pick === 0 && !mine ? 1 : pick;
      if (!shown(p)) for (var i = 0; i < deepBtns.length; i++) if (shown(i)) { p = i; break; }
      return p;
    }
    function paintDeeps() {
      var p = eff();
      deepBtns.forEach(function (b, i) {
        b.hidden = !shown(i);
        b.innerHTML = (i === 0 && tag ? '<small class="lp-deep-tag">' + fillE(tag) + '</small>' : '') + esc(cardMessage(i, occasion, from, sender));
        var on = !edited && i === p;
        b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', String(on));
      });
    }
    function recompose() {
      if (!edited) { msgEl.value = cardMessage(eff(), occasion, from, sender); count(); }
      paintDeeps();
    }
    deepBtns.forEach(function (b) {
      b.onclick = function () { edited = false; pick = Number(b.getAttribute('data-deep')); recompose(); };
    });
    msgEl.value = edited ? d.message : '';
    if (edited) count(); else recompose();
    msgEl.oninput = function () { edited = msgEl.value.trim() !== ''; count(); paintDeeps(); };
    document.getElementById('lp-next').onclick = function () {
      var err = document.getElementById('lp-err');
      if (!msgEl.value.trim()) { edited = false; recompose(); }
      err.textContent = '';
      S.details.message = msgEl.value.trim().replace(/\s+/g, ' ');
      S.details.msgEdited = edited;
      S.details.msgPick = eff();
      S.details.msgV = 2;
      S.details.premiere_mode = 'asap';
      save();
      var btn = this;
      btn.disabled = true;
      // Les choix de personnalisation partent ici (le Worker range from / message / premiere ; il ignore encore gender,
      // interests, color, occasion, look : ils sont aussi dans le journal step_view). Champs inchangés depuis le 23/10 matin.
      var L = S.loves || {};
      api('/api/details', { method: 'POST', json: { from: from, message: S.details.message, accent: S.details.accent || guessAccent(), premiere: { mode: 'asap' },
        gender: (S.hero || {}).gender || null, interests: L.list || [], interest_other: L.other || null, color: L.color || null,
        occasion: occasion || null, look: S.details.look || null } })
        .then(function () {
          // L'expéditeur n'entre jamais dans le journal s'il a été tapé (« other ») ; pick : la suggestion gardée.
          go('preview', { occasion: occasion, sender: sender, edited: edited, pick: eff() });
        })
        .catch(function (e) { btn.disabled = false; err.textContent = friendly(e); });
    };
  }

  // ------------------------------------------------------------ étape 4 : l'aperçu
  // L'aperçu révélé : une pluie de confettis, une seule fois (Paul, 23/10 : « fluide, facile, dopamine »). Rien si
  // l'appareil demande moins d'animations.
  function confetti(host) {
    if (!host || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    var colors = ['#f2c14e', '#d99a1e', '#ff7a59', '#7c6cf2', '#2fb38a', '#fff8ee'];
    var layer = document.createElement('div');
    layer.className = 'lp-confetti';
    layer.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < 36; i++) {
      var p = document.createElement('i');
      p.style.left = (Math.random() * 100).toFixed(1) + '%';
      p.style.background = colors[i % colors.length];
      p.style.setProperty('--dx', Math.round(Math.random() * 120 - 60) + 'px');
      p.style.setProperty('--dy', (host.clientHeight + 40) + 'px');
      p.style.setProperty('--r', Math.round(Math.random() * 720 - 360) + 'deg');
      p.style.animationDelay = (Math.random() * 0.35).toFixed(2) + 's';
      p.style.animationDuration = (1.2 + Math.random() * 0.9).toFixed(2) + 's';
      layer.appendChild(p);
    }
    host.appendChild(layer);
    setTimeout(function () { if (layer.parentNode) layer.parentNode.removeChild(layer); }, 2800);
  }
  // 30/10 (Paul : « on vend une série de 6 épisodes… il faut que tu détaches de l'épisode », « expliquer ce qui va se
  // passer, les peurs, où il va gagner, où il va perdre », lié aux valeurs) : l'étape 6 présente la SAISON. Chaque épisode =
  // la valeur, le moment réel que l'enfant connaît (ce que le parent reconnaît) et l'histoire en une phrase, tirée des
  // scripts gelés (F_film/FILM_dino_ep*_v1.txt, FILM_hollowhill_ep*_v1.txt ; bible lancement_2210/05). Titres : catalogue
  // (series.<aventure>.episodes), sinon ceux d'ici. Une aventure absente d'ici garde l'ancienne fiche d'épisode.
  var SEASON_SHEETS0 = {
    dino: {
      name: 'Dinosaur Valley', poster: 'in Dinosaur Valley',
      story: 'It starts with a promise to a baby dinosaur. Then come a glowing egg, a grumpy giant, a tiny tunnel and a wild storm: one big adventure that keeps going from episode to episode, until {name} becomes the Keeper of the Valley.',
      cast: [['{name}', 'The bravest explorer in Dinosaur Valley'], ['Button', 'A baby triceratops no bigger than a puppy'],
        ['Pip', 'A tiny flyer whose spots glow like fireflies… but her wings are too small to fly'], ['The grumpy T. rex', 'Big and loud. But is he really mean?']],
      eps: [
        ['{Name} and the Baby Dinosaur', '💛', 'Kind', 'keeping a promise', 'Crack! Out of a lonely egg pops Button, and his family is far away. {Name} promises: “We\'ll find your family. Together.” Across a giant\'s long neck, hiding from a grumpy T. rex, all the way home… where Button says his very first word: “{Name}!”'],
        ['{Name} and the Glowing Egg', '💛', 'Kind', 'taking care of someone smaller', 'Button finds a little blue egg, all alone. It\'s cold, and its light is fading. The only warm place is past the Whispering Woods, at night. {Name} is scared, very scared… and goes anyway, holding the egg close until it glows and lights the way.'],
        ['{Name} and the Grumpy T. rex', '🦁', 'Brave and kind', 'when someone looks mean', 'BOOM! BOOM! The T. rex stomps day and night, and the egg can\'t hatch. In episode 1, {name} hid from him. This time, {name} walks right up… and finds a big thorn in his foot. One POP, one clumsy hug, and the egg bursts into light: hello, Pip!'],
        ['{Name} and the Tiny Tunnel', '⭐', 'Confident', '“I\'m too small”', 'CRASH! Falling rocks trap three baby dinosaurs in a cave. The T. rex\'s arms are too short, the gentle giant\'s head too big. Only {name} fits in the tiny, dark tunnel. Pip can\'t fly yet, but Pip can glow, and lights the way out: one… two… three!'],
        ['{Name} and the Big Storm', '🤝', 'Helping others', '“I can do it alone”', 'A storm rolls in, the stream becomes a river, and the herd is stuck on the open hill. Button tries to cross alone: splash! Then {name} has an idea: nobody crosses alone. Everyone holds the tail in front, and {name} leads the way, stone by stone.'],
        ['{Name}, Keeper of the Valley', '🏆', 'Never giving up', 'when it doesn\'t work the first time', 'At the Big Gathering, Pip wants to light up the sky for everyone. But Pip falls, once, twice, in front of the whole valley, and hides. So {name} carries Pip up the Tallest Rock, into the big wind. Will Pip fly? You\'ll find out with {name}.']
      ],
      takeaway: 'Six moments every child knows (the dark, someone who looks mean, feeling too small, wanting to do it alone) become six adventures. And whenever {name} is scared, Button whispers: “It\'s okay to be scared…” and everyone answers: “Brave is when you go anyway!”'
    },
    halloween: {
      name: 'Hollow Hill', poster: 'on Hollow Hill',
      story: 'It starts on Halloween night, with a shy little ghost whose BOO comes out as a squeak. Episode after episode, {name} and Patch face the dark, make new friends and get ready for the Great Boo Festival, where Patch has one big dream.',
      cast: [['{name}', 'The bravest little hero on Hollow Hill'], ['Patch', 'A shy little ghost made of an old patchwork quilt'],
        ['Flit', 'A tiny lost bat who is scared of the dark'], ['Wanda', 'A little witch who can\'t fly straight… yet']],
      eps: [
        ['{Name} and the Halloween Moon', '💡', 'Clever', 'when nothing works', 'On Halloween night the Moon has vanished, and no pumpkin will glow. Patch knows where it sleeps: in the old tree on top of Hollow Hill. Up they climb, past the bats and a dancing skeleton. Patch\'s BOO comes out as a squeak… so {name} tickles the Moon awake!'],
        ['{Name} and the Giant Shadow', '🦁', 'Brave', 'scary shadows', 'A giant winged shadow spreads over Hollow Hill, and everyone hides, even the Moon. {Name} is scared, very scared… and tiptoes closer anyway. Behind the shadow: Flit, a tiny lost bat, scared of the dark. {Name} lifts the lantern, the shadow shrinks, and Flit gets home.'],
        ['{Name} and the Lonely Skeleton', '💛', 'Kind', 'the one nobody plays with', 'Every time the skeleton says hello, its bones go CLACKETY-CLACK, and everyone runs. {Name} is the first to say hello back. The skeleton is so happy it falls to pieces! {Name} puts it back together like a puzzle, and the Hollow Hill Friends are born.'],
        ['{Name} and the Runaway Pumpkins', '🤝', 'Helping others', 'everyone is good at something', 'The Moon sneezes, and every festival pumpkin rolls down the hill. Patch feels useless: even a STOP comes out as a squeak. Then {name} whispers an idea. Flit spots the pumpkins in the dark, Patch stretches into a giant net, and {name} holds on tight.'],
        ['{Name} and the Wobbly Broom', '⭐', 'Confident', '“I can\'t do it”', 'Wanda, the young witch, leads the Broom Parade, but her broom wobbles… CRUNCH, into the leaves. The sky is big and the ground is far, but {name} hops on behind her and holds it steady. Then, gently, {name} lets go. And the night before the festival, Patch goes missing!'],
        ['{Name} and the Great Boo Festival', '🤝', 'Braver together', 'when everyone is watching', '{Name} finds Patch hiding in the attic: “What if my BOO is a squeak, in front of everyone?” So they\'ll go up together. On stage, with all of Hollow Hill watching, Patch freezes… Will that BOO come out? You\'ll find out with {name}.']
      ],
      takeaway: 'Six moments every child knows (the dark, scary shadows, the kid left out, wanting to quit) become six adventures. And whenever {name} is scared, Patch whispers: “It\'s okay to be scared…” and everyone answers: “Brave is when you go anyway!”'
    },
    christmas: {
      name: 'The Christmas Star', poster: 'and the Christmas Star',
      story: 'It starts on Christmas Eve, when the brightest star in the sky goes dark. Then come a letter from Santa, a young reindeer named Tinsel, a dark forest, a cave of ice and a great storm: one big adventure that keeps going from episode to episode, until {name} lights the heart of the Star.',
      cast: [['{name}', 'The brave child Santa asked for help'], ['Tinsel', 'A young reindeer with three little bells on its harness'],
        ['Santa', 'His Christmas Star went dark. He needs {name}.'], ['The big wolf', 'Scary in the dark forest. But is it really?']],
      eps: [
        ['{Name} and the Christmas Star', '🦁', 'Brave', 'scared of the dark', 'On Christmas Eve, the brightest star goes dark, and Santa sends a letter: “I need someone brave. I need you.” Deep in a dark forest, eyes shine between the trees. {Name} is scared, very scared… then lifts a little lantern, and the wolves step back.'],
        ['{Name} and the Littlest Wolf', '💛', 'Kind', 'helping someone smaller', 'That same night, the big wolf comes back for {name}. A wolf cub is stuck under a fallen tree, and its mother can\'t reach it. Tinsel is too big. Only {name} is small enough… and kind enough to dig, slowly and gently, so the little one isn\'t scared.'],
        ['{Name} and the Cave of Ice', '🧡', 'Sharing', 'sharing what you need too', 'Little white tracks lead to a cave of ice. Inside, a polar bear cub is shivering in the dark. {Name} is cold too, and the lantern is the only warm light. So {name} sets it down between them… and the whole cave turns gold.'],
        ['{Name} and the Great White Bear', '⏳', 'Patient', '“I want it now!”', 'The cub wants to run straight across the ice to its mother. But the dark ice is thin, and it cracks. {Name} puts a mitten on its back and counts: one… two… three… Waiting is hard. Then the great white bear comes the safe way around.'],
        ['{Name} and the Great Storm', '🤝', 'Helping each other', '“I can\'t do it alone”', 'A great storm hides the way, and Santa\'s reindeer are stuck in the mountains. {Name} shields the little flame, then holds it up high. Tinsel rings its bells, the wolves open a path, and everyone gets home together. No one could do it alone.'],
        ['{Name} and the Heart of the Star', '❤️', 'Love, and never giving up', 'missing someone you love', 'Five lights are on, but the heart of the Star stays dark. The wind pushes {name} back, and {name} tries again. Even the lantern isn\'t enough. So {name} closes {their} eyes and thinks of someone special… Will the heart light up? You\'ll find out with {name}.']
      ],
      takeaway: 'Six moments every child knows (the dark, a little one who needs help, sharing, waiting, a storm, missing someone you love) become six adventures. And whenever {name} is scared, Tinsel stays close, the narrator whispers: “It\'s okay to be scared…” and everyone answers: “Brave is when you go anyway!”'
    }
  };
  // 03/11 ~12 h (Paul : « que tout soit modifiable ») : la fiche saison, film par film, vient du bloc « 6 · Season — <film> »
  // (champs sheet_<film>_…, pré-remplis avec le texte d'avant : titres d'épisode du catalogue, le reste d'ici). Champ vide =
  // rien ; bloc supprimé = le texte d'avant. Le prénom du casting n°1 reste {name} (c'est lui qui porte la vignette 3D).
  function sheetOf(a) {
    var s0 = SEASON_SHEETS0[a.id];
    if (!s0) return s0;
    var k = 'sheet_' + a.id + '_', cat = CAT.series && CAT.series[a.id] && CAT.series[a.id].episodes || [];
    return {
      name: tx(k + 'name', s0.name), poster: tx(k + 'place', s0.poster), series: tx(k + 'series', 'A Little Premiere series · 6 episodes'),
      story: tx(k + 'pitch', s0.story), takeaway: tx(k + 'moments', s0.takeaway),
      cast: s0.cast.map(function (c, i) { return [i ? tx(k + 'c' + (i + 1) + '_name', c[0]) : c[0], tx(k + 'c' + (i + 1) + '_text', c[1])]; }),
      eps: s0.eps.map(function (e, i) {
        var n = k + 'ep' + (i + 1) + '_', ct = (cat.filter(function (x) { return x && x.n === i + 1 && x.title; })[0] || {}).title;
        return [tx(n + 'title', ct || e[0]), tx(n + 'icon', e[1]), tx(n + 'value', e[2]), tx(n + 'moment', e[3]), tx(n + 'text', e[4])];
      })
    };
  }
  // SEASON_SHEETS[film] = la fiche avec les champs du bloc (lue à chaque écran, après la config).
  var SEASON_SHEETS = {};
  Object.keys(SEASON_SHEETS0).forEach(function (id) { Object.defineProperty(SEASON_SHEETS, id, { enumerable: true, get: function () { return sheetOf({ id: id }); } }); });
  // Éditeur : le pitch, le casting, les épisodes et la morale portent le bloc du film (clic de l'inspecteur → ce bloc).
  var seasonSheetHtml0 = seasonSheetHtml;
  seasonSheetHtml = function (a, ss, p) {
    var h = seasonSheetHtml0(a, ss, p), e = ed('z_sheet_' + a.id);
    if (!e) return h;
    return h.replace('<ul class="lp-cast">', '<ul class="lp-cast"' + e + '>').replace('<ol class="lp-eps">', '<ol class="lp-eps"' + e + '>')
      .split('<p>' + fillE(ss.story) + '</p>').join('<p' + e + '>' + fillE(ss.story) + '</p>')
      .split('<p>' + fillE(ss.takeaway) + '</p>').join('<p' + e + '>' + fillE(ss.takeaway) + '</p>');
  };
  // 30/10 ~11 h 50 (Paul : « pas assez détaillé… raconter un petit peu l'histoire vite fait » ; board : 40-50 mots, tirés des
  // vraies répliques des scripts F_film/FILM_*_v1.txt, la phrase rituelle du film dans « What {name} takes away »).
  function seasonSheetHtml(a, ss, p) {
    var cat = CAT.series && CAT.series[a.id] && CAT.series[a.id].episodes || [];
    var cast = ss.cast.map(function (c) {
      var me = c[0] === '{name}' && p.url;
      return '<li' + (me ? ' class="is-me"><img src="' + esc(p.url) + '" alt="">' : '>') + '<span><b>' + fillE(c[0]) + '</b> · ' + fillE(c[1]) + '</span></li>';
    }).join('');
    var eps = ss.eps.map(function (e, i) {
      var t = e[0]; // sheetOf() : titre du catalogue, remplacé par le champ du bloc « 6 · Season » s'il existe
      return '<li><b>' + fillE(t) + '</b><span class="lp-ep-val">' + e[1] + ' ' + esc(e[2]) + ' · ' + esc(e[3]) + '</span>' +
        '<span class="lp-ep-txt">' + fillE(e[4]) + '</span></li>';
    }).join('');
    var meta = tx('prev_sheet_meta', '6 episodes · about 3 minutes each · The narrator says {name}\'s name · A real photo of {name} in the end credits');
    return '<div class="lp-sheet"' + ed('z_prev') + '>' +
      sheetH('prev_sheet_series', 'The series') + '<p>' + fillE(ss.story) + '</p>' +
      sheetH('prev_sheet_cast', 'The cast') + '<ul class="lp-cast">' + cast + '</ul>' +
      sheetH('prev_sheet_eps', 'The 6 episodes') + '<ol class="lp-eps">' + eps + '</ol>' +
      sheetH('prev_sheet_takeaway', 'What {name} takes away') + '<p>' + fillE(ss.takeaway) + '</p>' +
      sheetEnd() +
      (meta ? '<p class="lp-meta">' + fillE(meta) + '</p>' : '') +
      '</div>';
  }
  function sheetH(k, d) { var h = tx(k, d); return h ? '<h3>' + fillE(h) + '</h3>' : ''; }
  function sheetEnd() {
    if (!(S.details && S.details.message)) return '';
    var e = tx('prev_sheet_end_text', 'The narrator reads your words to {name}:');
    return sheetH('prev_sheet_end', 'And at the very end') + '<p>' + (e ? fillE(e) + ' ' : '') + '<i>“' + esc(S.details.message) + '”</i></p>';
  }
  var shownPreview = false, shownPoster = false;
  // 02/11 (Paul, capture 22 : « l'image de base… hyper réelle », puis « on peut l'afficher dès le début ? ») : le portrait
  // est prêt avant l'affiche (écart mesuré sur 321 sessions des 5 derniers jours : médiane 1,1 s, p90 15 s). L'écran
  // d'attente reste donc jusqu'à ce que l'affiche soit faite ET chargée, 30 s au plus ; au-delà, l'ancien chemin
  // (portrait, puis l'affiche en fondu) reprend. Pas d'affiche prévue (off, échec) : rien n'est retenu.
  var posterImgOk = {};
  function posterHold(p) {
    if (p.state !== 'done') { if (S.posterHoldAt) { S.posterHoldAt = 0; save(); } return false; }
    var pending = !p.poster && (p.poster_state === 'queued' || p.poster_state === 'running');
    if (!pending && !(p.poster && !posterImgOk[p.poster])) return false;
    if (!S.posterHoldAt) { S.posterHoldAt = Date.now(); save(); }
    if (Date.now() - S.posterHoldAt > 30000) return false;
    if (p.poster && !posterImgOk[p.poster] && posterImgOk[p.poster] !== 0) {
      var url = p.poster, im = new Image(); posterImgOk[url] = 0;
      im.onload = im.onerror = function () { posterImgOk[url] = 1; if (S.step === 'preview') renderPreview(); };
      im.src = url;
    }
    if (!pollTimer && pending) startPolling();
    if (!pending && !app.querySelector('[data-lp-wait]')) return false; // déjà sur l'étape 6 : on n'y revient pas
    if (!pending) setTimeout(function () { if (S.step === 'preview' && app.querySelector('[data-lp-wait]')) renderPreview(); }, 30500 - (Date.now() - S.posterHoldAt));
    return true;
  }
  function renderPreview() {
    var a = adventure();
    var p = S.preview || {};
    if (p.state === 'queued' || p.state === 'running' || !p.state || posterHold(p)) {
      if (!pollTimer) startPolling();
      // 23/10 ~14 h (Paul : « imaginez sa tête ») : la grande vidéo est le montage de réactions, scènes faites au studio IA,
      // dit en petit comme sur les pages d'atterrissage.
      // 02/11 (Paul : « pas toujours la même chose, pas en boucle ») : chaque sondage (2,5 s) réécrivait cet écran et
      // relançait la vidéo d'attente à zéro (mesuré en ligne : aucune ne jouait plus de 2,4 s). Écran déjà affiché : on n'y
      // touche plus ; la barre avance seule (tickProgress) et la playlist enchaîne à la fin de chaque vidéo.
      // 03/11 : bloc « 6 · Waiting » (avec les 7 lignes de liveSteps). Dans l'éditeur, l'écran se redessine à chaque réglage.
      if (!DEMO && app.querySelector('[data-lp-wait]')) return;
      var wc = costume(), wt = wc ? tx('wait_text_costume', 'Shaping {name}\'s face, hair and smile in 3D, in {their} {costume} costume. It usually takes 1 to 2 minutes.')
        : tx('wait_text', 'Shaping {name}\'s face, hair and smile in 3D. It usually takes 1 to 2 minutes.');
      app.innerHTML = '<div class="lp-card lp-center" data-lp-wait="1">' + progress('preview') +
        '<h2 class="lp-h2"' + ed('z_wait') + '>' + fillE(tx('wait_title', 'Our studio is bringing {name} to life…')) + '</h2>' +
        '<div class="lp-live lp-live-lg"' + ed('z_wait') + '><span id="lp-livestep">' + fillE(liveSteps()[0]) + '… 1/7</span><b class="lp-live-pct" id="lp-livepct">0%</b>' +
          '<div class="lp-live-bar"><div id="lp-livebar"></div></div></div>' +
        (sceneHtml('lp-scene-lg', 'Imagine their face', fill(tx('wait_note', 'Scenes created with our AI studio to show the moment.'))).replace('<p class="lp-scene-note">', '<p class="lp-scene-note"' + ed('z_wait') + '>') ||
          '<div class="lp-spinner" aria-hidden="true"></div>') +
        (wt ? '<p class="lp-muted"' + ed('z_wait') + '>' + fillE(wt, wc ? { costume: wc.label.toLowerCase() } : null) + '</p>' : '') +
        liveStepsHtml() + dyk('waiting') + '</div>';
      tickProgress();
      return;
    }
    if (p.state === 'failed' || p.state === 'none') {
      var refused = p.error === 'refused';
      var busy = p.error === 'busy';
      app.innerHTML = '<div class="lp-card lp-center">' + progress('preview') +
        '<h2 class="lp-h2">' + (busy ? 'Our studio is very busy' : fillE('We couldn\'t create {name}\'s hero')) + '</h2>' +
        '<p class="lp-muted">' + (refused ? fillE('This photo didn\'t work for our 3D studio. A different photo of {name} usually fixes it.')
          : busy ? 'Please try again in a few minutes.' : 'Something went wrong on our side. Let\'s try again.') + '</p>' +
        (p.can_regen && !refused ? '<button type="button" class="lp-btn" id="lp-regen">Try again</button>' : '') +
        '<button type="button" class="lp-btn ' + (p.can_regen && !refused ? 'lp-btn-ghost' : '') + '" id="lp-newphoto">Use another photo</button></div>';
      var rg = document.getElementById('lp-regen');
      if (rg) rg.onclick = regen;
      document.getElementById('lp-newphoto').onclick = function () { go('photo'); };
      return;
    }
    if (freshLinks(function () { if (S.step === 'preview') renderPreview(); })) return;
    var st = a.story || {}, ss = SEASON_SHEETS[a.id];
    // 03/11 : bloc « 6 · Preview » (fiche comprise : sheetH, sheetEnd) ; histoire, casting, épisodes et aventure sans fiche : en dur.
    var c6 = costume(), badge = tx('prev_badge', 'Your free preview'), regenT = tx('prev_regen', 'Not quite them? Try again · {left} left'),
      rcT = tx('prev_recostume', 'Try another costume'), opT = tx('prev_otherphoto', 'Use another photo');
    var lead = !ss ? 'This is {name} in the movie' + (c6 ? ',' + asCostume() : '') + '. Now let\'s bring the whole adventure to life.'
      : c6 ? tx('prev_lead_costume', 'This is {name} in the series, as a {costume}. Now let\'s bring all 6 episodes to life.')
      : tx('prev_lead', 'This is {name} in the series. Now let\'s bring all 6 episodes to life.');
    var imagine = ss ? tx('prev_imagine', 'Now imagine {name}\'s face when the first episode starts and the narrator says {their} name.')
      : 'Now imagine {name}\'s face when the movie starts and the narrator says {their} name.';
    var beats = (st.beats || []).map(function (b, i, arr) {
      return '<li>' + fillE(b) + (i === arr.length - 1 ? ' <em>We\'re keeping the ending for movie night.</em>' : '') + '</li>';
    }).join('');
    // Le héros du casting ({name}) porte sa vignette 3D (Paul, 23/10 ~14 h : « l'image de l'enfant + la description »).
    var cast = (st.cast || []).map(function (c) {
      var me = c.name === '{name}' && p.url;
      return '<li' + (me ? ' class="is-me"><img src="' + esc(p.url) + '" alt="">' : '>') + '<span><b>' + fillE(c.name) + '</b> · ' + fillE(c.role) + '</span></li>';
    }).join('');
    app.innerHTML =
      '<div class="lp-card">' + progress('preview') +
      (badge ? '<p class="lp-badge"' + ed('z_prev') + '>' + fillE(badge) + '</p>' : '') +
      '<h2 class="lp-h2"' + ed('z_prev') + '>' + (ss ? fillE(tx('prev_title', 'Meet {Name}, the hero of {series}'), { series: ss.name }) : 'Meet ' + fillE(a.title)) + '</h2>' +
      (p.poster || p.poster_state === 'queued' || p.poster_state === 'running'
        ? '<div class="lp-hero lp-hero-poster" id="lp-heromedia" data-poster="1">' + heroPosterHtml(a, p.poster, p.url, ss) + '</div>'
        : '<div class="lp-hero" id="lp-heromedia"><img src="' + esc(p.url) + '" alt="' + fillE('{name} as a 3D animated hero') + '"></div>') +
      (lead ? '<p class="lp-lead"' + ed('z_prev') + '>' + fillE(lead, c6 ? { costume: c6.label.toLowerCase() } : null) + '</p>' : '') +
      (p.can_regen && regenT ? '<button type="button" class="lp-link" id="lp-regen"' + ed('z_prev') + '>' + fillE(regenT.split('{left}').join(String(p.regen_left == null ? '' : p.regen_left))) + '</button>' : '') +
      (p.can_regen && costumesOf(a) && rcT ? '<button type="button" class="lp-link" id="lp-recostume"' + ed('z_prev') + '>' + fillE(rcT) + '</button>' : '') +
      (photoTip() ? '<p class="lp-softtip">' + esc(photoTip()) + (opT ? ' <button type="button" class="lp-link" id="lp-otherphoto"' + ed('z_prev') + '>' + fillE(opT) + '</button>' : '') + '</p>' : '') +
      // 23/10 ~14 h (Paul, capture 35) : plus de vidéo « …and this is the world » sous le portrait ; la fiche du film suit.
      (ss ? seasonSheetHtml(a, ss, p) : '<div class="lp-sheet"' + ed('z_prev') + '>' +
        '<h3>Where it happens</h3><p>' + fillE(st.setting) + '</p>' +
        sheetH('prev_sheet_cast', 'The cast') + '<ul class="lp-cast">' + cast + '</ul>' +
        '<h3>The mission</h3><p>' + fillE(st.mission) + '</p>' +
        '<h3>What happens</h3><ol>' + beats + '</ol>' +
        // 24/10 ~12 h 20 (Paul, capture 56 : « un moment précis où il est courageux et sauve quelque chose… le sens qui
        // justifie l'achat… moins de what you get ») : le moment héroïque (story.hero_moment, catalogue) et le cœur de
        // l'histoire, écrits sur le vrai script ; le message tapé à l'étape 5 revient mot pour mot ; « What you get » part
        // (l'offre suit, juste après).
        (st.hero_moment ? '<h3>' + fillE('{Name}\'s hero moment') + '</h3><p>' + fillE(st.hero_moment) + '</p>' : '') +
        '<h3>The heart of the story</h3><p>' + fillE(st.lesson) + '</p>' +
        sheetEnd() +
        '<p class="lp-meta">' + esc(CAT.settings.film_length_label) + ' · ' + fillE('The narrator says {name}\'s name') + ' · ' + fillE('A real photo of {name} in the end credits') + '</p>' +
      '</div>') +
      '<p class="lp-guarantee-line">' + fillE('🛡️ ' + guarantee()) + '</p>' +
      (imagine ? '<p class="lp-lead lp-center-text"' + ed('z_prev') + '>' + fillE(imagine) + '</p>' : '') +
      (needMail() ? '<form id="lp-mailform" class="lp-mailgate" novalidate><label class="lp-label lp-ico-label" for="lp-email"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h18v12H3z"/><path d="m3 7 9 6 9-6"/></svg><span>' +
        fillE((AB.abe && AB.abe.label) || 'Where should we send {name}\'s preview?') + '</span></label>' +
        '<input class="lp-input lp-input-lg" id="lp-email" type="email" inputmode="email" autocomplete="email" placeholder="you@example.com">' +
        '<p class="lp-error" id="lp-err" role="alert"></p></form>' : '') +
      '<button type="button" class="lp-btn lp-btn-full lp-btn-big" id="lp-make"' + ed('z_prev') + '>' + fillE(tx('prev_button', 'Make {name}\'s movie')) + '</button>' +
      dyk('preview') +
      '</div>';
    if (!shownPreview) { shownPreview = true; track('preview_shown', {}, 4); confetti(document.getElementById('lp-heromedia')); }
    if (!S.klPreview) { S.klPreview = true; save(); klEvent('LP Preview Ready', { hero_image: p.url || null }); }
    armPoster(); // poster_shown part quand l'affiche est vraiment affichée, plus quand son lien est posé
    if (p.anim) swapAnim();
    if ((p.anim_state === 'queued' || p.anim_state === 'running' || p.poster_state === 'queued' || p.poster_state === 'running') && !pollTimer) startPolling();
    var r = document.getElementById('lp-regen');
    if (r) r.onclick = regen;
    var rc = document.getElementById('lp-recostume');
    if (rc) rc.onclick = function () { S.costumeRetry = true; go('costume'); };
    var op = document.getElementById('lp-otherphoto');
    if (op) op.onclick = function () { go('photo'); };
    document.getElementById('lp-make').onclick = function () {
      if (!needMail()) return go('offer');
      var btn = this, em = document.getElementById('lp-email'), err = document.getElementById('lp-err'), email = em.value.trim();
      if (!MAIL_RE.test(email)) { // vide : on amène au champ, sans message d'erreur ; tapé mais faux : le message
        err.textContent = email ? fill('Please enter a valid email to get {name}\'s movie.') : '';
        if (email) em.classList.add('lp-miss');
        em.scrollIntoView({ behavior: 'smooth', block: 'center' }); em.focus({ preventScroll: true });
        return;
      }
      btn.disabled = true; S.email = email; save();
      sendLead().then(function () {
        publish('lead', { adventure: S.adventure, angle: S.angle || null, arm: S.arm });
        go('offer', { email_after_preview: 1 });
      }).catch(function (e) { btn.disabled = false; S.email = ''; save(); err.textContent = friendly(e); });
    };
    var mf = document.getElementById('lp-mailform');
    if (mf) {
      mf.onsubmit = function (ev) { ev.preventDefault(); document.getElementById('lp-make').click(); };
      document.getElementById('lp-email').oninput = function () { this.classList.remove('lp-miss'); document.getElementById('lp-err').textContent = ''; };
    }
  }

  function regen() {
    api('/api/preview/regen', { method: 'POST', json: {} }).then(function () {
      S.preview = { state: 'queued', startedAt: Date.now() };
      shownPreview = shownPoster = false;
      save();
      renderPreview();
      startPolling();
    }).catch(function (e) { showError(friendly(e), function () { go('preview'); }); });
  }

  // ------------------------------------------------------------ étape 5 : la bande-annonce de l'enfant
  // Paul, 19/10 : 30 s, lecture auto MUETTE (le navigateur bloque le son sans geste), bouton son bien visible, carton
  // « Starring {NAME} » + portrait 3D, voix off au prénom. Contrat : G_tunnel/API_TRAILER.txt (fork tunnel) :
  //   GET /api/trailer?format=16x9 → { available, clips: [{ url, seconds }], end_card: { at, seconds, name, portrait_url },
  //     voice: { url, at } | null, voice_state, captions: [{ at, seconds, text }], overlays: { enabled, state, shots } }
  // Sous-titres tant que c'est muet : le prénom à l'écran dès 0,2 s. Plans-visage (V2) en SUPERPOSITION, jamais dans la
  // playlist. Sans manifeste : la bande-annonce du catalogue (`trailer`) et le carton posé ici sur ses 4 dernières secondes.
  var TRAILER_API = '/api/trailer?format=16x9';
  // A/B abt (Dino) et abn (Noël) : le Worker sert alors la version épinglée dans TRAILER_AB_B pour cette aventure.
  function trailerApi() { var b = (S.adventure === 'dino' && abArm('abt') === 'b') || (S.adventure === 'christmas' && abArm('abn') === 'b'); return TRAILER_API + (b ? '&abt=b' : ''); }
  var TRAILER_FACES_API = '/api/trailer/faces';
  var trailerStop = null;
  function stopTrailer() { if (trailerStop) { trailerStop(); trailerStop = null; } }
  function okUrl(u) { return /^https:\/\//.test(u || '') || /^http:\/\/127\.0\.0\.1[:/]/.test(u || ''); }
  function planFromManifest(m) {
    if (!m || m.available !== true) return null;
    var clips = (m.clips || []).filter(function (c) { return okUrl(c.url); }).map(function (c) { return { url: c.url, seconds: Number(c.seconds) || 0 }; });
    if (!clips.length) return null;
    var ec = m.end_card || {};
    var ov = m.overlays || {};
    return {
      clips: clips,
      card: { at: Number(ec.at), seconds: Number(ec.seconds) || 4, name: ec.name || m.name || '', portrait: okUrl(ec.portrait_url) ? ec.portrait_url : '' },
      voice: m.voice && okUrl(m.voice.url) ? { url: m.voice.url, at: Number(m.voice.at) || 0 } : null,
      voiceState: m.voice_state || (m.voice ? 'done' : 'none'),
      captions: (m.captions || []).map(function (c) { var at = Number(c.at) || 0; return { at: at, end: at + (Number(c.seconds) || 0), text: String(c.text || '') }; }),
      overlaysOn: !!ov.enabled,
      overlaysState: ov.state || 'none',
      shots: (ov.shots || []).filter(function (s) { return s.state === 'done' && okUrl(s.url); })
    };
  }
  function planFallback() {
    var a = adventure();
    // 23/10 ~14 h : la playlist d'attente montre d'autres enfants (réactions) ; la bande-annonce de secours est celle du film.
    var u = (a && a.trailer) || '';
    return okUrl(u) ? { clips: [{ url: u, seconds: 0 }], card: { at: NaN, seconds: 4.4, name: '', portrait: '' }, voice: null, voiceState: 'none', captions: [], overlaysOn: false, overlaysState: 'none', shots: [] } : null;
  }
  function trailerHtml() {
    var a = adventure();
    var img = S.preview && S.preview.url, pst = S.preview && S.preview.poster;
    return '<div class="lp-trailer" id="lp-trailer">' +
      '<video playsinline muted preload="auto" aria-label="Movie trailer"></video>' +
      // 23/10 ~19 h (Paul : « on voit un enfant » → « le héros 3D ») : le portrait 3D de SON enfant en médaillon pendant
      // toute la bande-annonce ; le héros du film est un modèle (garçon) tant que les plans-visage Seedance restent éteints.
      '<div class="lp-tbadge" id="lp-tbadge"' + ed('z_off_top') + (img ? '' : ' hidden') + '><img id="lp-tbadgeimg" src="' + esc(img || '') + '" alt="">' +
        '<span><small>' + esc(tx('off_tr_starring', 'Starring')) + '</small><b id="lp-tbadgename">' + esc(vars().name === 'your child' ? '' : vars().name) + '</b></span></div>' +
      '<p class="lp-tcap" id="lp-tcap" hidden></p>' +
      '<div class="lp-endcard" id="lp-endcard" hidden>' +
        '<img id="lp-endimg" src="' + esc(pst || img || '') + '" alt=""' + (pst ? ' class="is-poster"' : img ? '' : ' hidden') + '>' +
        '<div class="lp-endcard-text"><p class="lp-endcard-kicker">' + esc(tx('off_tr_starring', 'Starring')) + '</p>' +
        '<p class="lp-endcard-name" id="lp-endname">' + esc((S.hero && S.hero.name ? vars().name : '').toUpperCase()) + '</p>' +
        '<p class="lp-endcard-title">' + esc(a.short_title || '') + '</p></div></div>' +
      '<button type="button" class="lp-tsound" id="lp-tsound"' + ed('z_off_top') + ' aria-label="Turn the sound on">' + esc(tx('off_tr_sound', '🔊 Tap for sound')) + '</button>' +
      '<button type="button" class="lp-treplay" id="lp-treplay" hidden>' + esc(tx('off_tr_replay', '↺ Watch again')) + '</button></div>';
  }
  function startTrailer() {
    var box = document.getElementById('lp-trailer');
    if (!box) return;
    var v = box.querySelector('video');
    var card = document.getElementById('lp-endcard');
    var img = document.getElementById('lp-endimg');
    var capEl = document.getElementById('lp-tcap');
    var sound = document.getElementById('lp-tsound');
    var replay = document.getElementById('lp-treplay');
    var badge = document.getElementById('lp-tbadge');
    var plan = null;
    var i = 0;
    var offsets = [0];
    var voiceEl = null;
    var shots = {};
    var raf = 0;
    var alive = true;
    var timers = [];
    trailerStop = function () {
      alive = false;
      if (raf) cancelAnimationFrame(raf);
      timers.forEach(clearTimeout);
      if (voiceEl) { try { voiceEl.pause(); } catch (e) { /* rien */ } }
    };
    function play(el) { var p = el.play(); if (p && p.catch) p.catch(function () {}); }
    function now() { return (offsets[i] || 0) + v.currentTime; }
    function cardAt() {
      if (!isNaN(plan.card.at)) return plan.card.at;
      return i === plan.clips.length - 1 && v.duration ? offsets[i] + v.duration - plan.card.seconds : Infinity;
    }
    function setVoice(vo) {
      if (!alive || voiceEl || !vo) return;
      plan.voice = vo;
      voiceEl = new Audio(vo.url);
      voiceEl.preload = 'auto';
    }
    function addShots(list) {
      list.forEach(function (s) {
        var key = s.plan || String(s.at);
        if (shots[key]) return;
        var el = document.createElement('video');
        el.className = 'lp-tshot';
        el.src = s.url;
        el.muted = true;
        el.preload = 'auto';
        el.setAttribute('playsinline', '');
        el.hidden = true;
        box.insertBefore(el, capEl);
        shots[key] = { s: s, el: el };
      });
    }
    function sync() {
      var t = now();
      var last = i === plan.clips.length - 1;
      var show = (last && v.ended) || t >= cardAt();
      card.hidden = !show;
      badge.hidden = show || !document.getElementById('lp-tbadgeimg').getAttribute('src');
      box.classList.toggle('is-end', show);
      var cap = '';
      if (v.muted && !show) plan.captions.forEach(function (c) { if (t >= c.at && t < c.end) cap = c.text; });
      if (capEl.textContent !== cap) capEl.textContent = cap;
      capEl.hidden = !cap;
      Object.keys(shots).forEach(function (k) {
        var s = shots[k].s;
        var el = shots[k].el;
        var on = !v.paused && t >= s.at && t < s.at + (Number(s.seconds) || 0) && el.readyState >= 2;
        if (on) {
          var want = (Number(s.clip_in) || 0) + (t - s.at);
          if (Math.abs(el.currentTime - want) > 0.25) { try { el.currentTime = want; } catch (e) { /* rien */ } }
          if (el.paused) play(el);
        } else if (!el.paused) el.pause();
        el.hidden = !on;
      });
      if (voiceEl) {
        var w = t - plan.voice.at;
        if (v.muted || v.paused || w < 0) { if (!voiceEl.paused) voiceEl.pause(); }
        else {
          if (Math.abs(voiceEl.currentTime - w) > 0.3) { try { voiceEl.currentTime = w; } catch (e) { /* pas encore chargée */ } }
          if (voiceEl.paused) play(voiceEl);
        }
      }
    }
    function tick() { sync(); raf = !v.paused && !v.ended && alive ? requestAnimationFrame(tick) : 0; }
    function load(k) { i = k; v.src = plan.clips[k].url; play(v); }
    function refresh(after) {
      api(trailerApi()).then(planFromManifest).then(function (p) {
        if (!alive || !p) return;
        if (p.voice) setVoice(p.voice);
        if (p.shots.length) addShots(p.shots);
        if (after) after(p);
      }).catch(function () {});
    }
    function poll(every, n, more) {
      if (!alive || n <= 0) return;
      timers.push(setTimeout(function () { refresh(function (p) { if (more(p)) poll(every, n - 1, more); }); }, every));
    }
    function begin(p) {
      if (!alive || !document.body.contains(box)) return; // l'écran a changé entre-temps
      plan = p;
      if (!plan) { box.hidden = true; return; }
      if (plan.card.name) document.getElementById('lp-endname').textContent = String(plan.card.name).toUpperCase();
      if (plan.card.portrait) {
        if (!img.classList.contains('is-poster')) { img.src = plan.card.portrait; img.hidden = false; }
        document.getElementById('lp-tbadgeimg').src = plan.card.portrait;
      }
      if (plan.voice) setVoice(plan.voice);
      else if (plan.voiceState === 'running') poll(3000, 20, function (q) { return !q.voice && q.voiceState === 'running'; }); // 60 s : Google peut faire attendre ~40 s
      if (plan.shots.length) addShots(plan.shots);
      if (plan.overlaysOn) {
        api(TRAILER_FACES_API, { method: 'POST', json: {} }).then(function (r) {
          if (r && (r.started || r.reason === 'already_started')) poll(12000, 25, function (q) { return q.overlaysState === 'running'; });
        }).catch(function () {});
      }
      load(0);
    }
    v.addEventListener('loadedmetadata', function () { offsets[i + 1] = offsets[i] + (plan.clips[i].seconds || v.duration || 0); });
    v.addEventListener('play', tick);
    v.addEventListener('pause', function () { if (plan) sync(); });
    v.addEventListener('seeked', function () { if (plan) sync(); });
    v.addEventListener('ended', function () {
      if (i + 1 < plan.clips.length) return load(i + 1);
      sync();
      replay.hidden = false;
      track('trailer_end', { muted: v.muted, personal: !!plan.voice, overlays: Object.keys(shots).length }, 5);
    });
    sound.onclick = function () {
      v.muted = !v.muted;
      sound.classList.toggle('is-on', !v.muted);
      sound.textContent = v.muted ? tx('off_tr_sound', '🔊 Tap for sound') : '🔇';
      sound.setAttribute('aria-label', v.muted ? 'Turn the sound on' : 'Mute');
      if (voiceEl && !v.muted && voiceEl.paused) { // iOS : la voix se débloque dans ce geste, sans rien faire entendre
        var tv = voiceEl;
        tv.muted = true;
        tv.play().then(function () { tv.pause(); tv.muted = false; sync(); }).catch(function () { tv.muted = false; });
      }
      if (v.paused && replay.hidden) play(v);
      // Chrome met parfois en pause une vidéo lancée muette qu'on démute : on relance, toujours dans le geste.
      setTimeout(function () { if (alive && v.paused && !v.ended && replay.hidden) play(v); }, 200);
      if (plan) sync();
      track('trailer_sound', { on: !v.muted }, 5);
    };
    replay.onclick = function () {
      replay.hidden = true;
      if (i !== 0) load(0); else { v.currentTime = 0; play(v); }
      track('trailer_replay', {}, 5);
    };
    var late = new Promise(function (r) { setTimeout(function () { r(null); }, 2500); });
    Promise.race([api(trailerApi()).then(planFromManifest).catch(function () { return null; }), late])
      .then(function (p) { begin(p || planFallback()); });
  }

  // ------------------------------------------------------------ étape 5 : l'offre
  // Copie du paywall de StarringYou (rapport A §1.4, 19/10), demandée par Paul ; le prix par épisode seulement sur les packs ;
  // des cadeaux à coût quasi nul (affiches et coloriages au prénom) à la place de leurs chansons ; un ajout saisonnier à
  // 7,99 $ ; un récapitulatif « FREE » ; une barre d'achat collante et la garantie (remake ou remboursement, au choix). Rien de faux : le
  // prix barré est le vrai prix d'un épisode multiplié par le nombre d'épisodes (variante Shopify : compare_at).
  // 23/10 ~14 h (Paul : « juste le premier épisode ou la saison complète avec les produits cadeaux ») : 2 offres, 1 épisode
  // à 24,99 $ ou 6 épisodes pour le prix de 2 (49,98 $, barré 149,94 $ : −67 %, jamais « −70 % »). 3 et 7 restent pour les
  // bras et les reprises plus anciens.
  var PLANS = {
    1: { name: 'The Premiere', deal: '1 episode' },
    3: { name: 'The Mini-Series', badge: 'MOST POPULAR', deal: 'Buy 2 Get 1 Free · 3 episodes' },
    6: { name: 'The Full Season', badge: 'BEST VALUE', deal: '6 episodes', save: true }, // badge = nom de la promo quand elle tourne
    // 23/10 : « Buy 5 Get 2 Free » était faux à 99,99 $ (5 épisodes = 149,95 $) ; la remise se calcule sur le prix barré.
    7: { name: 'The Full Season', badge: 'BEST VALUE', deal: '7 episodes', save: true }
  };
  // Offres « épisodes » (même enfant) : kind « series » pour 3, 6 et 7, « film » pour 1 ; l'ancien pack famille (kind
  // « pack », plusieurs enfants) garde ses textes du catalogue.
  function planOf(id) {
    var o = CAT.offers[id];
    if (!o || !(o.kind === 'series' || ((o.kind || 'film') === 'film' && o.films === 1))) return null;
    return PLANS[o.films] || null;
  }
  // Ajouts (kind « addon ») : un produit à part ; variante et prix lus sur /products/<handle>.js, sinon le catalogue.
  var ADDONS = {};
  // Base64 « URL » d'un texte UTF-8 (prénoms accentués) : format des propriétés d'un lien de panier Shopify.
  function b64url(str) { return btoa(unescape(encodeURIComponent(str))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); }
  function cents(x) { var n = Number(x); return Number.isInteger(n) && n >= 100 ? n : Math.round(n * 100); }
  function bumpVariant(b) {
    var o = b && CAT.offers[b.offer];
    if (!o) return null;
    if (o.kind === 'addon') return ADDONS[b.offer] || (o.variant_id && o.price != null ? { id: o.variant_id, price: cents(o.price) } : null);
    return variantBySku(o.sku);
  }
  function loadAddons() {
    Object.keys(CAT.offers || {}).forEach(function (id) {
      var o = CAT.offers[id];
      if (o.kind !== 'addon' || !o.product_handle) return;
      fetch(ROOT + 'products/' + encodeURIComponent(o.product_handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (pr) {
          var vs = (pr && pr.variants) || [];
          var v = vs.filter(function (x) { return x.sku === o.sku; })[0] || vs[0];
          if (v) ADDONS[id] = { id: v.id, price: v.price, available: v.available };
        }).catch(function () {});
    });
  }
  function priceOf(id) { var v = variantBySku(skuFor(id)); return v ? v.price : null; }
  // 23/10 ~17 h (Paul : « au checkout, afficher le prix de base et la réduction dans la section Réduction, que ce soit
  // Shopify qui applique la réduction ») : la variante porte le prix de base (LP-EP6 149,94 $) et une remise automatique
  // Shopify (« Early Black Friday… », −99,96 $) l'amène au prix payé, que donne le catalogue (offre.checkout_price). Ici le
  // prix de base devient le prix barré et le prix payé le prix affiché : tout le paywall suit. Shopify n'applique qu'une
  // remise produit par ligne, la meilleure : la remise frère/sœur ne s'y ajoute pas. Remise changée dans Shopify =
  // checkout_price à changer avec.
  // 01/11 : même prix payé pour la variante propre à une aventure (sku_overrides, ex. LP-EP6-HW : affiche Hollow Hill au
  // paiement), sinon la page d'Halloween affichait 149,94 $. La remise Shopify « Early Black Friday » vise les deux variantes.
  function applyCheckoutPrices() {
    Object.keys(CAT.offers || {}).forEach(function (id) {
      var o = CAT.offers[id];
      var pay = o.checkout_price != null ? cents(o.checkout_price) : null;
      var skus = [o.sku].concat((CAT.adventures || []).map(function (a) { return a.sku_overrides && a.sku_overrides[id]; }).filter(Boolean));
      skus.forEach(function (sku) {
        var v = pay && variantBySku(sku);
        if (!v || !(v.price > pay)) return;
        v.compare_at_price = v.price;
        v.price = pay;
        v.autoDiscount = true;
      });
    });
  }
  function singlePrice(arm) {
    for (var i = 0; i < arm.offers.length; i++) { var o = CAT.offers[arm.offers[i]]; if (o && o.films === 1) return priceOf(arm.offers[i]); }
    return null;
  }
  function preselectFor(arm) {
    var byRel = arm.preselect_by_relationship || {};
    return byRel[S.relationship] || arm.preselect;
  }
  function offerCards(arm) {
    var a = adventure();
    var one = singlePrice(arm);
    var html = '';
    var available = 0;
    arm.offers.forEach(function (id) {
      var o = CAT.offers[id];
      var price = priceOf(id);
      var v = variantBySku(skuFor(id));
      if (!o || price === null || (v && v.available === false)) { if (window.console) console.warn('[lp] offer without Shopify variant', id, skuFor(id)); return; }
      available++;
      var p = planOf(id);
      var on = S.offer === id;
      var struck = v && v.compare_at_price > price ? v.compare_at_price : p && o.films > 1 && one ? one * o.films : 0;
      var vars2 = { adventure_title: fill(a.title), adventure_short: a.short_title };
      // 24/10 ~12 h 20 (Paul, capture 59 : « enlève le moins cher qu'un ticket de cinéma et le prix par épisode, garde
      // juste la promo 67 % ») : la carte saison porte le nom de la promo (réglé par Paul), le prix barré et « 67% OFF »,
      // le chrono, et ses cadeaux (en une ligne depuis 13 h 30). La carte 1 épisode reste sobre : elle sert d'ancre.
      var season = !!(p && o.films > 1);
      var pk = p ? 'off_p' + (o.films > 6 ? 6 : o.films) : '';
      var badge = season && promoName() ? promoName().toUpperCase() : (p ? tx(pk + '_badge', p.badge || '') : o.badge);
      html += '<label class="lp-offer' + (on ? ' is-on' : '') + (badge ? ' has-badge' : '') + (season ? ' is-season' : '') + '" data-offer="' + esc(id) + '">' +
        '<input type="radio" name="lp-offer" value="' + esc(id) + '"' + (on ? ' checked' : '') + '>' +
        (badge ? '<span class="lp-offer-badge">' + esc(badge) + '</span>' : '') +
        '<span class="lp-offer-top"><span class="lp-offer-label">' + esc(p ? fill(tx(pk + '_name', p.name)) : o.label) + '</span>' +
          '<span class="lp-offer-price">' + (struck > price ? '<s>' + esc(money(struck)) + '</s>' : '') + '<span>' + esc(money(price)) + '</span></span></span>' +
        '<span class="lp-offer-head">' + esc(p ? fill(tx(pk + '_deal', p.deal).replace(/\{n\}/g, o.films)) : o.headline || '') +
          (season && struck > price ? '<span class="lp-offer-off">' + Math.round((1 - price / struck) * 100) + '% OFF</span>' : '') + '</span>' +
        (season && promoName() ? '<span class="lp-offer-cd" data-cdbox>' + fillE(tx('off_cd', '⏳ {promo} price ends {when}'), { promo: promoName(), when: promoWhen() }) + ' · <b class="lp-cd"></b></span>' : '') +
        // 24/10 ~13 h 30 (Paul : « met pas images et tout dans Full season ») : les cadeaux en une ligne ; ~14 h 40 (Paul :
        // « développe tous les gifts sur une ligne ») : tout ce que la commande livre déjà (affiches et coloriages : gifts.js ;
        // billet et QR : /ticket ; lien famille et téléchargement : cinema.js ; vraie photo au générique : fabriquer_commande).
        // ~15 h 30 (Paul : « met pas tous les cadeaux, ça fait abusé et fake… premium, vraie valeur pas gadget ») : seulement
        // ce que la saison ajoute (l'Activity Pack), à son prix de vente réel ; billet, lien famille, téléchargement et photo
        // au générique sont dans chaque commande (FAQ), donc pas des cadeaux de la saison.
        // ~16 h 20 (Paul) : le pack n'est plus dans la carte saison ; il reste à sa place sous les cartes, coché « FREE ».
        // ~16 h 50 (Paul : « les cadeaux Paul's Activity Pack… movie poster, coloring, ajoute le QR code pour voir à tout moment ») :
        // le billet à QR est listé dans le pack ; le redire ici le compterait deux fois sur la même page.
        (p ? ''
          : '<ul>' + (o.bullets || []).map(function (b) { return '<li>' + fillE(b, vars2) + '</li>'; }).join('') + '</ul>') +
        (o.films === 1 && episodesOf(a) ? episodeSelectHtml() : '') +
        '</label>';
    });
    return { html: html, count: available };
  }

  // Épisode au choix pour l'offre d'un seul film (Paul, 24/10 ~15 h 20 : « elle doit pouvoir choisir entre les 6 épisodes,
  // c'est crédible, et ça doit envoyer le bon »). Titres = series.<aventure>.episodes publiés par le Worker series6 de 6e
  // (une seule source, 6e 24/10 ~16 h), épisodes « ready » seulement ; il fabrique l'épisode reçu dans /api/checkout. Allumé
  // par settings.episode_pick = true dans le catalogue, posé seulement quand Paul a tranché le message des ép. 2-5.
  function episodesOf(a) {
    if (!a || !CAT.settings || CAT.settings.episode_pick !== true) return null;
    var s = CAT.series && CAT.series[a.id];
    var e = s && Array.isArray(s.episodes) ? s.episodes.filter(function (x) { return x && x.ready === true && x.title; }) : [];
    return e.length > 1 ? e : null;
  }
  function episodePick() {
    var eps = episodesOf(adventure());
    if (!eps || (CAT.offers[S.offer] || {}).films !== 1) return null;
    var n = Number(S.episode) || 1;
    return eps.some(function (x) { return x.n === n; }) ? n : eps[0].n;
  }
  // ~16 h 20 (Paul : « un truc déroulant… comme un bundle sur un shop normal ») : un menu dans la carte du film.
  function episodeSelectHtml() {
    var eps = episodesOf(adventure());
    var n = Number(S.episode) || 1;
    if (!eps.some(function (x) { return x.n === n; })) n = eps[0].n;
    return '<span class="lp-ep-row"><select class="lp-ep-sel" id="lp-ep-sel" aria-label="Episode">' +
      eps.map(function (x) {
        return '<option value="' + x.n + '"' + (n === x.n ? ' selected' : '') + '>' + esc(x.n + ' · ' + fill(x.title)) + '</option>';
      }).join('') + '</select></span>';
  }

  // L'offre du bras dont les cadeaux contiennent déjà ce pack (mêmes affiches et coloriages, ou plus) : là, il est offert.
  function freeOfferFor(b) {
    var k = ((CAT.offers[b.offer] || {}).gifts) || {};
    if (!k.poster && !k.coloring) return null;
    var arm = armDef();
    return arm.offers.filter(function (id) {
      var g = (CAT.offers[id] || {}).gifts || {};
      return (CAT.offers[id] || {}).films > 1 && (g.poster || 0) >= (k.poster || 0) && (g.coloring || 0) >= (k.coloring || 0);
    })[0] || null;
  }

  // Cases à cocher (ex. le pack d'activités d'Halloween), seulement si le catalogue les active et si la variante existe.
  function bumpsFor() {
    return (CAT.bumps || []).filter(function (b) {
      var o = CAT.offers[b.offer];
      var bv = bumpVariant(b);
      return o && bv && bv.available !== false && (!b.until || new Date() <= new Date(b.until)) && (!b.show_for_adventures || !b.show_for_adventures.length || b.show_for_adventures.indexOf(S.adventure) >= 0);
    });
  }

  var SIBLING_PCT = 30; // repli : le Worker renvoie sibling_pct avec sibling: true
  function siblingPct() { return (S && S.sibling && (Number(S.siblingPct) || SIBLING_PCT)) || 0; }
  function siblingOff() {
    var v = variantBySku(skuFor(S.offer));
    return v && v.autoDiscount ? 0 : Math.floor((priceOf(S.offer) || 0) * siblingPct() / 100);
  }
  function cartTotal() {
    var total = (priceOf(S.offer) || 0) - siblingOff();
    (S.bumps || []).forEach(function (id) {
      var b = (CAT.bumps || []).filter(function (x) { return x.id === id; })[0];
      var bv = bumpVariant(b);
      if (bv) total += bv.price;
    });
    return total;
  }

  // L'offre saison disponible dans le bras (variante Shopify présente), sinon null.
  function seasonId() {
    var arm = armDef(), sid = null;
    arm.offers.forEach(function (id) { var x = CAT.offers[id]; if (!sid && x && x.films > 1 && planOf(id) && priceOf(id) !== null) sid = id; });
    return sid;
  }

  // 24/10 ~11 h 30 (Paul : « voir ce paywall plus comme une page produit… les bénéfices, la promesse ») : le haut des 21 PDP
  // mesurées (direct-response/references/pdp.md : nom du produit, note, phrase, bénéfices à icônes). 24/10 ~13 h 30 (Paul :
  // « garde le côté personnalisé pour l'enfant et pas broad… la tête de l'enfant généré à la fin de la bande-annonce, avec le
  // nom ») : le nom du produit est le carton de fin de la bande-annonce (portrait 3D, STARRING, prénom, titre du film), et
  // ses 4 bénéfices, courts, en grille comme avant.
  function pdpTopHtml() {
    var a = adventure(), img = S.preview && S.preview.url, nm = vars().name, full = fill(a.title);
    var sub = full.indexOf(nm) === 0 ? full.slice(nm.length).trim() : a.short_title || full;
    // 28/10 (Paul : « comme le packaging… elle sait à quoi elle va avoir droit ») : l'affiche de l'étape 6 en vignette.
    var poster = S.preview && S.preview.poster;
    return '<div class="lp-pw-card' + (poster ? ' has-poster' : '') + '"' + ed('z_off_top') + '>' + (poster ? '<img src="' + esc(poster) + '" alt="' + fillE('{Name}\'s movie poster') + '">'
      : img ? '<img src="' + esc(img) + '" alt="' + fillE('{Name} as a 3D animated hero') + '">' : '') +
      '<div class="lp-pw-cardtext"><p class="lp-endcard-kicker">' + fillE(tx('off_starring', 'Starring')) + '</p><h2 class="lp-pw-name">' + esc(nm.toUpperCase()) + '</h2><p class="lp-pw-story">' + esc(sub) + '</p></div></div>' +
      '<p class="lp-pw-rate"' + ed('z_off_trust') + '>' + tpLink(TP_STARS + '<b>' + esc(trustT('rating', 'Excellent')) + '</b> ' + esc(tx('off_rate_on', 'on')) + ' ' + esc(tpName())) + '</p>' +
      (pwT('promise', 'More than a cartoon: an adventure where {name} becomes the hero.') ? '<p class="lp-pw-promise"' + ed('z_off_top') + '>' + fillE(pwT('promise', 'More than a cartoon: an adventure where {name} becomes the hero.')) + '</p>' : '');
  }
  var STUDY_TXT = 'Kids copy their heroes, even more when the hero is them. In a 2025 study of 315 kids aged 5 to 6, a story about a hero who shares made them share more, and even more when the hero had their own photo and name.';
  function pdpBenefitsHtml() {
    return '<ul class="lp-pdp4"' + ed('z_off_ben') + '>' + [
      [pwT('b1_icon', '🎁'), pwT('b1_title', 'A gift {they}\'ll truly love'), pwT('b1_text', '{Their} face, {their} name, your words')],
      [pwT('b2_icon', '🦸'), pwT('b2_title', 'This time, {name} is the hero'), pwT('b2_text', 'in every scene, in 3D')],
      // ~15 h 30 (Paul : « remplace découvre le courage par quelque chose qui englobe courage, gentillesse, entraide ») :
      // ce que vit le héros dans l'histoire (ép. 1-6 : ramener Button, saluer le squelette seul, guider dans la tempête),
      // jamais « teaches values » (ETUDE_personnalisation §4).
      [pwT('b3_icon', '💛'), pwT('b3_title', 'Good values, lived by {name}'), pwT('b3_text', 'courage, kindness, helping others, while having fun')],
      [pwT('b4_icon', '👀'), pwT('b4_title', 'Watch {their} reaction live'), pwT('b4_text', 'together, the moment it starts')]
    ].filter(function (x) { return x[1]; }).map(function (x) { return '<li><i aria-hidden="true">' + esc(x[0]) + '</i><span><b>' + fillE(x[1]) + '</b>' + fillE(x[2]) + '</span></li>'; }).join('') + '</ul>' +
      // ~15 h 30 (Paul : « très petit, l'étude sérieuse ») : la phrase de l'étude déjà en ligne le 24/10 matin, dite telle quelle.
      (pwT('study', STUDY_TXT) ? '<p class="lp-pw-study"' + ed('z_off_ben') + '>★ ' + fillE(pwT('study', STUDY_TXT)) + ' <span>' + esc(pwT('study_src', 'Kotaman & Balcı (2025), Early Childhood Education Journal')) + '</span></p>' : '');
  }
  // A/B de la page d'offre (Paul, 30/10 ~14 h 40) : chrono seul contre chrono + quota de la semaine du studio. Arrêté le
  // 02/11 ~22 h 30 : chrono seul gagnant (20 ventes / 120 visiteurs, 7,71 $ par visiteur, 17 saisons, contre 13 / 112,
  // 3,95 $, 5 saisons). Paul : « on enlève… celui du stock… et on change par rien sauf un petit attention, nous ne pouvons
  // pas garantir la disponibilité des stocks durant notre meilleure offre de l'année du Early Black Friday ».
  // Test suivant (abw) : 'chrono' = la carte saison et son chrono seuls (témoin) ; 'note' = en plus, cette petite ligne.
  // Tiré une fois à la 1re vue d'une offre qui vend la saison ; part avec step_view, offer_view et checkout_click (abw ;
  // abwf = 1 si forcé). Forcer pour vérifier : ?abw=chrono ou ?abw=note. Lecture : onglet A/B de genstack.
  var ABQ = 'offer-attention-2026-11-02';
  function abq() {
    if (S.abq && S.abq.id === ABQ) return S.abq;
    var f = /^(chrono|note)$/.exec(params.get('abw') || '');
    // Éditeur : toujours le bras « note » (= A + la ligne), pour que la ligne se voie et se modifie ; mention en rouge dessous.
    S.abq = { id: ABQ, c: f ? f[0] : (DESIGN || Math.random() < 0.5 ? 'note' : 'chrono'), forced: !!f };
    save();
    return S.abq;
  }
  function abqData(d) {
    if (S.abq && S.abq.id === ABQ) { d.abw = S.abq.c; if (S.abq.forced) d.abwf = 1; }
    return abData(d);
  }
  function quotaHtml() {
    if (!seasonId() || abq().c !== 'note') return '';
    var t = tx('off_note', '⚠️ Heads up: we can\'t guarantee stock availability during our best offer of the year, Early Black Friday.');
    return t ? '<p class="lp-bfnote" role="note"' + ed('z_off_buy') + '>' + fillE(t) + '</p>' +
      (DESIGN ? '<span class="lp-dyk-ed">Editor only: A/B test — half of the visitors see this line, the other half don\'t.</span>' : '') : '';
  }
  // Les moyens de paiement réellement actifs (shop.enabled_payment_types, rendus par la section, logos de Shopify).
  function payHtml() {
    var t = document.getElementById('lp-pay');
    return t && t.innerHTML.trim() ? '<div class="lp-pay" role="img" aria-label="Accepted payment methods">' + t.innerHTML + '</div>' : '';
  }

  // 02/11 (Paul : « pouvoir modifier le copywriting sur le paywall ») : les textes de l'offre sont des réglages de la section
  // (Personnaliser › LP — Create funnel › « Offer page — texts »), lus à chaque affichage (l'éditeur montre la frappe). Par
  // défaut = les textes d'avant, mot pour mot. Réglage vidé ou « - » = la ligne disparaît (sauf le bouton, jamais vide).
  // Sans le groupe dans la config (section d'avant), les textes d'avant.
  function pwT(k, d) {
    var P = CFG.pw;
    if (!P || P[k] === undefined) return d;
    var v = String(P[k] == null ? '' : P[k]).trim();
    return v === '-' ? '' : v;
  }
  function pwFaq() {
    if (!Array.isArray(CFG.faq)) return PAYWALL_FAQ;
    return CFG.faq.map(function (f) { return [String(f.q || '').trim(), String(f.a || '').trim()]; })
      .filter(function (f) { return f[0] && f[1] && f[0] !== '-'; });
  }
  var PAYWALL_FAQ = [
    ['What exactly do we get?', 'Each episode is a 3-minute 3D animated movie where {name} is the hero: {their} face, {their} costume, {their} name said out loud by the narrator, and your message at the end. With the Full Season, {name} stars in 6 episodes and gets {their} Activity Pack: movie posters and coloring pages to print. It all arrives by email, on a private movie page you can watch, download and share.'],
    ['When does it arrive?', 'By email, within {delivery_hours} hours. With the Full Season, all the episodes arrive together.'],
    ['Will it really look like {name}?', 'The movie is made from the 3D hero you just saw. Not quite {them}? Go back and try another photo before you order.'],
    ['What if we don\'t love it?', 'Reply to your delivery email within 30 days: we remake the movie for free (usually within 24 hours), with a new photo, a corrected name or a different adventure. Nothing to send back.'],
    ['Is it scary?', 'No. Every adventure is gentle, funny and friendly, made for little ones. Nothing scary, even on Halloween.'],
    ['Is {name}\'s photo safe?', '{photo_rule} Only one AI model ever sees it, it is never public, and it is never used to train AI.'],
    ['Is it made with AI?', 'Yes. Our studio uses AI to bring {name} into the movie. That\'s why you saw {their} 3D hero for free, and why the movie is ready in {delivery_hours} hours.'],
    ['Is this a subscription?', 'No. You pay once, and that\'s it.'],
    ['Can the whole family watch?', 'Yes. You get a private movie page and a family link to share with everyone.'],
    ['Is it a good gift?', 'It\'s the gift where they are the star. Print the free premiere ticket to reveal it in style.']
  ];

  function renderOffer() {
    if (needMail() && S.preview && S.preview.state === 'done') { S.step = 'preview'; save(); return renderPreview(); } // abe B : l'email d'abord
    if (S.adventure === 'dino') abArm('abt'); // tiré ici : il part dans le step_view de l'offre
    if (S.adventure === 'christmas') abArm('abn');
    if (freshLinks(function () { if (S.step === 'offer') renderOffer(); })) return;
    var arm = armDef();
    if (!S.offerTouched || !S.offer || arm.offers.indexOf(S.offer) < 0) S.offer = preselectFor(arm);
    var bumps = bumpsFor();
    S.bumps = (S.bumps || []).filter(function (id) { return bumps.some(function (b) { return b.id === id; }); });
    var cards = offerCards(arm);
    if (!cards.count) return showError('This offer is not available right now. Please come back in a few minutes.', function () { go('offer'); });
    var faq = pwFaq().map(function (f) {
      return '<details class="lp-faq"><summary>' + fillE(f[0]) + '</summary><p>' + fillE(f[1], { photo_rule: photoRule() }) + '</p></details>';
    }).join('');
    // ~16 h 20 (Paul : « le Paul's Activity Pack offert dans la Full Season, en upsell au prix affiché de 15,98 $… qu'il reste
    // exactement au même endroit quand tu as la Full Season, juste sélectionné et marqué en gros comme offert ») : la case
    // ne bouge pas ; avec une offre dont les cadeaux couvrent le pack (season6 : 6 affiches + 6 coloriages), elle est cochée,
    // grisée et « FREE with The Full Season », et rien n'est ajouté au panier (le pack est déjà dans les cadeaux de l'offre).
    var bumpHtml = bumps.map(function (b) {
      var bv = bumpVariant(b);
      return '<label class="lp-bump" data-bumpbox="' + esc(b.id) + '"' + ed('z_off_cards') + '><input type="checkbox" data-bump="' + esc(b.id) + '"' + (S.bumps.indexOf(b.id) >= 0 ? ' checked' : '') + '> <span><b>' + fillE(tx('off_pack_title', b.label || 'Add {Name}\'s Activity Pack')) +
        '<span class="lp-bump-paid"> · +' + esc(money(bv.price)) + '</span></b>' +
        '<span class="lp-bump-free"><s>' + esc(money(bv.price)) + '</s> ' + esc(tx('off_pack_free', 'FREE with {plan}').replace(/\{plan\}/g, (CAT.offers[freeOfferFor(b)] || {}).label || 'the season')) + '</span>' +
        // ~16 h 50 (Paul : « met pas les quantités mais met : movie poster, coloring… le QR code… que ça vaille 16 $ ») : b.items.
        (Array.isArray(b.items) && b.items.length ? '<ul class="lp-bump-list">' + b.items.map(function (x, i) { x = tx('off_pack_' + (i + 1), x); return x ? '<li>' + fillE(x) + '</li>' : ''; }).join('') + '</ul>'
          : '<span class="lp-muted lp-small lp-bump-txt">' + fillE(b.text || '') + '</span>') + '</span></label>';
    }).join('');
    app.innerHTML =
      '<div class="lp-card lp-paywall">' + progress('offer') +
      pdpTopHtml() +
      trailerHtml() +
      pdpBenefitsHtml() +
      quotaHtml() +
      '<p class="lp-muted lp-pw-sub"' + ed('z_off_cards') + '>' + fillE(cards.count > 1 ? pwT('choose', 'Choose how many adventures {name} gets to live:') : pwT('one', '{Name}\'s own movie, starring the 3D hero you just met.')) + '</p>' +
      (siblingPct() ? ' <p class="lp-pill">' + fillE(tx('off_sibling', '🎁 {pct}% off applied for a brother or sister'), { pct: siblingPct() }) + '</p>' : '') +
      '<div class="lp-offers" role="radiogroup" aria-label="Your movie"' + ed('z_off_cards') + '>' + cards.html + '</div>' +
      '<div id="lp-bumps">' + bumpHtml + '</div>' +
      // 24/10 ~12 h 20 (Paul, capture 60 : « le bundle et directement le moyen de payer ») : le bouton suit les cartes ;
      // ~13 h 30 (Paul : « en dessous du add to cart les badges de paiement, la garantie… trust pilot et tout »).
      '<button type="button" class="lp-btn lp-btn-full lp-btn-big" id="lp-buy"' + ed('z_off_buy') + '></button>' +
      payHtml() +
      // 03/11 ~16 h (Paul, captures 21-23 : « juste en dessous [des moyens de paiement] "Secure payment, love it or we remake
      // free"… et sous ça, les avis Trustpilot ») : badges + note + avis sous les logos, la garantie ensuite.
      trustWallHtml() +
      // 23/10 ~17 h 30 (Paul : « une garantie de fou… impossible d'être déçu ») ; 24/10 ~12 h 20 : en deux lignes.
      '<div class="lp-guarantee lp-guarantee-big"' + ed('z_off_trust') + '><b>🛡️ ' + esc(guarantee()) + '</b><p>' + fillE(trustT('guarantee_text', 'Not amazed? We remake it for free within 30 days. Nothing to send back.')) + '</p>' +
        // 24/10 : ligne réglée par Paul dans l'éditeur de thème (« Line under the guarantee ») ; vide = rien.
        (trustStat() ? '<p class="lp-trust-stat">' + esc(trustStat()) + '</p>' : '') + '</div>' +
      dyk('offer') +
      (tx('off_photo', '🔒 {Name}\'s photo: {photo_rule}') ? '<p class="lp-promise"' + ed('z_off_buy') + '>' + fillE(tx('off_photo', '🔒 {Name}\'s photo: {photo_rule}'), { photo_rule: photoRule() }) + '</p>' : '') +
      (faq ? '<div class="lp-faqs"' + ed('z_off_faq') + '>' + (pwT('faq_title', 'Questions families ask') ? '<h3>' + fillE(pwT('faq_title', 'Questions families ask')) + '</h3>' : '') + faq + '</div>' : '') +
      '<button type="button" class="lp-link" id="lp-back"' + ed('z_off_buy') + '>' + fillE(tx('off_back', 'Back to the preview')) + '</button>' +
      '</div>' +
      '<div class="lp-sticky" id="lp-sticky" hidden' + ed('z_off_buy') + '><button type="button" class="lp-btn lp-btn-full" id="lp-buy2"></button>' +
        '<p>🛡️ ' + esc(guarantee()) + (promoName() ? '<span data-cdbox> · ⏳ <span class="lp-cd"></span></span>' : '') + '</p></div>';
    startTrailer();
    startCountdowns();
    startAutoscroll(app);
    var sticky = document.getElementById('lp-sticky');
    // Le pack d'activités d'Halloween ne s'ajoute qu'à l'épisode seul : la saison a déjà son Activity Pack (23/10 ~14 h).
    function syncBumps() {
      var one = (CAT.offers[S.offer] || {}).films === 1;
      var any = false;
      bumps.forEach(function (b) {
        var box = app.querySelector('[data-bumpbox="' + b.id + '"]');
        var free = freeOfferFor(b) === S.offer;
        box.hidden = !one && !free;
        box.classList.toggle('is-free', free);
        box.querySelector('input').disabled = free;
        box.querySelector('input').checked = free || S.bumps.indexOf(b.id) >= 0;
        any = any || !box.hidden;
      });
      document.getElementById('lp-bumps').hidden = !any;
      if (!one && S.bumps.length) { S.bumps = []; save(); }
    }
    function refreshCta() {
      syncBumps();
      var label = fill(pwT('cta', '') || 'Make {name} the hero · {price}', { price: money(cartTotal()) });
      document.getElementById('lp-buy').textContent = label;
      document.getElementById('lp-buy2').textContent = label;
      tickCountdowns();
    }
    refreshCta();
    // La barre collante se montre quand le bouton du récapitulatif n'est pas à l'écran ; la page garde une marge pour elle.
    rootEl.classList.add('has-sticky');
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { sticky.hidden = es[0].isIntersecting; }).observe(document.getElementById('lp-buy'));
    } else sticky.hidden = false;
    track('offer_view', abqData({ offers: arm.offers, preselected: S.offer }), 5);
    if (!S.klOffer) { S.klOffer = 1; save(); klEvent('LP Offer Viewed', { offer: S.offer, price: cartTotal() / 100 }); }
    function pick(id) {
      S.offer = id;
      S.offerTouched = true;
      save();
      app.querySelectorAll('.lp-offer').forEach(function (l) { l.classList.toggle('is-on', l.getAttribute('data-offer') === S.offer); });
      app.querySelectorAll('input[name="lp-offer"]').forEach(function (r) { r.checked = r.value === S.offer; });
      refreshCta();
    }
    var epSel = document.getElementById('lp-ep-sel');
    if (epSel) {
      epSel.onchange = function () {
        S.episode = Number(this.value);
        var one = this.closest('[data-offer]').getAttribute('data-offer');
        if (S.offer !== one) pick(one); else save();
        track('episode_select', { episode: S.episode }, 5);
      };
    }
    app.querySelectorAll('input[name="lp-offer"]').forEach(function (r) {
      r.onchange = function () {
        pick(this.value);
        var v = variantBySku(skuFor(S.offer));
        track('offer_select', { offer: S.offer, price: v ? v.price / 100 : null }, 5);
      };
    });
    app.querySelectorAll('input[data-bump]').forEach(function (c) {
      c.onchange = function () {
        var id = this.getAttribute('data-bump');
        S.bumps = S.bumps.filter(function (x) { return x !== id; });
        if (this.checked) S.bumps.push(id);
        save();
        refreshCta();
        track('bump_toggle', { bump: id, on: this.checked }, 5);
      };
    });
    document.getElementById('lp-back').onclick = function () { go('preview'); };
    var buy = function () {
      if (CAT.interstitial && CAT.interstitial.enabled && variantBySku(skuFor(CAT.interstitial.offer))) { go('interstitial'); track('interstitial_view', {}, 5); }
      else checkout(false);
    };
    document.getElementById('lp-buy').onclick = buy;
    document.getElementById('lp-buy2').onclick = buy;
  }

  function renderInterstitial() {
    var it = CAT.interstitial;
    var v = variantBySku(skuFor(it.offer));
    app.innerHTML = '<div class="lp-card lp-center"><h2 class="lp-h2">' + fillE(it.title) + '</h2><p class="lp-muted">' + fillE(it.text) + '</p>' +
      '<button type="button" class="lp-btn lp-btn-full" id="lp-yes">' + fillE(it.yes_label) + (v ? ' · +' + esc(money(v.price)) : '') + '</button>' +
      '<button type="button" class="lp-link" id="lp-no">' + fillE(it.no_label) + '</button></div>';
    document.getElementById('lp-yes').onclick = function () { track('interstitial_yes', {}, 5); checkout(true); };
    document.getElementById('lp-no').onclick = function () { track('interstitial_no', {}, 5); checkout(false); };
  }

  // Comme StarringYou (rapport A §1.5) : vider le panier, ajouter LA ligne, aller au checkout. Jamais de photo dans la ligne.
  function checkout(withExtra) {
    if (DEMO) return;
    var btns = ['lp-buy', 'lp-buy2', 'lp-yes'].map(function (id) { return document.getElementById(id); }).filter(Boolean);
    var label = btns.length ? btns[0].textContent : '';
    btns.forEach(function (b) { b.disabled = true; b.textContent = 'Opening secure checkout…'; });
    api('/api/checkout', { method: 'POST', json: { offer_id: S.offer, bumps: S.bumps || [], interstitial: !!withExtra, episode: episodePick() || undefined } })
      .then(function (res) {
        // 01/11 : la variante du SKU renvoyé d'abord (variante propre à l'aventure, son affiche au paiement), puis celle de l'offre.
        var mainId = (variantBySku(res.sku) || {}).id || res.variant_id;
        if (!mainId) throw Object.assign(new Error('variant_missing'), { code: 'variant_missing' });
        var items = [{ id: mainId, quantity: 1, properties: res.properties }];
        (res.extra || []).forEach(function (x) {
          var id = x.variant_id || (variantBySku(x.sku) || {}).id;
          if (id) items.push({ id: id, quantity: 1, properties: x.properties });
        });
        var value = cartTotal() / 100;
        track('checkout_click', abqData({ offer: S.offer, sku: res.sku, value: value, currency: CFG.currency || 'USD' }), 6);
        klEvent('LP Checkout Started', { offer: S.offer, value: value });
        return fetch(ROOT + 'cart/clear.js', { method: 'POST', headers: { 'content-type': 'application/json' }, credentials: 'same-origin' })
          .then(function () {
            // Shopify ne garde un checkout abandonné que s'il a l'e-mail (Paul, 23/10 ~17 h : « détecter les checkouts
            // abandonnés »). Le lien de panier /cart/<variante>:1 le pré-remplit (checkout[email], vérifié en ligne le 23/10 ;
            // /checkout?checkout[email]= ne le fait pas). Il ne porte des propriétés que sur la 1re ligne : avec un ajout
            // (Activity Pack…), panier AJAX comme avant, sans e-mail pré-rempli.
            if (items.length === 1 && S.email) {
              S.checkoutAt = Date.now();
              save();
              location.href = ROOT + 'cart/' + items[0].id + ':1?properties=' + b64url(JSON.stringify(items[0].properties || {})) +
                '&checkout[email]=' + encodeURIComponent(S.email) + (res.discount_code ? '&discount=' + encodeURIComponent(res.discount_code) : '');
              return 'permalink';
            }
            return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'content-type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ items: items }) });
          })
          .then(function (r) {
            if (r === 'permalink') return;
            if (!r.ok) throw Object.assign(new Error('cart_add'), { code: 'cart_add' });
            S.checkoutAt = Date.now();
            save();
            location.href = ROOT + 'checkout' + (res.discount_code ? '?discount=' + encodeURIComponent(res.discount_code) : '');
          });
      })
      .catch(function (e) {
        btns.forEach(function (b) { b.disabled = false; b.textContent = label; });
        if (e.code === 'adventure_closed') { S.adventure = null; return renderPick('This adventure just closed for new orders. Please pick another one.'); }
        if (e.code === 'variant_missing' || e.code === 'cart_add') return showError('This offer is not available right now. Please try again in a few minutes.', function () { go('offer'); });
        showError(friendly(e), function () { go('offer'); });
      });
  }

  // Clarity (genstack, cockpit LP, bloc Funnel, 02/11/2026 ; Paul : « masquage strict, aucune photo d'enfant ni prénom dans les
  // enregistrements, et chaque session taguée avec le sid, l'étape et le bras A/B »). Réglage « Clarity project ID » de la
  // section : vide = éteint. L'intégration d'app « Microsoft Clarity » doit être désactivée : si elle tourne, rien n'est chargé.
  // Chargé après l'effacement du #h= (code de reprise), jamais avec ?sib= ni ?_kx= (jeton et identifiant Klaviyo dans l'URL).
  // Toute la page est masquée (data-clarity-mask sur body) : textes, prénoms, src des images et des vidéos. clarity.js (0.8.77)
  // ne nettoie jamais aria-label, poster ni style : aucun prénom ni lien d'image n'y est posé dans ce fichier.
  var CLARITY = String(CFG.clarity_id || '').replace(/[^a-z0-9]/gi, '');
  var clarityOn = false;
  function clarityStart() {
    if (clarityOn || !CLARITY || DESIGN || window.clarity || params.get('sib') || params.get('_kx')) return;
    clarityOn = true;
    document.body.setAttribute('data-clarity-mask', 'true');
    window.clarity = function () { (window.clarity.q = window.clarity.q || []).push(arguments); }; // file d'attente avant le chargement
    var t = document.createElement('script');
    t.async = 1;
    t.src = 'https://www.clarity.ms/tag/' + CLARITY;
    document.head.appendChild(t);
    // Consentement : le même que l'intégration d'app (bannière Shopify ; EEE, Royaume-Uni, Suisse).
    var send = function (ad, an) { window.clarity('consentv2', { ad_Storage: ad ? 'granted' : 'denied', analytics_Storage: an ? 'granted' : 'denied', source: 101 }); };
    if (window.Shopify && Shopify.loadFeatures) Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (!err) send(Shopify.customerPrivacy.marketingAllowed(), Shopify.customerPrivacy.analyticsProcessingAllowed());
    });
    document.addEventListener('visitorConsentCollected', function (e) { send(e.detail.marketingAllowed, e.detail.analyticsAllowed); });
  }
  // Tags de session, à chaque écran : sid (le sid seul n'ouvre rien), étape vue, bras de chaque A/B (f = forcé, nos vérifications).
  function clarityTag(d) {
    if (typeof window.clarity !== 'function' || !S || !S.sid) return; // 02/11 : Clarity chargé par l'app Shopify (Paul) ou par clarityStart
    window.clarity('set', 'sid', S.sid);
    window.clarity('set', 'etape', d.name);
    for (var k in d) if (/^ab[a-z]$/.test(k)) window.clarity('set', k, d[k] + (d[k + 'f'] ? 'f' : ''));
  }

  // ------------------------------------------------------------ blocs « Custom Liquid » de la section (02/11, Paul : « rajouter
  // des codes liquides » sur chaque étape). Shopify rend chaque bloc dans un <template class="lp-liq"> (inerte) ; ici, à
  // chaque écran dessiné, les blocs de cet écran (ou « All screens ») sont posés en haut, à la place du « Did you know? »
  // ou en bas de la carte. {name}, {Name}, {their}… = le prénom et les pronoms ; les <script> s'exécutent à chaque affichage.
  var LIQ_VARS = /\{(name|Name|age|they|them|their|themself|They|Their|Them|from)\}/g;
  // 02/11 (Paul : « des petites sections qui ajoutent de la confiance, accrocheuses, déjà cachées… sur chaque partie du
  // funnel ; sur le paywall plusieurs endroits où je n'ai qu'à écrire ») : blocs « Trust / copy box » (CFG.boxes) : avis
  // Trustpilot, note cliquable, encadré, ligne à icône, texte. Même placement que les blocs Liquid. Montrés si « Show on the
  // site » est coché, sans [ ] restant, et dans le bon bras du test « Did you know? » A vs B (abk) ; l'éditeur montre tout.
  function holeBox(b) { return /\[[^\]]*\]/.test([b.title, b.text, b.name].join(' ')); }
  function boxHtml(b) {
    var t = fill(b.title || ''), x = fill(b.text || ''), n = fill(b.name || ''), ic = String(b.icon || '').trim(), h;
    if (b.look === 'review') {
      h = '<figure class="lp-rv lp-box lp-box-review">' + starsHtml(b.stars) + '<blockquote>' + (t ? '<b>' + esc(t) + '</b>' : '') + (x ? ' ' + esc(x) : '') + '</blockquote>' +
        '<figcaption>' + (n ? esc(n) + ' · ' : '') + esc(trustT('review_line', 'Review on ' + tpName())) + '</figcaption></figure>';
    } else if (b.look === 'rating') {
      h = '<p class="lp-box lp-box-rating">' + starsHtml(b.stars) + (t ? '<b>' + esc(t) + '</b>' : '') + (x ? '<span>' + esc(x) + '</span>' : '') + '</p>';
    } else if (b.look === 'highlight') {
      h = '<div class="lp-box lp-box-hl" role="note">' + (t ? '<b>' + (ic ? esc(ic) + ' ' : '') + esc(t) + '</b>' : '') + (x ? '<p>' + esc(x) + '</p>' : '') + '</div>';
    } else if (b.look === 'line') {
      h = '<p class="lp-box lp-box-line">' + (ic ? '<i aria-hidden="true">' + esc(ic) + '</i>' : '') + '<span>' + (t ? '<b>' + esc(t) + '</b> ' : '') + esc(x) + '</span></p>';
    } else {
      h = '<div class="lp-box lp-box-text">' + (t ? '<p class="lp-box-t">' + (ic ? esc(ic) + ' ' : '') + esc(t) + '</p>' : '') + (x ? '<p>' + esc(x) + '</p>' : '') + '</div>';
    }
    var u = String(b.link || '').trim();
    if (u) h = '<a class="lp-box-a" href="' + esc(u) + '"' + (/^https?:/.test(u) ? ' target="_blank" rel="noopener"' : '') + '>' + h + '</a>';
    if (DESIGN) {
      h += (b.on === false ? '<span class="lp-dyk-ed">Editor only: not on the site until « Show on the site » is ticked.</span>'
        : holeBox(b) ? '<span class="lp-dyk-ed">Editor only: hidden on the site until every [ ] is filled in.</span>' : '') +
        (b.arm === 'a' || b.arm === 'b' ? '<span class="lp-dyk-ed">Editor only: Version ' + b.arm.toUpperCase() + ' of the A/B test « Did you know? » A vs B.</span>' : '');
    }
    return h;
  }
  // Où poser un encart : [parent, nœud avant lequel insérer] ; calculé une fois par écran (l'ordre des blocs est gardé).
  function anchorOf(card, pos) {
    var q = function (sel) { return card.querySelector(sel); }, el;
    if (pos === 'top') return [card, card.firstChild];
    if (pos === 'dyk') { el = q('.lp-dyk-card'); return el ? [el.parentNode, el] : [card, null]; }
    if (pos === 'pw_rating') el = q('.lp-pw-promise') || q('.lp-pw-rate');
    else if (pos === 'pw_trailer') el = q('#lp-trailer');
    else if (pos === 'pw_benefits') el = q('.lp-pw-study') || q('.lp-pdp4');
    else if (pos === 'pw_button') el = q('.lp-pay') || q('#lp-buy');
    else if (pos === 'pw_guarantee') el = q('.lp-guarantee');
    if (el) return [el.parentNode, el.nextSibling];
    if (pos === 'pw_offers') { el = q('.lp-bf') || q('.lp-pw-sub'); if (el) return [el.parentNode, el]; }
    if (pos === 'pw_faq') { el = q('.lp-faqs'); if (el) return [el.parentNode, el]; }
    return [card, null];
  }
  // 03/11 ~12 h (Paul : « je copie le code liquide et je l'ajoute directement dessus… il y a 6 étapes entre temps » : les
  // positions fines n'existaient que sur l'offre). Écran « Where I drag it » (step = auto) : le bloc se pose juste après la
  // zone du bloc qui le précède dans la liste de gauche (after = sa clé, calculée par le Liquid), sur l'écran de cette zone.
  function autoScreen(after) { var k = String(after || '').split(':')[0]; return !k || k === 'z_head' ? 'hero' : (ZONE_SCREEN[k] || ''); }
  function anchorAfter(card, key) {
    if (!key || key === 'z_head') return [card, card.firstChild];
    var els = card.querySelectorAll('[data-ed="' + key + '"]'), el = els[els.length - 1];
    if (!el) return null;
    while (el.parentNode !== card && el.parentNode.tagName !== 'FORM') el = el.parentNode;
    return [el.parentNode, el.nextSibling];
  }
  function injectLiq() {
    var tpls = document.querySelectorAll('template.lp-liq'), boxes = (CFG.boxes || []).filter(function (b) { return b && b.id; }),
      autoF = FACTS.filter(function (f) { return f.step === 'auto'; });
    if ((!tpls.length && !boxes.length && !autoF.length) || !S || !S.step) return;
    var card = app.querySelector('.lp-card');
    if (!card || card.hasAttribute('data-liq') || card.classList.contains('lp-resume') || card.querySelector('#lp-retry')) return;
    if (card.children.length === 1 && card.querySelector('.lp-spinner')) return; // écran de chargement : l'écran vrai suit
    card.setAttribute('data-liq', '1');
    var scr = curScreen(), v = vars(), at = {}, k = null;
    function place(pos, node) {
      if (!at[pos]) at[pos] = pos.indexOf('after:') === 0 ? (anchorAfter(card, pos.slice(6)) || anchorOf(card, 'bottom')) : anchorOf(card, pos);
      at[pos][0].insertBefore(node, at[pos][1]);
    }
    autoF.forEach(function (f) {
      if (autoScreen(f.after) !== scr) return;
      if (!DESIGN) {
        if (f.on === false || hole(f)) return;
        if (f.arm === 'a' || f.arm === 'b') { if (k === null) k = abArm('abk'); if (f.arm !== k) return; }
      }
      var w = document.createElement('div');
      w.innerHTML = dykCard(f);
      if (w.firstChild) place('after:' + (f.after || ''), w.firstChild);
    });
    boxes.forEach(function (b) {
      if (b.step === 'auto' ? autoScreen(b.after) !== scr : (b.step !== 'all' && b.step !== scr)) return;
      if (!DESIGN) {
        if (b.on === false || holeBox(b)) return;
        if (b.arm === 'a' || b.arm === 'b') { if (k === null) k = abArm('abk'); if (b.arm !== k) return; }
      }
      var w = document.createElement('div');
      w.className = 'lp-box-out';
      w.setAttribute('data-boxid', b.id);
      if (DESIGN) w.setAttribute('data-ed', 'b:' + b.id);
      w.innerHTML = boxHtml(b);
      place(b.step === 'auto' ? 'after:' + (b.after || '') : (b.pos || 'dyk'), w);
    });
    Array.prototype.forEach.call(tpls, function (t) {
      var st = t.getAttribute('data-step'), on = t.getAttribute('data-on') === 'true', af = t.getAttribute('data-after') || '';
      if ((st === 'auto' ? autoScreen(af) !== scr : (st !== 'all' && st !== scr)) || (!on && !DESIGN)) return;
      var box = document.createElement('div');
      box.className = 'lp-liq-out';
      box.setAttribute('data-liqid', t.getAttribute('data-bid'));
      if (DESIGN) box.setAttribute('data-ed', 'b:' + t.getAttribute('data-bid'));
      box.innerHTML = t.innerHTML.replace(LIQ_VARS, function (m, k2) { return esc(v[k2]); }) +
        (DESIGN && !on ? '<span class="lp-dyk-ed">Editor only: not on the site until « Show on the site » is ticked.</span>' : '');
      place(st === 'auto' ? 'after:' + af : (t.getAttribute('data-pos') || 'dyk'), box);
      Array.prototype.forEach.call(box.querySelectorAll('script'), function (old) {
        var s2 = document.createElement('script');
        Array.prototype.forEach.call(old.attributes, function (a2) { s2.setAttribute(a2.name, a2.value); });
        s2.text = old.text;
        old.parentNode.replaceChild(s2, old);
      });
    });
  }
  new MutationObserver(injectLiq).observe(app, { childList: true });
  if (DESIGN) new MutationObserver(edLink).observe(rootEl, { childList: true, subtree: true });

  // ------------------------------------------------------------ éditeur : chaque écran en démo
  // Barre « Editor preview » au-dessus du tunnel (éditeur seulement) : un clic = cet écran, avec Leo, 5 ans. Le lien
  // /pages/create?lp_step=<écran> ouvre l'éditeur directement dessus. Le portrait 3D d'exemple = l'image du costume
  // « Superhero » (fichiers Shopify) ; l'affiche = celle de l'aventure.
  var DEMO_NAV = [['hero', '1 · Name'], ['adventure', '2 · Adventure'], ['costume', '2 · Costume'], ['photo', '3 · Photo'], ['loves', '4 · Occasion'],
    ['message', '5 · Message'], ['waiting', '6 · Waiting'], ['preview', '6 · Preview'], ['offer', 'Offer page']];
  var DEMO_HERO = 'https://cdn.shopify.com/s/files/1/1054/4421/3068/files/lp-hw-costume-superhero.jpg?v=1792442335';
  function demoGo(screen, advIn) {
    if (!DEMO || !CAT) return;
    var adv = advIn || params.get('adv') || (S && S.adventure) || 'dino';
    if (screen === 'costume') { var withC = CAT.adventures.filter(function (x) { return costumesOf(x); })[0]; if (withC) adv = withC.id; }
    if (!adventure(adv)) adv = CAT.adventures[0].id;
    var a = adventure(adv);
    S = {
      v: 1, demo: true, sid: null, secret: null, adventure: adv, arm: (S && S.arm) || CAT.experiments.offer.arms[0].id, angle: '', relationship: 'parent',
      hero: { name: 'Leo', age: 5, gender: 'boy' }, email: 'demo@example.com', leadDone: true, leadSent: 1, advSeen: true,
      costume: costumesOf(a) ? (a.default_costume || costumesOf(a)[0].id) : null,
      details: { accent: guessAccent(), from: 'Grandma', message: 'We are so proud of you, Leo.', occasion: 'birthday', premiere_mode: 'asap' },
      preview: screen === 'waiting' ? { state: 'running', startedAt: Date.now() }
        : { state: 'done', url: DEMO_HERO, poster: a.poster || DEMO_HERO, poster_state: 'done', anim: null, regen_left: 2, can_regen: true, startedAt: Date.now() },
      ab: S && S.ab, dyk: S && S.dyk, abq: S && S.abq, createdAt: Date.now(), step: 'hero'
    };
    stopPolling();
    go(screen === 'waiting' ? 'preview' : screen);
    demoNav();
  }
  function demoNav() {
    var nav = document.getElementById('lp-ednav');
    if (!nav) {
      nav = document.createElement('nav');
      nav.id = 'lp-ednav';
      nav.className = 'lp-ednav';
      nav.setAttribute('aria-label', 'Editor preview');
      rootEl.insertBefore(nav, rootEl.firstChild);
      nav.onclick = function (e) { var b = e.target.closest('[data-demo]'); if (b) demoGo(b.getAttribute('data-demo')); };
    }
    var cur = curScreen();
    nav.innerHTML = '<span>Editor preview — screen:</span>' + DEMO_NAV.map(function (x) {
      return '<button type="button" data-demo="' + x[0] + '"' + (x[0] === cur ? ' class="is-on"' : '') + '>' + esc(x[1]) + '</button>';
    }).join('');
  }
  if (DEMO) new MutationObserver(function () { if (S && S.demo) demoNav(); }).observe(app, { childList: true });

  // ------------------------------------------------------------ démarrage
  function newSession() {
    var adv = (params.get('adv') || '').toLowerCase();
    var angle = params.get('a') || '';
    var utm = {};
    // adset : paramètre d'URL de la pub ({{adset.name}}), recopié sur chaque événement du journal serveur.
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'adset', 'fbclid'].forEach(function (k) { if (params.get(k)) utm[k] = params.get(k); });
    var tz = '';
    try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) { /* rien */ }
    var sib = params.get('sib') || '';
    return api('/api/session', { method: 'POST', json: { adv: adv, angle: angle, arm: params.get('o') || '', utm: utm, tz: tz, lang: navigator.language || '', sibling: sib || undefined } })
      .then(function (r) {
        S = {
          v: 1, sid: r.sid, secret: r.secret, adventure: r.adventure, arm: r.arm, angle: angle === 'grandparent' || angle === 'parent' ? angle : '',
          relationship: angle === 'grandparent' ? 'grandparent' : angle === 'parent' ? 'parent' : '',
          hero: {}, details: { accent: guessAccent() }, createdAt: Date.now(), step: 'hero',
          sibling: r.sibling === true, siblingPct: r.sibling === true ? Number(r.sibling_pct) || null : null, sib: sib || null
        };
        abLanding();
        save();
        publish('session_start', { adventure: S.adventure, angle: S.angle || null, arm: S.arm });
        // 01/11 (Paul, capture : « si les gens arrivent sur ça, tu casses tout le funnel ») : une pub vers une aventure fermée
        // (?adv=halloween après le 30/10 midi ET : 11 sessions, 0 vente) ouvrait l'ancien écran « Pick an adventure ». Le
        // Worker a déjà mis une aventure ouverte dans r.adventure : on part sur l'étape 1, le choix se fait à l'étape 2.
        go('hero');
      });
  }

  function renderResume(saved) {
    S = saved;
    var name = vars().name;
    app.innerHTML = '<div class="lp-card lp-center lp-resume"><h2 class="lp-h2">Welcome back!</h2><p class="lp-muted">' + esc('Continue ' + name + '\'s movie?') + '</p>' +
      '<button type="button" class="lp-btn lp-btn-full" id="lp-cont">Continue</button><button type="button" class="lp-link" id="lp-restart">Start over</button></div>';
    track('resume_shown', {});
    document.getElementById('lp-cont').onclick = function () {
      track('resume_accepted', {});
      api('/api/session').then(function (r) {
        var p = r.preview || {};
        S.preview = { state: p.state, url: p.image_url || null, anim: p.anim_url || null, anim_state: p.anim_state, poster: p.poster_url || null, poster_state: p.poster_state, regen_left: p.regen_left, can_regen: p.can_regen, error: p.error, startedAt: Date.now() };
        S.adventure = r.session.adventure || S.adventure;
        if (!adventure()) { S.adventure = null; return go('adventure'); } // fermée depuis : l'étape 2, jamais l'ancien écran (01/11)
        var target = S.step;
        var needsPhoto = p.state !== 'done' && r.session.photo !== 'kept' && p.state !== 'queued' && p.state !== 'running';
        if (needsPhoto && ['details', 'loves', 'message', 'endmsg', 'premiere', 'next', 'preview', 'offer'].indexOf(target) >= 0) target = 'photo';
        if (p.state === 'queued' || p.state === 'running' || p.anim_state === 'queued' || p.anim_state === 'running' || p.poster_state === 'queued' || p.poster_state === 'running') startPolling();
        go(target || 'hero');
      }).catch(function () { clearSaved(); boot(true); });
    };
    document.getElementById('lp-restart').onclick = function () { clearSaved(); boot(true); };
  }

  // Revenu du checkout : reprise, sauf s'il a payé (session « ordered ») : alors un nouveau film.
  function afterCheckout(saved) {
    S = saved;
    api('/api/session').then(function (r) {
      if (r.session && r.session.status === 'ordered') { clearSaved(); return newSession(); }
      renderResume(saved);
    }).catch(function () { renderResume(saved); });
  }

  // Reprise depuis un email de relance : le Worker a posé un code à usage unique (2 min) dans le fragment #h=.
  function handoff(code) {
    return api('/api/handoff', { method: 'POST', json: { code: code } }).then(function (cred) {
      S = { v: 1, sid: cred.sid, secret: cred.secret, hero: {}, details: {}, createdAt: Date.now(), step: 'preview' };
      return api('/api/session');
    }).then(function (r) {
      var se = r.session;
      var p = r.preview || {};
      S.adventure = se.adventure;
      S.arm = se.arm;
      S.angle = se.angle || '';
      S.relationship = se.relationship || '';
      S.hero = { name: se.hero.name, age: se.hero.age };
      S.leadDone = true;
      S.details = {
        from: se.details.from || '', message: se.details.message || '', accent: se.details.accent || guessAccent(),
        premiere_mode: se.details.premiere_mode || 'asap', premiere_at: se.details.premiere_at || null, premiere_label: se.details.premiere_label || ''
      };
      S.preview = { state: p.state, url: p.image_url || null, anim: p.anim_url || null, anim_state: p.anim_state, poster: p.poster_url || null, poster_state: p.poster_state, regen_left: p.regen_left, can_regen: p.can_regen, error: p.error, startedAt: Date.now() };
      save();
      if (!adventure()) { S.adventure = null; return go('adventure'); } // fermée depuis : l'étape 2 (01/11)
      if (p.anim_state === 'queued' || p.anim_state === 'running' || p.poster_state === 'queued' || p.poster_state === 'running') startPolling();
      go(p.state === 'done' ? 'preview' : 'photo');
    });
  }

  function boot(fresh) {
    var saved = fresh ? null : load();
    var hm = /[#&]h=([\w-]+)/.exec(location.hash || '');
    if (hm) { try { history.replaceState(null, '', location.pathname + location.search); } catch (e) { /* rien */ } }
    clarityStart();
    var p = API ? fetch(API + '/api/catalog').then(function (r) { if (!r.ok) throw new Error('catalog'); return r.json(); }) : Promise.reject(new Error('no_api'));
    // Prix lus en direct sur la boutique (/products/<handle>.js) : une variante créée ou un prix changé s'affiche sans
    // republier le thème. Si la lecture échoue, les variantes rendues par Liquid servent.
    var prod = CFG.product_handle ? fetch(ROOT + 'products/' + encodeURIComponent(CFG.product_handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }) : Promise.resolve(null);
    Promise.all([p, prod]).then(function (res) {
      var cat = res[0];
      var live = res[1];
      if (live && live.variants && live.variants.length) {
        CFG.variants = live.variants.map(function (v) { return { id: v.id, sku: v.sku, price: v.price, title: v.title, available: v.available, compare_at_price: v.compare_at_price }; });
      }
      CAT = cat;
      applyCheckoutPrices();
      loadAddons();
      if (!CAT.adventures || !CAT.adventures.length) return showError('New movies open soon. Please come back in a little while.');
      if (DEMO) { var ls = params.get('lp_step'); return demoGo(DEMO_NAV.some(function (x) { return x[0] === ls; }) ? ls : 'hero'); }
      if (hm) return handoff(hm[1]).catch(function () { return newSession(); });
      // Reprise (Paul, 23/10 ~17 h : « s'il arrive au checkout et repart sur le site, il reprend facilement ») : avant, un
      // clic vers le checkout ou une pub d'une autre aventure (?adv=) faisait tout recommencer, photo comprise.
      var usable = saved && saved.sid && saved.secret && Date.now() - (saved.createdAt || 0) < RESUME_MS;
      var sibParam = params.get('sib') || '';
      if (usable && saved.step && saved.step !== 'hero' && saved.step !== 'pick' && (!sibParam || sibParam === saved.sib)) return saved.checkoutAt ? afterCheckout(saved) : renderResume(saved);
      return newSession();
    }).catch(function (e) { showError(friendly(e)); });
  }

  // Éditeur : un réglage modifié re-rend la section (nouveau « Loading… », sans relancer ce fichier). On remet l'app vivante à
  // sa place, on relit la config et on redessine l'écran en cours avec les nouveaux textes.
  if (DESIGN) {
    document.addEventListener('shopify:section:load', function (e) {
      var fresh = e.target.querySelector('#lp-root'), conf = e.target.querySelector('#lp-config');
      if (!fresh || fresh === rootEl || !conf) return;
      try { var c = JSON.parse(conf.textContent || '{}'); for (var k in c) CFG[k] = c[k]; } catch (er) { return; }
      fresh.parentNode.replaceChild(rootEl, fresh);
      FACTS = readFacts();
      if (S && S.step) render();
      edLink();
      edShow(edFact);
    });
    document.addEventListener('shopify:block:select', function (e) { edShow(e.detail && e.detail.blockId); });
    document.addEventListener('shopify:block:deselect', function () { edShow(''); });
  }

  boot(false);
})();
